import {i as Or, G as cn, c as hn, s as W, J as dn, a as Jn, r as to, b as eo, k as io, p as un, d as T, B as Vs, e as so, y as ro, f as no, g as oo, n as u, x as p, m as zs, h as ao, j as lo, q as co, l as lt, u as Ee, o as ho, t as zi, v as uo, M as Ts, W as pn, w as k, z as b, A as Et, C as Fi, D as po, E as tt, F as C, H as fo, I as mo, K as go, L as vo, N as yo, O as bo, P as wo, Q as $o, R as So, S as Dt, T as Co, U as xo, V as _o, X as Oo, Y as fn, Z as Po, _ as Fs, $ as Io, a0 as Ao, a1 as ms, a2 as Mo, a3 as To} from "./vendor.js";
function z(e) {
    throw new Error(e)
}
function mn(e) {
    return typeof e == "function" ? e() : e
}
function Ws(e, t, i) {
    const s = mn(e);
    s instanceof Promise ? s.then(r => {
        t.aborted || i(r)
    }
    ) : i(s)
}
function Z(e) {
    return Array.isArray(e) ? e : [e]
}
function Wi(e, t) {
    return Array.from(t).some(i => e.has(i))
}
function ct(e) {
    return e instanceof HTMLElement || e instanceof SVGElement
}
function Bt(e, t, i) {
    const s = Z(e);
    if (s.length === 0)
        return () => {}
        ;
    const r = new IntersectionObserver( (n, o) => {
        n.some(a => a.isIntersecting) && (t(),
        o.disconnect())
    }
    ,i);
    return s.forEach(n => r.observe(n)),
    () => {
        r.disconnect()
    }
}
function ht(e, t="all") {
    if (Array.isArray(e) || e instanceof NodeList) {
        e.forEach(s => ht(s, t));
        return
    }
    if (!ct(e))
        return;
    const i = Z(t);
    if (i.includes("all")) {
        e.style.cssText = "";
        return
    }
    i.forEach(s => {
        String(s).startsWith("--") ? e.style.removeProperty(String(s)) : e.style[s] = ""
    }
    )
}
function dt(e) {
    const t = document.createElement("template");
    return t.innerHTML = e,
    t.content
}
function gn(e) {
    const t = dt(e).firstElementChild;
    if (!t)
        throw new Error("No element found in template");
    return t
}
function ot(e, t) {
    const i = e.querySelector(t);
    if (!i)
        throw new Error(`Required element not found with selector: ${t}`);
    return i
}
function Yi() {
    return document.documentElement.getAttribute("dir") === "rtl" ? "rtl" : "ltr"
}
function Ke(e, t, i) {
    (i ?? Array.from(t.attributes).map(r => r.name)).forEach(r => {
        t.hasAttribute(r) ? e.setAttribute(r, t.getAttribute(r) ?? "") : e.removeAttribute(r)
    }
    )
}
async function Eo(e) {
    try {
        await navigator.clipboard.writeText(e)
    } catch {
        const t = document.createElement("textarea");
        t.value = e,
        document.body.appendChild(t),
        t.select(),
        document.execCommand("copy"),
        document.body.removeChild(t)
    }
}
function Pr(e, t=!1) {
    return t && ct(e) && Or(e) ? e : document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
        acceptNode: s => ct(s) && Or(s) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
    }).nextNode()
}
function w(e, t) {
    if (Array.isArray(e) || e instanceof NodeList) {
        e.forEach(i => w(i, t));
        return
    }
    ct(e) && (typeof t == "function" && (t = t(e)),
    Object.entries(t).forEach( ([i,s]) => {
        s !== void 0 && (i.startsWith("--") ? e.style.setProperty(i, s) : e.style[i] = s)
    }
    ))
}
class Do extends cn {
    constructor(t) {
        super(t)
    }
    complete() {
        return super.complete(),
        this
    }
}
function Ir(e) {
    return new Do(e)
}
function Lo(e) {
    e.getAnimations().forEach(t => t.cancel())
}
const Ys = new Map;
function H(e, t) {
    Ys.set(e, t)
}
function at(e, t, i) {
    return Xe(e)(t, i)
}
function Xe(e) {
    const t = Ys.get(e);
    if (!t)
        throw new Error(`Animation preset "${e}" not found. Make sure it's registered with defineAnimationPreset.`);
    return t
}
function Ci(e) {
    return Ys.has(e)
}
function ko(e) {
    hn(e).forEach( (i, s) => {
        if (!(s instanceof Element))
            return;
        const r = {}
          , n = i?.keyframes || {};
        for (const a in n) {
            const c = n[a];
            if (Array.isArray(c)) {
                for (const h of c)
                    if (h != null) {
                        r[a] = h;
                        break
                    }
            }
        }
        const o = {};
        for (const [a,c] of Object.entries(r))
            o[a] = String(c);
        w(s, o)
    }
    )
}
function ve(e) {
    return hn(e).forEach( (i, s) => {
        if (!(s instanceof Element))
            return;
        const r = {}
          , n = i?.keyframes || {};
        for (const a in n) {
            const c = n[a];
            if (!Array.isArray(c))
                continue;
            let h;
            for (let f = c.length - 1; f >= 0; f--) {
                const v = c[f];
                if (v != null) {
                    h = v;
                    break
                }
            }
            h !== void 0 && (r[a] = h)
        }
        const o = {};
        for (const [a,c] of Object.entries(r))
            o[a] = String(c);
        w(s, o)
    }
    ),
    Promise.resolve()
}
H("fade-up", (e, t) => [[e, {
    transform: ["translateY(min(2rem, 90%))", "none"],
    opacity: [0, 1]
}, {
    duration: 1,
    ease: "power4.out",
    delay: W(.05),
    ...t
}]]),
H("default", Xe("fade-up")),
H("fade-up-large", (e, t) => [[e, {
    transform: ["translateY(90%)", "none"],
    opacity: [0, 1]
}, {
    duration: 1,
    ease: "power4.out",
    delay: W(.05),
    ...t
}]]),
H("zoom-in", (e, t) => [[e, {
    transform: ["scale(0.8)", "scale(1)"],
    opacity: [0, 1]
}, {
    duration: 1,
    ease: "power4.out",
    delay: W(.1),
    ...t
}]]),
H("zoom-in-subtle", (e, t) => [[e, {
    transform: ["scale(0.95)", "scale(1)"],
    opacity: [0, 1]
}, {
    duration: 1,
    ease: "power3.out",
    ...t
}]]),
H("zoom-out", (e, t) => [[e, {
    transform: ["scale(1.2)", "scale(1)"]
}, {
    duration: 1.5,
    ease: "power4.out",
    ...t
}]]),
H("popover-scale-in", (e, t) => [[e, {
    opacity: 1,
    scale: 1
}, {
    duration: .6,
    ease: "power3.out",
    ...t
}]]),
H("popover-scale-out", (e, t) => [[e, {
    opacity: 0,
    scale: 0
}, {
    duration: .25,
    ease: "power1.in",
    ...t
}]]);
function vn(e) {
    return window.matchMedia(`(min-width: ${e}px)`).matches
}
function Ro(e) {
    return !vn(e)
}
function gs() {
    return "ontouchstart"in window || navigator.maxTouchPoints > 0
}
const qo = window.matchMedia("(hover: hover) and (pointer: fine)");
function Ki() {
    return qo.matches
}
const Bo = window.matchMedia("(prefers-reduced-motion: reduce)");
function ui() {
    return Bo.matches
}
function Ks() {
    return "GestureEvent"in window
}
function yn(e) {
    return window.contentLoaded ? (e?.(),
    Promise.resolve()) : new Promise(t => {
        window.addEventListener("DOMContentLoaded", () => {
            e?.(),
            t()
        }
        )
    }
    )
}
function Xi(e) {
    return window.loadFired ? (e?.(),
    Promise.resolve()) : new Promise(t => {
        window.addEventListener("load", () => {
            e?.(),
            t()
        }
        )
    }
    )
}
function Ft(e) {
    return Promise.all(Z(e).map(t => customElements.get(t) ? Promise.resolve(customElements.get(t)) : customElements.whenDefined(t)))
}
let vs = !1
  , ys = null;
function Uo(e) {
    return vs ? (e?.(),
    Promise.resolve()) : (ys || (ys = new Promise(t => {
        const i = new AbortController
          , {signal: s} = i
          , r = o => {
            !o.isTrusted || vs || (vs = !0,
            i.abort(),
            t())
        }
          , n = (o, a, c) => {
            o.addEventListener(a, r, {
                once: !0,
                passive: !0,
                signal: s,
                ...c
            })
        }
        ;
        n(window, "pointerdown"),
        n(window, "mousedown"),
        n(window, "mousemove"),
        n(window, "touchstart"),
        n(window, "keydown"),
        n(window, "wheel")
    }
    )),
    ys.then( () => {
        e?.()
    }
    ))
}
async function xi(e) {
    if (Array.isArray(e)) {
        await Promise.all(e.map(t => xi(t)));
        return
    }
    if (e instanceof HTMLImageElement)
        return e.src && e.complete ? void 0 : new Promise(t => {
            const i = () => {
                e.removeEventListener("load", i),
                e.removeEventListener("error", i),
                t()
            }
            ;
            e.addEventListener("load", i),
            e.addEventListener("error", i)
        }
        )
}
async function bn(e) {
    if (Array.isArray(e)) {
        await Promise.all(e.map(t => bn(t)));
        return
    }
    return new Promise(t => {
        const i = new Image;
        typeof e == "string" ? i.src = e : (i.src = e.src,
        i.srcset = e.srcset,
        i.sizes = e.sizes),
        i.onload = () => t(),
        i.onerror = () => t()
    }
    )
}
function Ho(e) {
    return typeof e.getAnimationTargets == "function"
}
async function No(e, t={}) {
    const {deep: i=!0, waitForContentLoaded: s=!0, waitForImages: r=!0, waitForSplitText: n=!0} = t
      , o = a => i ? a : a.filter(c => {
        const h = c.closest("animation-element");
        return h === null || h === e
    }
    );
    if (s && await yn(),
    r) {
        await Ft("image-loader");
        const a = o([...e.getElementsByTagName("img")]);
        await xi(a)
    }
    if (n) {
        await Ft("split-text");
        const a = o([...e.getElementsByTagName("split-text")]);
        await Promise.all(a.map(c => c.ready))
    }
}
async function wn(e) {
    const t = await jo(e);
    return Promise.all(t.map(i => i.play()))
}
async function jo(e) {
    return await Ft("animation-element"),
    [...e.getElementsByTagName("animation-element")]
}
function $n(e, t) {
    return [...e.querySelectorAll(t)].flatMap(i => Ho(i) ? i.getAnimationTargets() : ct(i) ? [i] : [])
}
function Vo(e) {
    const t = Z(e).flatMap(s => typeof s == "string" ? [...document.querySelectorAll(s)] : s instanceof Element ? [s] : [])
      , i = s => t.flatMap(r => $n(r, s));
    return i.when = (s, r) => {
        const n = i(s);
        n.length > 0 && r(n)
    }
    ,
    i
}
H("cards-in", (e, t) => {
    const i = Array.isArray(e) ? e.length : 1;
    return Sn(e) ? [[e, {
        transform: ["translateY(1rem)", "none"],
        opacity: [0, 1]
    }, {
        duration: 1,
        ease: "power4.out",
        delay: W(Math.min(.1, .5 / i)),
        ...t
    }]] : [[e, {
        transform: ["scale(0.9)", "scale(1)"],
        opacity: [0, 1]
    }, {
        duration: 1,
        ease: "power4.out",
        delay: W(Math.min(.1, .5 / i)),
        ...t
    }]]
}
),
H("cards-out", (e, t) => {
    const i = Array.isArray(e) ? e.length : 1;
    return Sn(e) ? [[e, {
        transform: "translateY(1rem)",
        opacity: 0
    }, {
        duration: .3,
        delay: W(Math.min(.05, .2 / i)),
        ease: "ease",
        ...t
    }]] : [[e, {
        transform: "translateY(8px) scale(0.95)",
        opacity: 0
    }, {
        duration: .3,
        delay: W(Math.min(.05, .2 / i)),
        ease: "ease",
        ...t
    }]]
}
),
H("product-cards-in", Xe("cards-in")),
H("product-cards-out", Xe("cards-out")),
H("collection-banner", e => {
    const t = Vo(e)
      , i = []
      , s = Xe("fade-up");
    return t.when(".breadcrumbs", r => {
        i.push(...s(r, {
            at: "<+0.15"
        }))
    }
    ),
    t.when(".collection-banner-title", r => {
        i.push(...s(r, {
            at: "<+0.15"
        }))
    }
    ),
    t.when(".collection-banner-description", r => {
        i.push(...s(r, {
            at: "<+0.15"
        }))
    }
    ),
    i
}
);
function Sn(e) {
    var t;
    return Array.isArray(e) && ((t = e[0]) == null ? void 0 : t.closest("[data-collection-view-mode=list]"))
}
H("slideshow-zoom-out", (e, t) => {
    const i = [];
    if (Array.isArray(e)) {
        const [s,r] = e;
        s && i.push([s, {
            opacity: [0, 1],
            scale: [1.2, 1]
        }, {
            duration: 1,
            ease: "power4.out",
            ...t
        }]),
        r && i.push([r, {
            opacity: 1
        }, {
            duration: 0
        }])
    }
    return i
}
),
H("slideshow-fade", (e, t) => {
    const i = [];
    if (Array.isArray(e)) {
        const [s,r] = e;
        r && i.push([r, {
            opacity: [1, 0]
        }, {
            duration: .2,
            ...t
        }]),
        s && i.push([s, {
            opacity: [0, 1]
        }, {
            duration: .2,
            ...t
        }])
    }
    return i
}
);
function m(e, t, i, s={}) {
    const r = new CustomEvent(t,{
        composed: !0,
        detail: i,
        ...s
    });
    e.dispatchEvent(r)
}
class zo extends dn {
    constructor(t, i) {
        super({
            keyframes: [0],
            duration: i * 1e3
        }),
        this.callback = t
    }
    notifyFinished() {
        this.callback(),
        super.notifyFinished()
    }
}
function E(e, t, i) {
    const s = eo(e, t, i);
    return new Cn([s],[[e, t, i ?? {}]])
}
function A(e, t) {
    const {animations: i} = Jn(e, t);
    return new Cn(i,e)
}
class Cn extends cn {
    constructor(t, i) {
        super(t),
        this.stop = () => {
            try {
                this._runAll("stop")
            } catch (s) {
                if (s?.name !== "InvalidStateError")
                    throw s
            }
        }
        ,
        this.setupClearProps(i)
    }
    _runAll(t) {
        this.animations.forEach(i => i[t]())
    }
    complete() {
        const t = this.animations[0];
        return t && t.state !== "finished" && super.complete(),
        this
    }
    tap(t) {
        return t(this),
        this
    }
    delayedCall(t, i) {
        return this.animations.push(new zo(t,i)),
        this
    }
    setupClearProps(t) {
        const i = [];
        for (const s of t) {
            if (!Array.isArray(s))
                continue;
            const [r,,n] = s;
            if (!n)
                continue;
            const {clearProps: o} = n;
            if (o && (typeof r == "string" || r instanceof Element || Array.isArray(r) || r instanceof NodeList)) {
                const a = to(r);
                i.push([a, o])
            }
        }
        i.length > 0 && this.then( () => {
            for (const [s,r] of i)
                ht(s, r)
        }
        )
    }
}
function _i(e) {
    let t = new AbortController;
    function i(...s) {
        return t.abort(),
        t = new AbortController,
        e(t.signal, ...s)
    }
    return i.abort = () => {
        t.abort(),
        t = new AbortController
    }
    ,
    i
}
class Xs {
    constructor(t) {
        this.options = t,
        this.isPlaying = !1,
        this.hasPlayed = !1,
        this.prepare = _i(async r => {
            if (!this._resolvePrepared) {
                const {promise: n, resolve: o} = Promise.withResolvers();
                this.prepared = n,
                this._resolvePrepared = o
            }
            if (this.targets.length === 0) {
                this.setReady();
                return
            }
            if (!this.isValidAnimationName(this.options.animation)) {
                console.warn(`Animation "${this.options.animation}" not found`),
                this.setReady();
                return
            }
            if (ui()) {
                this.setReady();
                return
            }
            this.options.autoplay && this.createObserver();
            try {
                await Ft(["image-loader", "split-text"]);
                const n = [...this.options.root.querySelectorAll("split-text")];
                if (n.length > 0 && await Promise.all(n.map(o => o.ready)),
                r.aborted)
                    return;
                ko(this.buildSequence(!1))
            } catch (n) {
                console.error(n)
            }
            this.options.root.addEventListener("split-text:split", this.handleSplitText),
            this.setReady()
        }
        ),
        this.handleSplitText = () => {
            !this.hasPlayed && !this.isPlaying && this.prepare()
        }
        ,
        this.play = _i(async (r, n=!1) => {
            var o, a;
            if (this.targets.length !== 0 && this.isValidAnimationName(this.options.animation) && ((o = this.stopObserver) == null || o.call(this),
            await this.prepared,
            !r.aborted)) {
                if (ui()) {
                    this.hasPlayed = !0,
                    m(this.options.root, "animation:finished", void 0, {
                        bubbles: !0
                    });
                    return
                }
                return this.isPlaying = !0,
                (a = this.timeline) == null || a.cancel(),
                this.options.root.getAnimations({
                    subtree: !0
                }),
                this.timeline = A(this.buildSequence(n)),
                this.timeline.then( () => {
                    if (this.isPlaying = !1,
                    m(this.options.root, "animation:finished", void 0, {
                        bubbles: !0
                    }),
                    this.options.clearProps !== void 0) {
                        let c = "all";
                        this.options.clearProps !== "" && this.options.clearProps !== "all" && (c = this.options.clearProps.split(","));
                        const h = this.targets.filter(f => !xe(f));
                        ht(h, c)
                    }
                }
                ),
                this.hasPlayed = !0,
                this.timeline
            }
        }
        );
        const {promise: i, resolve: s} = Promise.withResolvers();
        this.prepared = i,
        this._resolvePrepared = s
    }
    get targets() {
        return this.options.selector ? $n(this.options.root, this.options.selector) : [this.options.root]
    }
    getAnimationSequence(t) {
        const i = this.targets;
        if (i.length === 0)
            return [];
        if (!this.isValidAnimationName(this.options.animation))
            return [];
        if (ui())
            return [];
        const s = {};
        if (this.options.stagger !== void 0) {
            const r = this.options.delay ?? 0;
            s.delay = W(this.options.stagger, {
                startDelay: r
            })
        } else
            this.options.delay !== void 0 && (s.delay = this.options.delay);
        return Object.assign(s, t),
        at(this.options.animation, i, s)
    }
    buildSequence(t) {
        const i = this.targets;
        if (!i.some(xe)) {
            const a = {};
            if (this.options.stagger !== void 0) {
                const c = this.getEffectiveDelay(t) ?? 0;
                a.delay = W(this.options.stagger, {
                    startDelay: c
                })
            } else {
                const c = this.getEffectiveDelay(t);
                c !== void 0 && (a.delay = c)
            }
            return at(this.options.animation, i, a)
        }
        const r = this.getEffectiveDelay(t) ?? 0
          , n = this.options.stagger ?? 0
          , o = [];
        if (n === 0) {
            const a = i.filter(c => !xe(c));
            a.length > 0 && o.push(...at(this.options.animation, a, {
                at: r
            })),
            i.forEach(c => {
                const h = xe(c);
                h && o.push(...h.getAnimationSequence({
                    at: r
                }))
            }
            )
        } else
            i.forEach( (a, c) => {
                const h = r + c * n
                  , f = xe(a);
                f ? o.push(...f.getAnimationSequence({
                    at: h
                })) : o.push(...at(this.options.animation, [a], {
                    at: h
                }))
            }
            );
        return o
    }
    setReady() {
        var t;
        this.options.root.setAttribute("ready", ""),
        (t = this._resolvePrepared) == null || t.call(this),
        this._resolvePrepared = void 0
    }
    disconnect() {
        var t, i;
        (t = this.stopObserver) == null || t.call(this),
        this.options.root.removeEventListener("split-text:split", this.handleSplitText),
        (i = this.timeline) == null || i.cancel(),
        this.timeline = void 0
    }
    stop() {
        var t;
        (t = this.timeline) == null || t.stop()
    }
    createObserver() {
        var s;
        (s = this.stopObserver) == null || s.call(this);
        const t = {};
        this.options.autoplayRootMargin !== void 0 && (t.rootMargin = this.options.autoplayRootMargin),
        this.options.autoplayThreshold !== void 0 && (t.threshold = this.options.autoplayThreshold);
        const i = async () => {
            await No(this.options.root, {
                deep: !1,
                waitForImages: this.options.waitForImages ?? !1
            }),
            this.play(!0)
        }
        ;
        this.stopObserver = Bt(this.targets, i, t)
    }
    isValidAnimationName(t) {
        return Ci(t)
    }
    getEffectiveDelay(t) {
        return t && this.options.autoplayDelay !== void 0 ? this.options.autoplayDelay : this.options.delay
    }
}
function xe(e) {
    if (e.tagName.toLowerCase() === "animation-element" && typeof e.getAnimationSequence == "function")
        return e;
    const t = e.querySelector(":scope > animation-element");
    return t && typeof t.getAnimationSequence == "function" ? t : null
}
function g(e={
    type: String
}) {
    return function(t, i) {
        const s = io(i);
        Object.defineProperty(t, i, {
            get() {
                if (!this.hasAttribute(s))
                    return e.optional ? void 0 : e.default !== void 0 ? e.default : e.type === Boolean ? !1 : e.type === Number ? 0 : "";
                const n = this.getAttribute(s);
                return e.type === Boolean ? n !== null : e.type === Number ? n !== null ? Number(n) : 0 : n ?? ""
            },
            set(n) {
                e.type === Boolean ? this.toggleAttribute(s, n) : e.type === Number ? n !== null && !isNaN(n) ? this.setAttribute(s, n.toString()) : this.removeAttribute(s) : n !== null ? this.setAttribute(s, n) : this.removeAttribute(s)
            },
            enumerable: !0,
            configurable: !0
        });
        const r = t.constructor;
        r.observedAttributes || (r.observedAttributes = []),
        r.observedAttributes.push(s)
    }
}
const pi = new WeakMap;
function l(e, t=null, i={}) {
    return function(s, r) {
        const n = s.constructor;
        pi.has(n) || pi.set(n, []),
        pi.get(n).push({
            event: e,
            propertyKey: r,
            eventTarget: t,
            options: i
        })
    }
}
function Fo(e) {
    const t = [];
    let i = e;
    for (; i !== null && i !== Object && i !== Function.prototype; ) {
        const s = pi.get(i);
        if (s)
            for (const r of s)
                t.push(r);
        i = Object.getPrototypeOf(i)
    }
    return t
}
function Wo(e, t) {
    return t === null ? e : typeof t == "function" ? t(e) : t === "section" ? e.closest(".shopify-section") : t
}
function d(e, t) {
    return function(i) {
        const s = Fo(i)
          , r = s.filter(h => h.eventTarget === null)
          , n = s.filter(h => h.eventTarget !== null)
          , o = n.filter(h => h.options.attachTiming === "before")
          , a = n.filter(h => h.options.attachTiming !== "before")
          , c = class extends i {
            constructor(...h) {
                super(...h),
                this._eventControllers = new Map;
                for (const f of r)
                    this._attachSelfEventListener(f)
            }
            connectedCallback() {
                var h;
                for (const f of o)
                    this._attachExternalEventListener(f);
                (h = super.connectedCallback) == null || h.call(this);
                for (const f of a)
                    this._attachExternalEventListener(f)
            }
            disconnectedCallback() {
                var h;
                (h = super.disconnectedCallback) == null || h.call(this),
                this._detachExternalEventListeners()
            }
            _attachSelfEventListener(h) {
                if (Array.isArray(h.event)) {
                    h.event.forEach(_ => {
                        this._attachSelfEventListener({
                            ...h,
                            event: _
                        })
                    }
                    );
                    return
                }
                const {event: f, propertyKey: v} = h
                  , $ = this[v]
                  , S = typeof $ == "function" ? $.bind(this) : void 0;
                S && this.addEventListener(f, S)
            }
            _attachExternalEventListener(h) {
                var ai;
                if (Array.isArray(h.event)) {
                    h.event.forEach(V => {
                        this._attachExternalEventListener({
                            ...h,
                            event: V
                        })
                    }
                    );
                    return
                }
                const {event: f, propertyKey: v, eventTarget: $, options: S} = h
                  , {optional: _=!1} = S
                  , O = un(S, ["capture", "once", "passive"])
                  , P = this[v]
                  , M = typeof P == "function" ? P.bind(this) : void 0;
                if (!M)
                    return;
                const D = `${v}:${f}`;
                this._eventControllers.has(D) && ((ai = this._eventControllers.get(D)) == null || ai.abort());
                const R = new AbortController;
                this._eventControllers.set(D, R);
                const rt = Wo(this, $)
                  , yt = V => {
                    if (!R.signal.aborted) {
                        if (!V) {
                            _ || console.warn(`[${i.name}] Event target not found for listener ${v} on event ${f}`);
                            return
                        }
                        V.addEventListener(f, M, {
                            ...O,
                            signal: R.signal
                        })
                    }
                }
                ;
                rt instanceof Promise ? rt.then(V => Z(V).forEach(yt)) : Z(rt).forEach(yt)
            }
            _detachExternalEventListeners() {
                for (const h of this._eventControllers.values())
                    h.abort();
                this._eventControllers.clear()
            }
        }
        ;
        queueMicrotask( () => {
            t ? customElements.define(e, c, t) : customElements.define(e, c)
        }
        )
    }
}
var Yo = Object.defineProperty
  , Ko = Object.getOwnPropertyDescriptor
  , et = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Ko(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Yo(t, i, r),
    r
}
;
let G = class extends HTMLElement {
    constructor() {
        super(),
        this._managed = !1,
        this._instance = new Xs(this.getAnimationConfig())
    }
    connectedCallback() {
        var e;
        this._managed = !!((e = this.parentElement) != null && e.closest("animation-element")),
        this._managed || this.prepare()
    }
    disconnectedCallback() {
        this.disconnect()
    }
    getAnimationConfig() {
        return {
            root: this,
            selector: this.selector,
            animation: this.animation,
            delay: typeof this.delay == "number" ? this.delay / 1e3 : void 0,
            autoplayDelay: typeof this.autoplayDelay == "number" ? this.autoplayDelay / 1e3 : void 0,
            stagger: typeof this.stagger == "number" ? this.stagger / 1e3 : void 0,
            autoplay: this.autoplay,
            waitForImages: this.waitForImages,
            clearProps: this.clearProps,
            autoplayRootMargin: this.autoplayRootMargin,
            autoplayThreshold: this.autoplayThreshold
        }
    }
    prepare() {
        if (!this._managed)
            return this._instance.prepare()
    }
    disconnect() {
        return this._instance.disconnect()
    }
    play() {
        if (!this._managed)
            return this._instance.play()
    }
    getAnimationSequence(e) {
        return this._instance.getAnimationSequence(e)
    }
    beforeMorphDOM(e) {
        return this.hasAttribute("ready") && e.setAttribute("ready", ""),
        !0
    }
}
;
et([g({
    type: String
})], G.prototype, "selector", 2),
et([g({
    type: String,
    default: "fade-up"
})], G.prototype, "animation", 2),
et([g({
    type: Number,
    optional: !0
})], G.prototype, "delay", 2),
et([g({
    type: Number,
    optional: !0
})], G.prototype, "autoplayDelay", 2),
et([g({
    type: String,
    optional: !0
})], G.prototype, "autoplayRootMargin", 2),
et([g({
    type: Number,
    optional: !0
})], G.prototype, "autoplayThreshold", 2),
et([g({
    type: Number,
    optional: !0
})], G.prototype, "stagger", 2),
et([g({
    type: Boolean
})], G.prototype, "autoplay", 2),
et([g({
    type: Boolean
})], G.prototype, "waitForImages", 2),
et([g({
    type: String,
    optional: !0
})], G.prototype, "clearProps", 2),
G = et([d("animation-element")], G);
function Gi() {
    let e = new AbortController;
    function t() {
        return e.abort(),
        e = new AbortController,
        e.signal
    }
    return {
        abort: t,
        get signal() {
            return e.signal
        }
    }
}
function xn(e) {
    return class extends e {
        constructor() {
            super(...arguments),
            this.disconnectController = Gi()
        }
        get disconnected() {
            return this.disconnectController.signal
        }
        get $section() {
            return this.closest(".shopify-section") ?? z("Element is not inside of a Shopify section")
        }
        disconnectedCallback() {
            this.disconnectController.abort(),
            super.disconnectedCallback()
        }
        willUpdate(t) {
            super.willUpdate(t),
            this.forwardChanges(t, "WillUpdate")
        }
        updated(t) {
            super.updated(t),
            this.forwardChanges(t, "Updated")
        }
        firstUpdated(t) {}
        slotted(t, i) {
            const s = this.renderRoot.querySelector(t ? `slot[name="${t}"]` : "slot:not([name])");
            return s instanceof HTMLSlotElement ? s.assignedElements(i).filter(r => r instanceof Element) : []
        }
        getAllSlotted(t) {
            return [...this.renderRoot.querySelectorAll("slot")].flatMap(i => i.assignedElements(t).filter(s => s instanceof Element))
        }
        slottedHTMLElements(t, i) {
            return this.slotted(t, i).filter(s => s instanceof HTMLElement)
        }
        forwardChanges(t, i) {
            t.forEach( (s, r) => {
                const n = `${oo(r.toString())}${i}`;
                typeof this[n] == "function" && this[n](s, t)
            }
            )
        }
        updateCompleteAndConnected(t) {
            const i = this.disconnected;
            this.updateComplete.then( () => {
                i.aborted || t()
            }
            )
        }
    }
}
class N extends T(ro, xn) {
    createRenderRoot() {
        return this
    }
}
class x extends T(no, xn) {
    constructor(t) {
        super(),
        this.shadowDOM = !1,
        t !== void 0 && (this.shadowDOM = t)
    }
    get portalRoot() {
        return this._portalRoot || (this._portalRoot = document.createElement("div"),
        this._portalRoot.classList.add("lit-portal"),
        document.body.appendChild(this._portalRoot)),
        this._portalRoot
    }
    connectedCallback() {
        super.connectedCallback(),
        this._portalRoot && document.body.appendChild(this._portalRoot)
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(),
        (t = this._portalRoot) == null || t.remove()
    }
    renderPortal(t) {
        Vs(t, this.portalRoot, {
            host: this
        })
    }
    createRenderRoot() {
        return this.shadowDOM ? super.createRenderRoot() : this
    }
    static get themeCSS() {
        return Xo ?? (Xo = Go())
    }
    beforeMorphDOM(t, i) {
        return this.shadowDOM ? !0 : (this.replaceWith(t),
        !1)
    }
}
let Xo = null;
function Go() {
    return so(Qo().map(e => Zo(e)).join(`
`))
}
function Qo() {
    return Array.from(document.styleSheets).filter( ({ownerNode: e}) => e instanceof HTMLLinkElement && e.hasAttribute("data-theme-css") && !e.disabled)
}
function Zo(e) {
    return Array.from(e.cssRules).map(t => t.cssText).join(" ")
}
var Jo = Object.defineProperty
  , ta = Object.getOwnPropertyDescriptor
  , vt = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? ta(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Jo(t, i, r),
    r
}
;
let J = class extends x {
    constructor() {
        super(...arguments),
        this.active = !1,
        this.hideDelay = 200,
        this.showDelay = 0,
        this.duration = 500,
        this.zIndex = 0,
        this.name = "",
        this.portal = !1,
        this.activators = new Set
    }
    get $backdrop() {
        return (this.portal ? this.portalRoot : this.renderRoot).querySelector(".backdrop")
    }
    handleBackdropShow(e) {
        const {name: t, activator: i} = e.detail;
        this.name && t === this.name && (this.activators.add(i),
        this.active = !0)
    }
    handleBackdropHide(e) {
        const {activator: t} = e.detail;
        this.activators.delete(t),
        this.activators.size === 0 && (this.active = !1)
    }
    activeUpdated(e) {
        const t = [[this.$backdrop, {
            opacity: this.active ? 1 : 0,
            visibility: this.active ? "visible" : "hidden",
            pointerEvents: this.active ? "auto" : "none"
        }, {
            delay: (this.active ? this.showDelay : this.hideDelay) / 1e3,
            duration: this.duration / 1e3
        }]];
        if (e == null) {
            ve(t);
            return
        }
        A(t),
        this.active || this.activators.clear()
    }
    render() {
        const e = p`
      <div
        class="backdrop"
        style=${this.zIndex !== 0 ? `--backdrop-z-index: ${this.zIndex}` : ""}
        @click=${ () => this.dispatchEvent(new CustomEvent("click",{
            bubbles: !0
        }))}
      ></div>
    `;
        if (this.portal)
            this.renderPortal(e);
        else
            return e
    }
}
;
vt([u({
    type: Boolean,
    reflect: !0
})], J.prototype, "active", 2),
vt([u({
    type: Number,
    attribute: "hide-delay"
})], J.prototype, "hideDelay", 2),
vt([u({
    type: Number,
    attribute: "show-delay"
})], J.prototype, "showDelay", 2),
vt([u({
    type: Number
})], J.prototype, "duration", 2),
vt([u({
    type: Number,
    attribute: "z-index"
})], J.prototype, "zIndex", 2),
vt([u({
    type: String
})], J.prototype, "name", 2),
vt([u({
    type: Boolean
})], J.prototype, "portal", 2),
vt([l("backdrop:show", document)], J.prototype, "handleBackdropShow", 1),
vt([l("backdrop:hide", document)], J.prototype, "handleBackdropHide", 1),
J = vt([d("backdrop-element")], J);
function ut(e, t, i, s) {
    const r = i != null && i.selector ? e.querySelector(i.selector) : e
      , n = i != null && i.selector ? t.querySelector(i.selector) : t;
    return !r || !n ? !1 : i?.morph === !1 ? (r.innerHTML = n.innerHTML,
    Array.from(r.attributes).forEach(o => {
        r.removeAttribute(o.name)
    }
    ),
    Array.from(n.attributes).forEach(o => {
        r.setAttribute(o.name, o.value)
    }
    ),
    !0) : (s ?? (s = new WeakSet),
    zs(r, n, {
        ...i,
        onBeforeElUpdated(o, a) {
            if (i != null && i.onBeforeElUpdated && !i.onBeforeElUpdated(o, a) || o.hasAttribute("data-morph-ignore"))
                return !1;
            if (o.hasAttribute("data-morph-replace") || o.getAttribute("is") !== a.getAttribute("is") || o instanceof HTMLTemplateElement)
                return o.replaceWith(a),
                !1;
            if (ea(o) && !s.has(o)) {
                s.add(o);
                const c = i;
                return o.beforeMorphDOM(a, (h, f, v) => ut(h, f, {
                    ...c,
                    selector: void 0,
                    morph: void 0,
                    ...v
                }, s))
            }
            return !0
        }
    }),
    !0)
}
function ea(e) {
    return ao(e) && "beforeMorphDOM"in e && typeof e.beforeMorphDOM == "function"
}
function Lt(e, t={}) {
    return lo(e, t).addon(co).headers({
        "X-Requested-With": "XMLHttpRequest"
    }).errorType("json")
}
function ia(e, t) {
    const i = typeof e == "string" ? new URL(e) : e;
    return t instanceof URLSearchParams && (i.search = t.toString()),
    i
}
function sa(e) {
    return ia(`${window.location.origin}${window.location.pathname}`, e)
}
function Gs(e, t) {
    const i = Array.from(e.querySelectorAll("[data-section-ref]"))
      , s = Array.from(t.querySelectorAll("[data-section-ref]"));
    for (const r of s) {
        const n = r.dataset.sectionRef ?? "";
        if (n && !e.querySelector(`[data-section-ref="${n}"]`) && !bs(e, n))
            return console.warn("updateDOMBySectionRefs(): missing target for", n, "in", e),
            e.innerHTML = t.innerHTML,
            !1
    }
    i.forEach(r => {
        const n = r.dataset.sectionRef ?? "";
        n && t.querySelector(`[data-section-ref="${n}"]`) && ut(e, t, {
            selector: `[data-section-ref="${n}"]`
        })
    }
    );
    for (const r of s) {
        const n = r.dataset.sectionRef ?? "";
        if (n && !e.querySelector(`[data-section-ref="${n}"]`)) {
            const a = bs(e, n);
            a && a.replaceWith(r.cloneNode(!0))
        }
    }
    for (const r of i) {
        const n = r.dataset.sectionRef ?? "";
        n && (t.querySelector(`[data-section-ref="${n}"]`) || (bs(t, n) ? r.replaceWith(document.createComment(`section_ref: ${n}`)) : r.remove()))
    }
    return !0
}
function bs(e, t) {
    const i = document.createTreeWalker(e, NodeFilter.SHOW_COMMENT);
    let s = i.nextNode();
    for (; s; ) {
        const r = s.data.trim();
        if (r && /^section_ref:\s*([^\s]+)\s*$/.test(r) && r.replace(/^section_ref:\s*([^\s]+)\s*$/, "$1") === t)
            return s;
        s = i.nextNode()
    }
    return null
}
function Qs(e) {
    return e.closest(".shopify-section") ?? z("Shopify section not found")
}
function wt(e) {
    return e.id.replace(/^shopify-section-/, "")
}
function Zs(e, t) {
    var s;
    const i = new URL(t ?? ((s = window.Shopify) == null ? void 0 : s.routes.root) ?? "/",window.location.origin);
    return i.searchParams.set("section_id", typeof e == "string" ? e : wt(e)),
    i
}
function _n(e) {
    var t;
    return Lt(`${(t = window.Shopify) == null ? void 0 : t.routes.root}?section_id=${e}`).get().text()
}
function ra(e) {
    return _n(e).then(le)
}
function le(e) {
    const t = dt(e).querySelector(".shopify-section");
    if (!t)
        throw new Error("Shopify section not found in html");
    return t
}
function Ar(e, t) {
    var n, o;
    const i = na(e)
      , s = (n = document.activeElement) == null ? void 0 : n.id
      , r = Array.from(e.querySelectorAll("[data-preserve][id]"));
    t(),
    r.forEach(a => {
        const c = e.querySelector(`#${a.id}`);
        c && c.replaceWith(a)
    }
    ),
    i.forEach( (a, c) => {
        const h = document.getElementById(c);
        h && (a.attributes && a.attributes.forEach( (f, v) => {
            h.setAttribute(v, f)
        }
        ),
        a.scrollLeft && (h.scrollLeft = a.scrollLeft),
        a.scrollTop && (h.scrollTop = a.scrollTop))
    }
    ),
    s && ((o = document.activeElement) == null ? void 0 : o.id) !== s && queueMicrotask( () => {
        var a;
        return (a = document.getElementById(s)) == null ? void 0 : a.focus()
    }
    )
}
function na(e) {
    const t = new Map;
    for (const i of e.querySelectorAll("*")) {
        const s = {};
        !i.id || !(i instanceof HTMLElement) || (i.scrollTop !== 0 && (s.scrollTop = i.scrollTop),
        i.scrollLeft !== 0 && (s.scrollLeft = i.scrollLeft),
        (i.scrollTop || i.scrollLeft || s.attributes) && t.set(i.id, s))
    }
    return t
}
function Zt(e=0) {
    return new Promise(t => {
        setTimeout(t, e)
    }
    )
}
function De(e) {
    return new Promise(t => {
        requestIdleCallback(t, e)
    }
    )
}
function oa(e, t) {
    let i = 0
      , s = Symbol();
    function r() {
        const o = new Error("Async debounce aborted");
        throw o.name = "AbortError",
        o
    }
    const n = async function(...o) {
        const a = Symbol();
        s = a,
        i && (clearTimeout(i),
        await Zt(t),
        s !== a && r());
        let c = !1;
        i = window.setTimeout( () => {
            i = 0,
            c = !0
        }
        , t);
        const h = await e(...o);
        return s !== a && !c && r(),
        h
    };
    return n.cancel = () => {
        s = Symbol(),
        i && (clearTimeout(i),
        i = 0)
    }
    ,
    n
}
const ae = new Map;
function Jt(e={}) {
    const t = Gi();
    e.method ?? (e.method = "GET");
    function i(n, o=!1) {
        var c;
        (c = e.onLoading) == null || c.call(e, !0);
        const a = Lt(n, {
            signal: e.abortRequest && !o ? t.abort() : void 0
        }).fetch(e.method).text().catch(h => {
            throw e.cache && ae.delete(n),
            h
        }
        ).finally( () => {
            var h;
            (h = e.onLoading) == null || h.call(e, !1)
        }
        );
        return e.cache && ae.set(n, a),
        a
    }
    const s = typeof e.debounce == "number" ? oa(i, e.debounce) : null
      , r = (n, o=!1) => e.cache && ae.has(n) ? (s && s.cancel(),
    e.abortRequest && !o && t.abort(),
    ae.get(n)) : s ? s(n, o) : i(n, o);
    return r.abort = () => {
        s && s.cancel(),
        e.abortRequest && t.abort()
    }
    ,
    r.clearCache = () => {
        ae.clear()
    }
    ,
    r
}
var ln;
(ln = window.Shopify) != null && ln.designMode && window.addEventListener("shopify:section:load", () => {
    ae.clear()
}
);
var aa = Object.defineProperty
  , la = Object.getOwnPropertyDescriptor
  , Js = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? la(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && aa(t, i, r),
    r
}
;
let Oi = class extends HTMLElement {
    constructor() {
        super(...arguments),
        this.makeRequest = Jt({
            cache: !0,
            debounce: 500
        }),
        this.handleFilterChange = _i(async (e, t) => {
            if (t.detail.mode === "replace") {
                this.dispatchUpdateStart();
                try {
                    const i = await this.fetchBlogSection(t.detail.url);
                    if (!this.isConnected || e.aborted)
                        return;
                    const s = le(i);
                    this.updateContent(s),
                    history.replaceState({}, "", t.detail.url)
                } catch (i) {
                    if (!(i instanceof Error) || i.name !== "AbortError")
                        throw i
                } finally {
                    this.dispatchUpdateEnd()
                }
            }
        }
        )
    }
    get $section() {
        return this.closest(".shopify-section") ?? z("Section not found")
    }
    get $blogGrid() {
        return this.querySelector('[data-part="blog-grid"]') ?? z("Blog grid not found")
    }
    async handleSectionUpdate(e) {
        if (e.detail.mode === "append") {
            m(this, "section:updating", void 0, {
                bubbles: !0
            });
            try {
                const t = await this.fetchBlogSection(e.detail.url);
                if (!this.isConnected)
                    return;
                const i = le(t);
                this.appendBlogPosts(i),
                e.detail.scrollTop !== void 0 && window.scrollTo(0, e.detail.scrollTop)
            } catch (t) {
                console.error("Failed to load more blog posts:", t)
            } finally {
                m(this, "section:updated", void 0, {
                    bubbles: !0
                })
            }
        }
    }
    async fetchBlogSection(e) {
        return this.makeRequest(Zs(this.$section, e).toString())
    }
    updateContent(e) {
        const t = ot(e, "blog-section");
        ut(this, t)
    }
    appendBlogPosts(e) {
        const t = Array.from(this.getBlogGrid().children).map(s => s.cloneNode(!0));
        this.getBlogGrid(e).prepend(...t);
        const i = ot(e, "blog-section");
        ut(this, i)
    }
    getBlogGrid(e=this) {
        return e.querySelector('[data-part="blog-grid"]') ?? z("Blog grid not found")
    }
    dispatchUpdateStart() {
        m(this, "blog:updating", void 0, {
            bubbles: !0
        })
    }
    dispatchUpdateEnd() {
        m(this, "blog:updated", void 0, {
            bubbles: !0
        })
    }
}
;
Js([l("section:update")], Oi.prototype, "handleFilterChange", 2),
Js([l("section:update")], Oi.prototype, "handleSectionUpdate", 1),
Oi = Js([d("blog-section")], Oi);
var ca = Object.defineProperty
  , ha = Object.getOwnPropertyDescriptor
  , On = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? ha(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && ca(t, i, r),
    r
}
;
let Es = class extends HTMLButtonElement {
    constructor() {
        super(),
        this.addEventListener("click", this.handleClick.bind(this))
    }
    get controlsId() {
        return this.getAttribute("aria-controls") ?? ""
    }
    get direction() {
        return this.getAttribute("direction") ?? "next"
    }
    connectedCallback() {
        m(document, "control:connected", {
            targetId: this.controlsId
        }, {
            bubbles: !0
        })
    }
    handleCarouselUpdate({detail: e}) {
        if (e.targetId === this.controlsId) {
            if (!e.hasPrev && !e.hasNext) {
                this.hidden = !0;
                return
            }
            this.hidden = !1,
            this.direction === "prev" ? this.disabled = !e.hasPrev : this.direction === "next" && (this.disabled = !e.hasNext)
        }
    }
    handleClick() {
        const e = this.direction === "prev" ? "prev" : "next";
        m(document, "control:trigger", {
            targetId: this.controlsId,
            action: e
        }, {
            bubbles: !0
        })
    }
    beforeMorphDOM() {
        return !1
    }
}
;
On([l("carousel:update", document, {
    attachTiming: "before"
})], Es.prototype, "handleCarouselUpdate", 1),
Es = On([d("carousel-button", {
    extends: "button"
})], Es);
var da = Object.defineProperty
  , ua = Object.getOwnPropertyDescriptor
  , tr = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? ua(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && da(t, i, r),
    r
}
;
let Pi = class extends HTMLElement {
    handleCartUpdated(e) {
        const {sections: t} = e.detail.response;
        if (t["cart-button"]) {
            const i = le(t["cart-button"]).querySelector("cart-button");
            i && ut(this, i)
        }
    }
    async handlePageShow(e) {
        e.persisted && await this.reload()
    }
    async reload() {
        const e = (await ra("cart-button")).querySelector("cart-button");
        e && ut(this, e)
    }
}
;
tr([l("cart:updated", document)], Pi.prototype, "handleCartUpdated", 1),
tr([l("pageshow", window)], Pi.prototype, "handlePageShow", 1),
Pi = tr([d("cart-button")], Pi);
var pa = Object.defineProperty
  , fa = Object.getOwnPropertyDescriptor
  , er = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? fa(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && pa(t, i, r),
    r
}
;
let Ii = class extends HTMLElement {
    connectedCallback() {
        this.role = "button",
        this.setAttribute("tabindex", "0")
    }
    handleClick() {
        m(this, "cart:remove-discount", {
            code: this.code
        }, {
            bubbles: !0
        }),
        this.remove()
    }
}
;
er([g()], Ii.prototype, "code", 2),
er([l("click")], Ii.prototype, "handleClick", 1),
Ii = er([d("cart-discount-code")], Ii);
const Tt = new Map
  , Mr = 500
  , ma = 10;
function ga(e, t, i) {
    return i ?? (i = $a()),
    Tt.set(e, {
        container: t,
        returnFocusTo: i
    }),
    wa(e).toString()
}
function va(e) {
    var o;
    const t = Tt.get(e);
    if (!t)
        return null;
    const i = [...Tt.keys()]
      , s = i.indexOf(e)
      , r = s === i.length - 1
      , n = i[s + 1];
    if (n) {
        const a = Tt.get(n);
        a.returnFocusTo = t.returnFocusTo
    }
    if (Tt.delete(e),
    r) {
        if (!((o = t.returnFocusTo) != null && o.isConnected)) {
            const a = ya();
            return a ? a.container : null
        }
        return t.returnFocusTo
    }
    return null
}
function ya() {
    return Array.from(Tt.values()).at(-1)
}
function ba(e) {
    const t = [...Tt.keys()];
    return t.length > 0 && t[t.length - 1] === e
}
function wa(e) {
    const t = [...Tt.keys()].indexOf(e);
    return t >= 0 ? Mr + t * ma : Mr
}
function $a() {
    var i;
    if (!document.activeElement)
        return null;
    let e = document.activeElement;
    const t = (i = e.closest("[data-redirect-return-focus]")) == null ? void 0 : i.getAttribute("data-redirect-return-focus");
    if (t) {
        const s = document.getElementById(t);
        s && (e = s)
    }
    return e
}
class Pn {
    constructor(t, i, s, r, n) {
        this.target = i,
        this.eventType = s,
        this.listener = r,
        this.options = n,
        this.abortController = Gi(),
        t.addController(this)
    }
    async hostConnected() {
        const {signal: t} = this.abortController;
        Ws(this.target, t, i => {
            i = Z(i),
            i.filter(s => !!s).forEach(s => s.addEventListener(this.eventType, this.listener, {
                ...this.options,
                signal: t
            }))
        }
        )
    }
    hostDisconnected() {
        this.abortController.abort()
    }
}
class it {
    constructor(t) {
        this.host = t,
        this.subcontrollers = [],
        this.abortController = Gi()
    }
    get disconnected() {
        return this.abortController.signal
    }
    hostConnected() {}
    hostDisconnected() {
        this.abortController.abort()
    }
    hostUpdate() {}
    hostUpdated() {}
    addController(t) {
        return this.subcontrollers.push(t),
        t
    }
    remove() {
        this.hostDisconnected(),
        this.host.removeController(this),
        this.subcontrollers.forEach(t => {
            var i;
            t instanceof it ? t.remove() : ((i = t.hostDisconnected) == null || i.call(t),
            this.host.removeController(t))
        }
        )
    }
    listen(...t) {
        const i = new Pn(this.host,...t);
        return this.subcontrollers.push(i),
        i
    }
}
class Ut extends it {
    constructor(t, i, s) {
        super(t),
        this.callback = s,
        this.handleChange = r => {
            var n;
            (n = this.callback) == null || n.call(this, r.matches),
            this.host.requestUpdate()
        }
        ,
        this.mediaQuery = window.matchMedia(i),
        s?.(this.mediaQuery.matches),
        t.addController(this)
    }
    get matches() {
        return this.mediaQuery.matches
    }
    get query() {
        return this.mediaQuery
    }
    hostConnected() {
        this.mediaQuery.addEventListener("change", this.handleChange)
    }
    hostDisconnected() {
        this.mediaQuery.removeEventListener("change", this.handleChange)
    }
}
const Ae = new Map;
function ir(e, t=!1) {
    const i = {};
    t && (i.abortListeners = Sa(e)),
    Ae.set(e, i),
    document.documentElement.classList.add("no-scroll"),
    document.documentElement.style.setProperty("--scroll-lock", "1"),
    m(document, "scroll:locked")
}
function Ai(e) {
    var i;
    if (Ae.size === 0)
        return;
    const t = Ae.get(e);
    (i = t?.abortListeners) == null || i.abort(),
    Ae.delete(e),
    Ae.size === 0 && (document.documentElement.classList.remove("no-scroll"),
    document.documentElement.style.removeProperty("--scroll-lock"),
    m(document, "scroll:unlocked"))
}
function Sa(e) {
    const t = new AbortController
      , i = {
        initialY: 0
    }
      , s = o => {
        Ca(o) || o.targetTouches.length === 1 && o.targetTouches[0] && (i.initialY = o.targetTouches[0].clientY,
        e.addEventListener("touchmove", r, {
            signal: t.signal,
            passive: !1
        }))
    }
      , r = o => {
        if (o.touches.length > 1 || !o.targetTouches[0])
            return;
        const c = o.targetTouches[0].clientY - i.initialY;
        (xa(e, c) || _a(e, c)) && o.cancelable && o.preventDefault()
    }
      , n = () => {
        e.removeEventListener("touchmove", r)
    }
    ;
    return e.addEventListener("touchstart", s, {
        signal: t.signal,
        passive: !0
    }),
    e.addEventListener("touchend", n, {
        signal: t.signal
    }),
    t
}
function Ca(e) {
    return e.composedPath().some(t => t instanceof HTMLElement && t.matches("[data-scroll-lock-ignore]"))
}
function xa(e, t) {
    return e.scrollTop === 0 && t > 0
}
function _a(e, t) {
    return Oa(e) && t < 0
}
function Oa(e) {
    return e.scrollHeight - e.scrollTop <= e.clientHeight
}
class In {
    constructor(t) {
        this.modal = t
    }
    get modalClass() {}
    destroy() {
        this.modal = null
    }
}
class Pa extends In {
    constructor() {
        super(...arguments),
        this.name = "drawer",
        this.mobileQuery = window.matchMedia("not all and (min-width: 768px)")
    }
    get position() {
        return this.modal.getAttribute("position") ?? "right"
    }
    get modalClass() {
        return `modal--drawer modal--drawer-${this.position}`
    }
    get timescale() {
        return this.mobileQuery.matches || this.position === "bottom" ? .75 : 1
    }
    animateBackdropIn() {
        return [[this.modal.$backdrop, {
            opacity: [0, 1]
        }, {
            duration: .6
        }]]
    }
    animateBackdropOut() {
        return [[this.modal.$backdrop, {
            opacity: [1, 0]
        }, {
            duration: .35,
            at: .25
        }]]
    }
    animateWrapperIn() {
        const t = [];
        return t.push([this.modal.$wrapper, {
            opacity: [1, 1],
            transform: [this.getAnimationDirection("100%"), this.getAnimationDirection("0%")]
        }, {
            duration: .8 * this.timescale,
            ease: "power3.out"
        }]),
        this.modal.$content.length && t.push([this.modal.$content, {
            opacity: [0, 1],
            transform: [this.getAnimationDirection("64px"), this.getAnimationDirection("0px")]
        }, {
            duration: 1.2 * this.timescale,
            ease: "power4.out",
            at: "<"
        }]),
        t
    }
    animateWrapperOut() {
        return [[this.modal.$wrapper, {
            opacity: 0,
            transform: this.getAnimationDirection("25%")
        }, {
            duration: .25,
            ease: "power1.in"
        }]]
    }
    getAnimationDirection(t) {
        switch (this.position) {
        case "left":
            return `translate3d(calc(-${t} * var(--transform-logical, 1)), 0, 0)`;
        case "bottom":
            return `translate3d(0, ${t}, 0)`;
        default:
            return `translate3d(calc(${t} * var(--transform-logical, 1)), 0, 0)`
        }
    }
}
class An {
    constructor() {
        this.startX = 0,
        this.startY = 0,
        this.startTime = 0,
        this.currentX = 0,
        this.currentY = 0,
        this.isActive = !1,
        this.points = [],
        this.currentTimestamp = 0,
        this.lastVelocity = 0,
        this.velocityWindowMs = 80,
        this.minDtMs = 8
    }
    start(t, i, s) {
        const r = s ?? performance.now();
        this.startX = t,
        this.startY = i,
        this.currentX = t,
        this.currentY = i,
        this.startTime = r,
        this.currentTimestamp = r,
        this.isActive = !0,
        this.points = [{
            x: t,
            y: i,
            timestamp: r
        }],
        this.lastVelocity = 0
    }
    update(t, i, s) {
        const r = s ?? performance.now();
        this.currentX = t,
        this.currentY = i,
        this.currentTimestamp = r;
        const n = this.points[this.points.length - 1];
        (!n || n.x !== t || n.y !== i || n.timestamp !== r) && this.points.push({
            x: t,
            y: i,
            timestamp: r
        });
        const o = r - this.velocityWindowMs;
        let a = this.points[0];
        for (; this.points.length > 1 && a && a.timestamp < o; )
            this.points.shift(),
            a = this.points[0]
    }
    stop() {
        this.isActive = !1,
        this.points = []
    }
    get tracking() {
        return this.isActive
    }
    calculateVelocity() {
        const t = this.points.length;
        if (t < 2)
            return this.lastVelocity || 0;
        const i = this.points[0]
          , s = this.points[t - 1];
        if (!i || !s)
            return this.lastVelocity || 0;
        const r = s.timestamp - i.timestamp;
        if (r < this.minDtMs)
            return this.lastVelocity || 0;
        const n = s.x - i.x
          , o = s.y - i.y
          , c = Math.hypot(n, o) / r;
        return this.lastVelocity = c,
        c
    }
    getMetrics() {
        const t = this.currentX - this.startX
          , i = this.currentY - this.startY
          , s = this.currentTimestamp - this.startTime
          , r = Math.hypot(t, i)
          , n = this.calculateVelocity()
          , a = Math.atan2(Math.abs(i), Math.abs(t)) * (180 / Math.PI);
        return {
            deltaX: t,
            deltaY: i,
            duration: s,
            distance: r,
            velocity: n,
            angle: a
        }
    }
    exceedsHorizontalAngle(t) {
        const i = this.getMetrics();
        return Math.abs(i.deltaX) > 10 && i.angle > t
    }
    exceedsVerticalAngle(t) {
        const i = this.getMetrics();
        return Math.abs(i.deltaY) > 10 && i.angle < 90 - t
    }
}
class Ia extends it {
    constructor(t, i) {
        super(t),
        this.options = i,
        this.maxY = 0,
        this.progress = 0,
        this.ignoreInteraction = !1,
        this.initialScrollTop = 0,
        this.touchTracker = new An,
        this.progressCloseAnimation = r => {
            this.closeAnimation && (this.closeAnimation.time = this.closeAnimation.duration * r)
        }
        ,
        this.$container = this.options.$container,
        this.$handle = this.options.$handle,
        this.$scrollContainer = this.$container;
        const s = () => [this.$container, this.$handle];
        this.listen(s, "touchstart", this.handleTouchStart.bind(this), {
            passive: !0
        }),
        this.listen(s, "touchmove", this.handleTouchMove.bind(this), {
            passive: !1
        }),
        this.listen(s, "touchend", this.handleTouchEnd.bind(this), {
            passive: !1
        }),
        t.addController(this)
    }
    get overflowHidden() {
        return this.$scrollContainer.style.overflow === "hidden"
    }
    set overflowHidden(t) {
        this.$scrollContainer.style.overflow = t ? "hidden" : ""
    }
    resetPositions(t) {
        var i, s;
        this.maxY = this.$scrollContainer.clientHeight,
        this.progress = 0,
        this.initialScrollTop = this.$scrollContainer.scrollTop,
        this.touchTracker.start(((i = t.touches[0]) == null ? void 0 : i.clientX) ?? 0, ((s = t.touches[0]) == null ? void 0 : s.clientY) ?? 0, t.timeStamp)
    }
    handleTouchStart(t) {
        var i, s, r, n;
        t.touches[0] && (t.target instanceof Element ? this.$scrollContainer = t.target.closest("[data-drag-close-container]") ?? this.$container : this.$scrollContainer = this.$container,
        t.stopImmediatePropagation(),
        this.resetPositions(t),
        (i = this.closeAnimation) == null || i.cancel(),
        (s = this.cancelAnimation) == null || s.complete(),
        this.cancelAnimation = void 0,
        this.closeAnimation = this.options.closeAnimation(),
        this.closeAnimation.pause(),
        this.closeAnimation.time = 0,
        (n = (r = this.options).onDragStart) == null || n.call(r))
    }
    handleTouchMove(t) {
        var r, n;
        if (!t.touches[0] || this.ignoreInteraction)
            return;
        if (t.stopImmediatePropagation(),
        this.touchTracker.update(t.touches[0].clientX, t.touches[0].clientY, t.timeStamp),
        !this.overflowHidden && this.touchTracker.exceedsVerticalAngle(35)) {
            this.touchTracker.stop(),
            this.ignoreInteraction = !0;
            return
        }
        const {deltaY: i} = this.touchTracker.getMetrics()
          , s = this.$handle && t.composedPath().includes(this.$handle);
        if (!s && this.$scrollContainer.scrollTop !== this.initialScrollTop && this.$scrollContainer.scrollTop > 0 && (this.ignoreInteraction = !0),
        this.progress = lt(i, 0, this.maxY) / this.maxY,
        !this.overflowHidden)
            if (i > 10 && (s || this.$scrollContainer.scrollTop <= 0))
                this.overflowHidden = !0;
            else
                return;
        t.preventDefault(),
        this.cancelAnimation && (this.cancelAnimation.cancel(),
        this.cancelAnimation = void 0),
        this.progressCloseAnimation(this.progress),
        (n = (r = this.options).onDrag) == null || n.call(r, this.progress)
    }
    handleTouchEnd(t) {
        var s, r, n, o, a;
        t.stopImmediatePropagation(),
        this.ignoreInteraction = !1;
        const {velocity: i} = this.touchTracker.getMetrics();
        this.touchTracker.stop(),
        (s = this.closeAnimation) == null || s.stop(),
        this.closeAnimation = void 0,
        this.overflowHidden && (i > .5 || this.progress > .5 ? (n = (r = this.options).onDragClose) == null || n.call(r) : (this.cancelAnimation = this.options.cancelAnimation(),
        (a = (o = this.options).onDragCancel) == null || a.call(o))),
        this.overflowHidden = !1
    }
}
class Aa extends In {
    constructor() {
        super(...arguments),
        this.name = "mobile",
        this.dragClose = !1
    }
    get modalClass() {
        return "modal--mobile"
    }
    get $notch() {
        return this.modal.renderRoot.querySelector(".drag-notch")
    }
    initialize() {
        this.dragController = new Ia(this.modal,{
            $container: this.modal.$wrapper,
            $handle: this.$notch,
            closeAnimation: () => A([[this.modal.$wrapper, {
                transform: "translateY(100%)"
            }, {
                duration: 1,
                ease: "linear"
            }], [this.modal.$backdrop, {
                opacity: .5
            }, {
                duration: .5,
                at: "<"
            }]]),
            cancelAnimation: () => A([[this.modal.$wrapper, {
                transform: "translateY(0%)"
            }, {
                duration: .5,
                ease: "power3.out"
            }], [this.modal.$slotted, {
                transform: "translateY(0px)"
            }, {
                duration: .5,
                ease: "power3.out",
                at: "<"
            }], [this.modal.$backdrop, {
                opacity: 1
            }, {
                duration: .5,
                at: "<"
            }]]),
            onDragStart: () => {
                var t;
                (t = this.modal.animation) == null || t.complete()
            }
            ,
            onDragClose: () => {
                var t;
                (t = this.modal.animation) == null || t.stop(),
                this.modal.animation = void 0,
                this.dragClose = !0,
                this.modal.open = !1
            }
        })
    }
    destroy() {
        var t;
        (t = this.dragController) == null || t.remove(),
        super.destroy()
    }
    async beforeAnimateIn() {
        ht([this.modal.$wrapper, this.modal.$slotted], "all")
    }
    animateBackdropIn() {
        return [[this.modal.$backdrop, {
            opacity: [0, 1]
        }, {
            duration: .3
        }]]
    }
    animateBackdropOut() {
        return [[this.modal.$backdrop, {
            opacity: 0
        }, {
            duration: .4,
            delay: this.dragClose ? .2 : 0
        }]]
    }
    animateWrapperIn() {
        const t = [this.modal.$wrapper, {
            transform: ["translateY(25%)", "none"]
        }, {
            duration: .7,
            ease: "power4.out"
        }]
          , i = [this.modal.$wrapper, {
            opacity: [0, 1]
        }, {
            duration: .35,
            ease: "power1.out",
            at: "<"
        }];
        return [t, i]
    }
    animateWrapperOut() {
        return this.dragClose ? [[this.modal.$wrapper, {
            transform: "translateY(100%)"
        }, {
            duration: .133,
            ease: "linear"
        }]] : [[this.modal.$wrapper, {
            transform: "translateY(25%)",
            opacity: 0
        }, {
            duration: .2
        }]]
    }
    afterAnimateOut() {
        this.dragClose = !1
    }
    renderWrapper(t) {
        return p`
      <div class="modal__wrapper" part="wrapper">
        <div class="drag-notch"></div>
        ${t}
      </div>
    `
    }
}
const Tr = Object.freeze(Object.defineProperty({
    __proto__: null,
    DrawerStrategy: Pa,
    MobileStrategy: Aa
}, Symbol.toStringTag, {
    value: "Module"
}));
var Ma = Object.defineProperty
  , Ta = Object.getOwnPropertyDescriptor
  , Ot = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Ta(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Ma(t, i, r),
    r
}
;
let L = class extends x {
    constructor() {
        super(!0),
        this.open = !1,
        this.visible = !1,
        this.appendToBody = !1,
        this.themeEditorSync = !1,
        this.hash = "",
        this.dummyContent = document.createElement("div"),
        this.skipAnimation = !1,
        this.id || (this.id = Ee("Modal-")),
        this.hasAttribute("open") || w(this, {
            visibility: "hidden",
            pointerEvents: "none",
            opacity: "0"
        }),
        new Ut(this,"(min-width: 768px)",e => {
            this.setStrategy(e ? this.strategyName : this.mobileStrategyName),
            this.open && this.updateComplete.then( () => this.playAnimationElements())
        }
        ),
        Ks() && this.classList.add("is-webkit")
    }
    get $slotted() {
        return this.slottedHTMLElements()[0] ?? this.dummyContent
    }
    get $title() {
        return this.$slotted.querySelector("[data-title]")
    }
    get $description() {
        return this.$slotted.querySelector("[data-description]")
    }
    get $content() {
        const e = this.$slotted.querySelectorAll("[data-content]");
        return e.length ? [...e] : [this.$slotted]
    }
    get $wrapper() {
        return this.renderRoot.querySelector(".modal__wrapper")
    }
    get $container() {
        return this.renderRoot.querySelector(".modal__container")
    }
    get $backdrop() {
        return this.renderRoot.querySelector(".backdrop")
    }
    get strategyName() {
        return this.getAttribute("strategy") ?? "default"
    }
    get mobileStrategyName() {
        return this.getAttribute("mobile-strategy") ?? "mobile"
    }
    disconnectedCallback() {
        super.disconnectedCallback(),
        Ai(this)
    }
    createStrategy(e) {
        const t = `${ho(e)}Strategy`;
        if (this.isModalStrategyKey(t))
            return new Tr[t](this)
    }
    isModalStrategyKey(e) {
        return e in Tr
    }
    async setStrategy(e) {
        var t, i, s;
        ((t = this.strategy) == null ? void 0 : t.name) !== e && (this.strategy && (ht([this.$backdrop, this.$wrapper, this.$slotted], "all"),
        this.strategy.destroy()),
        this.strategy = this.createStrategy(e),
        this.hasUpdated && this.requestUpdate(),
        await this.updateComplete,
        (s = (i = this.strategy) == null ? void 0 : i.initialize) == null || s.call(i))
    }
    async openUpdated(e) {
        var t;
        await ((t = this.animation) == null ? void 0 : t.complete()),
        e === void 0 && !this.open ? (w(this, {
            visibility: "hidden",
            pointerEvents: "none"
        }),
        this.visible = !1) : this.open ? (this.visible = !0,
        this.show()) : this.hide()
    }
    async show() {
        this.focusTrap = zi(this.$slotted, {
            escapeDeactivates: !1,
            returnFocusOnDeactivate: !1,
            preventScroll: !0,
            allowOutsideClick: !0,
            fallbackFocus: this.$slotted,
            initialFocus: this.$slotted
        }),
        m(this, "modal:show", void 0, {
            bubbles: !0
        }),
        await this.beforeAnimateIn(),
        this.skipAnimation ? (this.animateIn().complete(),
        this.playAnimationElements(),
        this.skipAnimation = !1) : (this.animation = this.animateIn(),
        this.animation.pause(),
        await De({
            timeout: 100
        }),
        this.playAnimationElements(),
        this.animation.play(),
        await this.animation),
        this.afterAnimateIn()
    }
    async hide() {
        return m(this, "modal:hide", void 0, {
            bubbles: !0
        }),
        await this.beforeAnimateOut(),
        this.clearHash(),
        new Promise(e => {
            requestAnimationFrame( () => {
                this.animation = this.animateOut(),
                this.animation.then( () => {
                    this.afterAnimateOut(),
                    e()
                }
                )
            }
            )
        }
        )
    }
    animateIn() {
        return Ir([A(this.animateWrapperIn()), A(this.animateBackdropIn())])
    }
    animateOut() {
        return Ir([A(this.animateWrapperOut()), A(this.animateBackdropOut())])
    }
    animateWrapperIn() {
        var e;
        return (e = this.strategy) != null && e.animateWrapperIn ? this.strategy.animateWrapperIn() : [[this.$wrapper, {
            opacity: [0, 1],
            scale: [.9, 1]
        }, {
            duration: .4,
            ease: "power2.out"
        }]]
    }
    animateWrapperOut() {
        var e;
        return (e = this.strategy) != null && e.animateWrapperOut ? this.strategy.animateWrapperOut() : [[this.$wrapper, {
            opacity: 0,
            scale: .9
        }, {
            duration: .2,
            ease: "power1.in"
        }]]
    }
    animateBackdropIn() {
        var e;
        return (e = this.strategy) != null && e.animateBackdropIn ? this.strategy.animateBackdropIn() : [[this.$backdrop, {
            opacity: [0, 1]
        }, {
            duration: .3
        }]]
    }
    animateBackdropOut() {
        var e;
        return (e = this.strategy) != null && e.animateBackdropOut ? this.strategy.animateBackdropOut() : [[this.$backdrop, {
            opacity: 0
        }, {
            duration: .4
        }]]
    }
    async beforeAnimateIn() {
        var t, i, s;
        this.hidden = !1;
        const e = ga(this.id, this.$slotted);
        w(this, {
            "--modal-z-index": e
        }),
        ht(this, ["visibility", "pointerEvents", "opacity"]),
        this.appendToBody && (this.appendToBodyMarker = document.createComment(""),
        this.replaceWith(this.appendToBodyMarker),
        document.body.appendChild(this)),
        ir(this);
        try {
            (t = this.focusTrap) == null || t.activate()
        } catch (r) {
            console.error(r)
        }
        await ((s = (i = this.strategy) == null ? void 0 : i.beforeAnimateIn) == null ? void 0 : s.call(i))
    }
    afterAnimateIn() {
        var e, t;
        (t = (e = this.strategy) == null ? void 0 : e.afterAnimateIn) == null || t.call(e)
    }
    async beforeAnimateOut() {
        var t, i, s;
        (t = this.focusTrap) == null || t.deactivate(),
        this.focusTrap = void 0;
        const e = va(this.id);
        e instanceof HTMLElement && setTimeout( () => e.focus({
            preventScroll: !0
        })),
        this.style.pointerEvents = "none",
        await ((s = (i = this.strategy) == null ? void 0 : i.beforeAnimateOut) == null ? void 0 : s.call(i))
    }
    afterAnimateOut() {
        var e, t;
        Ai(this),
        w(this, {
            opacity: "0",
            visibility: "hidden",
            pointerEvents: "none"
        }),
        this.visible = !1,
        this.appendToBodyMarker && (this.appendToBodyMarker.replaceWith(this),
        this.appendToBodyMarker = void 0),
        (t = (e = this.strategy) == null ? void 0 : e.afterAnimateOut) == null || t.call(e)
    }
    resetScrollContainers() {
        this.renderRoot.querySelectorAll("*").forEach(e => {
            e.scrollTop !== 0 && e.scrollTo({
                top: 0
            })
        }
        )
    }
    playAnimationElements() {
        wn(this),
        this.querySelectorAll("em[is=text-highlight]").forEach(e => e.play())
    }
    handleClick(e) {
        e.target instanceof Element && e.target.closest("[data-close]") ? this.open = !1 : e.composedPath().includes(this.$container) || (e.preventDefault(),
        this.open = !1)
    }
    handleMouseDown(e) {
        e.composedPath().includes(this.$container) || e.preventDefault()
    }
    handleKeyDown(e) {
        e.key === "Escape" && ba(this.id) && (e.stopPropagation(),
        this.open = !1)
    }
    handleSlotChange() {
        var e, t, i;
        this.$slotted.tabIndex = -1,
        this.$slotted.setAttribute("role", "dialog"),
        this.$title && !this.hasAttribute("aria-label") && ((e = this.$title).id || (e.id = `${this.id}-Title`),
        this.$slotted.setAttribute("aria-labelledby", this.$title.id)),
        this.$description && ((t = this.$description).id || (t.id = `${this.id}-Description`),
        this.$slotted.setAttribute("aria-describedby", this.$description.id)),
        (i = this.focusTrap) == null || i.updateContainerElements(this.$slotted)
    }
    handleSectionSelect(e) {
        var t;
        this.themeEditorSync && (t = window.Shopify) != null && t.designMode && (this.open = !0,
        this.skipAnimation = e.detail.load)
    }
    handleSectionDeselect() {
        var e;
        this.themeEditorSync && (e = window.Shopify) != null && e.designMode && (this.open = !1)
    }
    checkHash() {
        if (this.hash) {
            const e = window.location.hash.substring(1);
            this.open = e === this.hash
        }
    }
    clearHash() {
        this.hash && window.location.hash === `#${this.hash}` && history.replaceState(null, "", window.location.pathname + window.location.search)
    }
    hashWillUpdate() {
        this.checkHash()
    }
    handleHashChange() {
        this.checkHash()
    }
    render() {
        var e;
        return p`
      <div
        class="modal ${((e = this.strategy) == null ? void 0 : e.modalClass) ?? "modal--default"}"
        @click=${this.handleClick}
        @keydown=${this.handleKeyDown}
        @mousedown=${this.handleMouseDown}
      >
        ${this.renderBackdrop()}
        <floating-close ?active=${this.open}></floating-close>
        <div class="modal__container" part="container">
          ${this.renderWrapper(p`<slot @slotchange=${this.handleSlotChange}></slot>`)}
          <slot name="container"></slot>
        </div>
      </div>
    `
    }
    renderBackdrop() {
        var e;
        return (e = this.strategy) != null && e.renderBackdrop ? this.strategy.renderBackdrop() : p`<div class="backdrop"></div>`
    }
    renderWrapper(e) {
        var t;
        return (t = this.strategy) != null && t.renderWrapper ? this.strategy.renderWrapper(e) : p` <div class="modal__wrapper" part="wrapper">
      <div class="modal__scroll" part="scroll">${e}</div>
      <slot name="wrapper"></slot>
    </div>`
    }
    beforeMorphDOM(e, t) {
        return t(this, e, {
            childrenOnly: !0
        }),
        !1
    }
}
;
L.styles = [x.themeCSS],
Ot([u({
    type: Boolean,
    reflect: !0
})], L.prototype, "open", 2),
Ot([u({
    type: Boolean,
    reflect: !0
})], L.prototype, "visible", 2),
Ot([u({
    type: Boolean,
    attribute: "append-to-body"
})], L.prototype, "appendToBody", 2),
Ot([u({
    type: Boolean,
    attribute: "theme-editor-sync"
})], L.prototype, "themeEditorSync", 2),
Ot([u({
    type: String
})], L.prototype, "hash", 2),
Ot([l(["shopify:section:select", "shopify:section:load"], "section", {
    optional: !0
})], L.prototype, "handleSectionSelect", 1),
Ot([l("shopify:section:deselect", "section", {
    optional: !0
})], L.prototype, "handleSectionDeselect", 1),
Ot([l("hashchange", window)], L.prototype, "handleHashChange", 1),
L = Ot([d("modal-element")], L),
document.addEventListener("click", e => {
    const t = e.target instanceof Element && e.target.closest("[data-modal]");
    if (!t)
        return;
    const i = t.getAttribute("data-modal");
    if (!i)
        return;
    const s = document.getElementById(i);
    s instanceof L && (e.preventDefault(),
    s.open = !0)
}
);
var Ea = Object.defineProperty
  , Da = Object.getOwnPropertyDescriptor
  , sr = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Da(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Ea(t, i, r),
    r
}
;
let Mi = class extends L {
    get strategyName() {
        return "drawer"
    }
    get mobileStrategyName() {
        return "drawer"
    }
    handleCartUpdated(e) {
        const t = wt(this.$section);
        e.detail.response.sections[t] && (this.updateCartDrawer(e.detail.response.sections[t]),
        e.detail.type === "add" && !e.detail.error && (this.open = !0))
    }
    async handlePageShow(e) {
        e.persisted && await this.reload()
    }
    async reload() {
        const e = await _n(wt(this.$section));
        this.updateCartDrawer(e)
    }
    updateCartDrawer(e) {
        const t = dt(e).querySelector("cart-drawer");
        t && (this.dataset.empty !== t.dataset.empty ? this.innerHTML = t.innerHTML : Gs(this, t),
        Ke(this, t, ["data-empty"]),
        this.handleSlotChange())
    }
}
;
sr([l("cart:updated", document)], Mi.prototype, "handleCartUpdated", 1),
sr([l("pageshow", window)], Mi.prototype, "handlePageShow", 1),
Mi = sr([d("cart-drawer")], Mi);
var La = Object.defineProperty
  , ka = Object.getOwnPropertyDescriptor
  , rr = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? ka(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && La(t, i, r),
    r
}
;
let Ti = class extends HTMLElement {
    connectedCallback() {
        this.setAttribute("aria-live", "polite"),
        this.setAttribute("aria-atomic", "true")
    }
    handleCartUpdated(e) {
        const {request: t, error: i} = e.detail;
        if (!i) {
            this.textContent = "";
            return
        }
        e.target instanceof HTMLElement && !e.target.contains(this) || (this.key ? this.key === t.id ? this.textContent = i : this.textContent = "" : this.textContent = i)
    }
    beforeMorphDOM(e) {
        return Ke(this, e, ["key"]),
        !1
    }
}
;
rr([g({
    type: String,
    optional: !0
})], Ti.prototype, "key", 2),
rr([l("cart:updated", document)], Ti.prototype, "handleCartUpdated", 1),
Ti = rr([d("cart-error")], Ti);
function Mn(e) {
    e instanceof HTMLFormElement && (e = new FormData(e));
    const t = new URLSearchParams(e);
    return uo.parse(t.toString())
}
function Tn(e) {
    const t = [];
    function i(s) {
        typeof s == "string" ? t.push(s) : Array.isArray(s) ? s.forEach(r => {
            typeof r == "string" ? t.push(r) : i(r)
        }
        ) : s !== null && typeof s == "object" && Object.values(s).forEach(r => i(r))
    }
    return i(e),
    t
}
function F(e, t) {
    var s;
    const i = ((s = window._t) == null ? void 0 : s[e]) ?? e;
    return !t || i.indexOf("{{") === -1 ? i : i.replace(/\{\{\s*(\w+)\s*\}\}/g, (r, n) => Object.prototype.hasOwnProperty.call(t, n) ? String(t[n]) : "")
}
class Er extends Error {
}
async function Ge(e, t, i={}) {
    var S, _, O;
    const s = Ts(e).with("add", () => window.routes.cart_add_url).with("update", () => window.routes.cart_update_url).with("change", () => window.routes.cart_change_url).with("clear", () => window.routes.cart_clear_url).exhaustive()
      , r = ["cart-button"]
      , n = document.querySelector("cart-drawer")
      , o = document.querySelector(".section-main-cart");
    n && r.push(wt(Qs(n))),
    o && r.push(wt(o));
    const a = {
        ...t
    }
      , c = [...r, ...i.sections || []];
    a.sections = c.join(","),
    i.sectionsUrl ? a.sections_url = i.sectionsUrl : a.sections_url = `${window.location.pathname}${window.location.search}`;
    const h = {
        type: e,
        request: a
    };
    (S = i.onUpdating) == null || S.call(i, h),
    i.eventTarget && m(i.eventTarget, "cart:updating", h, {
        bubbles: !0
    });
    let f, v;
    try {
        f = await Lt(s).post(a).json();
        const P = (_ = i.validateResponse) == null ? void 0 : _.call(i, f);
        if (P)
            throw new Er(P)
    } catch (P) {
        v = Ts(P).when(M => M instanceof pn, M => {
            var D;
            return Tn((D = M.json) == null ? void 0 : D.description).join(`
`)
        }
        ).when(M => M instanceof Er, M => M.message).otherwise( () => null) || F("general.error_message"),
        f = await Ra(c, a.sections_url)
    }
    const $ = {
        type: e,
        request: a,
        response: f,
        error: v
    };
    if ((O = i.onUpdated) == null || O.call(i, $),
    i.eventTarget && m(i.eventTarget, "cart:updated", $, {
        bubbles: !0
    }),
    v)
        throw new Error(v);
    return f
}
async function Ra(e, t) {
    const i = await Lt(`${window.routes.cart_url}.js`).get().json()
      , s = new URL(t,window.location.origin);
    return s.searchParams.set("sections", e.join(",")),
    {
        sections: await Lt(s.toString()).get().json(),
        item_count: i.item_count,
        discount_codes: i.discount_codes
    }
}
async function En(e, t={}) {
    return await Ge("add", e, t)
}
async function qa(e, t, i={}) {
    return await Ge("change", {
        id: e,
        quantity: t
    }, i)
}
async function Ba(e, t, i={}) {
    return await Ge("update", {
        discount: [...t, e].join(",")
    }, {
        ...i,
        validateResponse: s => {
            const r = s.discount_codes.find(n => n.code === e);
            return !r || !r.applicable ? `Discount code "${e}" could not be applied` : null
        }
    })
}
async function Ua(e, t, i={}) {
    const s = t.filter(r => r !== e);
    return await Ge("update", {
        discount: s.join(",")
    }, i)
}
var Ha = Object.defineProperty
  , Na = Object.getOwnPropertyDescriptor
  , ye = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Na(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Ha(t, i, r),
    r
}
;
let Wt = class extends HTMLFormElement {
    constructor() {
        super(...arguments),
        this.updateKeyDebounced = k(this.updateKey.bind(this), 400)
    }
    get discountCodes() {
        return [...this.querySelectorAll("cart-discount-code")].map(e => e.code)
    }
    async updateKey(e, t) {
        if (this.dataset.cartState === "updating")
            return;
        t = Number(t);
        const i = Qs(this)
          , s = wt(i);
        await qa(e, t, {
            eventTarget: this,
            sections: [s],
            onUpdating: () => {
                this.dataset.cartState = "updating"
            }
            ,
            onUpdated: () => {
                delete this.dataset.cartState
            }
        })
    }
    handleSubmit(e) {
        if (this.dataset.cartState) {
            e.preventDefault();
            return
        }
        if (e.submitter instanceof HTMLButtonElement && e.submitter.name === "cart-update") {
            e.preventDefault();
            const t = Mn(this)
              , i = {
                eventTarget: this,
                onUpdating: () => {
                    this.dataset.cartState = "updating"
                }
                ,
                onUpdated: () => {
                    delete this.dataset.cartState
                }
            };
            typeof t.discount == "string" ? Ba(t.discount, this.discountCodes, i) : Ge("update", t, i)
        }
    }
    handleChange(e) {
        if (this.dataset.cartState !== "updating" && e.target instanceof HTMLInputElement && e.target.dataset.key) {
            const t = e.target.dataset.key;
            this.dataset.cartState = "pending",
            m(document, "cart:editing", {
                key: t
            }),
            this.updateKeyDebounced(t, e.target.value)
        }
    }
    handleCartRemove(e) {
        this.dataset.cartState || this.updateKey(e.detail.key, 0)
    }
    handleCartRemoveDiscount(e) {
        this.dataset.cartState || Ua(e.detail.code, this.discountCodes, {
            eventTarget: this,
            onUpdating: () => {
                this.dataset.cartState = "updating"
            }
            ,
            onUpdated: () => {
                delete this.dataset.cartState
            }
        })
    }
    handleKeyDown(e) {
        e.key === "Enter" && e.target instanceof HTMLInputElement && this.querySelector('button[name="checkout"]') && e.preventDefault()
    }
}
;
ye([l("submit")], Wt.prototype, "handleSubmit", 1),
ye([l("change")], Wt.prototype, "handleChange", 1),
ye([l("cart:remove-item")], Wt.prototype, "handleCartRemove", 1),
ye([l("cart:remove-discount")], Wt.prototype, "handleCartRemoveDiscount", 1),
ye([l("keydown")], Wt.prototype, "handleKeyDown", 1),
Wt = ye([d("cart-form", {
    extends: "form"
})], Wt);
var ja = Object.defineProperty
  , Va = Object.getOwnPropertyDescriptor
  , Qi = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Va(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && ja(t, i, r),
    r
}
;
let Le = class extends N {
    constructor() {
        super(...arguments),
        this.active = !1
    }
    activeUpdated(e) {
        const t = E(this, {
            opacity: this.active ? 1 : 0,
            visibility: this.active ? "visible" : "hidden",
            pointerEvents: this.active ? "auto" : "none"
        }, {
            duration: .5
        });
        e === void 0 && t.complete()
    }
    handleCartUpdating() {
        this.active = !0
    }
    handleCartUpdated() {
        this.active = !1
    }
    beforeMorphDOM() {
        return !1
    }
}
;
Qi([b()], Le.prototype, "active", 2),
Qi([l("cart:updating", "section")], Le.prototype, "handleCartUpdating", 1),
Qi([l("cart:updated", "section")], Le.prototype, "handleCartUpdated", 1),
Le = Qi([d("cart-overlay")], Le);
var za = Object.defineProperty
  , Fa = Object.getOwnPropertyDescriptor
  , Ht = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Fa(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && za(t, i, r),
    r
}
;
let $t = class extends HTMLAnchorElement {
    handleClick(e) {
        e.preventDefault(),
        !this.disabled && m(this, "cart:remove-item", {
            key: this.key
        }, {
            bubbles: !0
        })
    }
    handleCartEditing(e) {
        this.disabled = !0
    }
    handleCartUpdating(e) {
        this.disabled = !0,
        e.detail.request.id === this.key && (this.loading = !0)
    }
    handleCartUpdated() {
        this.disabled = !1,
        this.loading = !1
    }
}
;
Ht([g()], $t.prototype, "key", 2),
Ht([g({
    type: Boolean
})], $t.prototype, "loading", 2),
Ht([g({
    type: Boolean
})], $t.prototype, "disabled", 2),
Ht([l("click")], $t.prototype, "handleClick", 1),
Ht([l("cart:editing", document)], $t.prototype, "handleCartEditing", 1),
Ht([l("cart:updating", document)], $t.prototype, "handleCartUpdating", 1),
Ht([l("cart:updated", document)], $t.prototype, "handleCartUpdated", 1),
$t = Ht([d("cart-remove-link", {
    extends: "a"
})], $t);
var Wa = Object.defineProperty
  , Ya = Object.getOwnPropertyDescriptor
  , Dn = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Ya(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Wa(t, i, r),
    r
}
;
let Ds = class extends HTMLElement {
    handleCartUpdated(e) {
        const t = wt(Qs(this));
        e.detail.response.sections[t] && this.updateCartSection(e.detail.response.sections[t])
    }
    updateCartSection(e) {
        const t = dt(e).querySelector("cart-section");
        t && (this.dataset.empty !== t.dataset.empty ? this.innerHTML = t.innerHTML : Gs(this, t),
        Ke(this, t, ["data-empty"]))
    }
}
;
Dn([l("cart:updated", document)], Ds.prototype, "handleCartUpdated", 1),
Ds = Dn([d("cart-section")], Ds);
var Ka = Object.defineProperty
  , Xa = Object.getOwnPropertyDescriptor
  , Ln = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Xa(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Ka(t, i, r),
    r
}
;
let Ei = class extends HTMLElement {
    constructor() {
        super(),
        this.morphOptions = {},
        this.performUpdate = _i(async (t, i, s) => {
            var n, o;
            this.dispatchUpdateStart(),
            await ((n = this.beforeContentUpdate) == null ? void 0 : n.call(this, s, t)),
            t.throwIfAborted();
            let r = 0;
            s === "append" && (r = this.getAppendTarget().children.length);
            try {
                const a = await this.fetchSection(i.url);
                if (t.throwIfAborted(),
                !this.isConnected)
                    return;
                const c = le(a);
                s === "append" ? (this.appendContent(c),
                i.scrollTop !== void 0 && window.scrollTo(0, i.scrollTop)) : (this.updateContent(c),
                i.url !== window.location.href && history.replaceState({}, "", i.url)),
                await ((o = this.afterContentUpdate) == null ? void 0 : o.call(this, s, t)),
                this.restoreFocus(s, r),
                m(this, "section:content-updated", {
                    mode: s,
                    section: c
                }, {
                    bubbles: !0
                })
            } catch (a) {
                (!(a instanceof Error) || a.name !== "AbortError") && (console.error("Failed to update section:", a),
                m(this, "section:error", {
                    error: a
                }, {
                    bubbles: !0
                }))
            } finally {
                t.aborted || this.dispatchUpdateEnd()
            }
        }
        );
        const e = this.fetchOptions;
        this.makeRequest = this.createFetchFunction(e)
    }
    createFetchFunction(e) {
        return Jt(e)
    }
    get $section() {
        return this.closest(".shopify-section") ?? z("Section not found")
    }
    get appendTargetSelector() {
        return this.getAttribute("append-target") ?? "[data-append-target]"
    }
    get fetchOptions() {
        const e = this.getAttribute("fetch-options");
        if (e)
            try {
                return JSON.parse(e)
            } catch {
                console.warn("Invalid fetch-options JSON, using defaults")
            }
        return {
            cache: !0,
            debounce: 500
        }
    }
    async handleSectionUpdate(e) {
        await this.performUpdate(e.detail, e.detail.mode)
    }
    async fetchSection(e) {
        return this.makeRequest(Zs(this.$section, e).toString())
    }
    updateContent(e) {
        const t = ot(e, this.tagName.toLowerCase());
        ut(this, t, this.morphOptions)
    }
    appendContent(e) {
        const t = this.getAppendTarget()
          , i = this.getAppendTarget(e)
          , s = Array.from(t.children).map(n => n.cloneNode(!0));
        i.prepend(...s);
        const r = ot(e, this.tagName.toLowerCase());
        ut(this, r, this.morphOptions)
    }
    getAppendTarget(e=this) {
        return ot(e, this.appendTargetSelector)
    }
    restoreFocus(e, t) {
        if (document.activeElement !== document.body)
            return;
        let i = null;
        if (e === "append") {
            const s = this.getAppendTarget()
              , r = Array.from(s.children).slice(t);
            for (const n of r)
                if (i = Pr(n, !0),
                i)
                    break
        } else
            i = Pr(this);
        i?.focus({
            preventScroll: !0
        })
    }
    dispatchUpdateStart() {
        m(this, "section:updating", void 0, {
            bubbles: !0
        })
    }
    dispatchUpdateEnd() {
        m(this, "section:updated", void 0, {
            bubbles: !0
        })
    }
    async update(e, t="replace") {
        await this.performUpdate({
            url: e,
            mode: t
        }, t)
    }
}
;
Ln([l("section:update")], Ei.prototype, "handleSectionUpdate", 1),
Ei = Ln([d("dynamic-section")], Ei);
var Ga = Object.defineProperty
  , Qa = Object.getOwnPropertyDescriptor
  , nr = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Qa(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Ga(t, i, r),
    r
}
;
let Di = class extends Ei {
    constructor() {
        super(...arguments),
        this.morphOptions = {
            childrenOnly: !0
        }
    }
    createFetchFunction() {
        return Jt({
            cache: !0,
            debounce: 500
        })
    }
    get $collectionGridItems() {
        return [...this.$section.querySelectorAll(".collection-grid-item")]
    }
    get appendTargetSelector() {
        return "[data-product-list]"
    }
    async handleSectionUpdate(e) {
        e.detail.scrollToTop && this.scrollSectionIntoViewIfNeeded(),
        await super.handleSectionUpdate(e)
    }
    handleFilterChange(e) {
        this.scrollSectionIntoViewIfNeeded(),
        this.performUpdate({
            ...e.detail,
            mode: "replace"
        }, "replace")
    }
    async handleViewMode(e) {
        await this.animateItemsOut(),
        this.setAttribute("data-collection-view-mode", e.detail.viewMode),
        this.animateItemsIn()
    }
    async beforeContentUpdate(e, t) {
        e === "replace" && await this.animateItemsOut()
    }
    async afterContentUpdate(e, t) {
        e === "replace" && this.animateItemsIn()
    }
    scrollSectionIntoViewIfNeeded() {
        Et.read( () => {
            const e = this.getBoundingClientRect().top
              , t = Number.parseFloat(getComputedStyle(document.querySelector(".body-scroll-margin")).scrollMarginTop);
            e < t && (this.classList.add("body-scroll-margin"),
            Et.render( () => this.scrollIntoView({
                block: "start",
                behavior: "smooth"
            })))
        }
        )
    }
    async animateItemsOut() {
        return this.animation || this.$collectionGridItems.length === 0 ? this.animation : (this.animation = A(at("product-cards-out", this.$collectionGridItems)),
        this.animation.then( () => {
            this.animation = void 0
        }
        ),
        this.animation)
    }
    animateItemsIn() {
        if (this.$collectionGridItems.length > 0)
            return A(at("product-cards-in", this.$collectionGridItems))
    }
}
;
nr([l("collection:filter-change")], Di.prototype, "handleFilterChange", 1),
nr([l("collection:view-mode")], Di.prototype, "handleViewMode", 1),
Di = nr([d("collection-section")], Di);
var Za = Object.defineProperty
  , Ja = Object.getOwnPropertyDescriptor
  , kn = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Ja(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Za(t, i, r),
    r
}
;
let Li = class extends HTMLElement {
    handleClick(e) {
        if (!(e.target instanceof Element))
            return;
        const t = e.target.closest("a");
        if (t instanceof HTMLAnchorElement && t.href) {
            e.preventDefault(),
            e.stopPropagation();
            const i = this.createUpdateDetail(t);
            this.updateActiveState(t),
            m(this, "section:update", i, {
                bubbles: !0
            })
        }
    }
    createUpdateDetail(e) {
        return {
            url: e.href,
            mode: "replace"
        }
    }
    updateActiveState(e) {
        this.querySelectorAll("[data-active='true']").forEach(t => {
            t.removeAttribute("data-active")
        }
        ),
        e.setAttribute("data-active", "true")
    }
}
;
kn([l("click")], Li.prototype, "handleClick", 1),
Li = kn([d("dynamic-section-links")], Li);
function tl(e) {
    class t extends e {
        get mergedFormData() {
            const s = new FormData(this)
              , r = this.getInputNames();
            return this.getOtherForms().forEach(n => {
                new FormData(n).forEach( (o, a) => {
                    typeof o == "string" && !r.has(a) && (s.getAll(a).includes(o) || s.append(a, o))
                }
                )
            }
            ),
            s
        }
        getInputNames() {
            return new Set([...this.elements].map(s => s.getAttribute("name") ?? "").filter(s => s))
        }
        getOtherForms() {
            const s = this.tagName.toLowerCase()
              , r = this.getAttribute("is")
              , n = r ? `form[is='${r}']` : s;
            return [...document.querySelectorAll(n)].filter(o => o !== this)
        }
    }
    return t
}
var el = Object.getOwnPropertyDescriptor
  , il = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? el(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let Dr = class extends tl(HTMLFormElement) {
    constructor() {
        super(),
        this.addEventListener("change", this.handleChange.bind(this)),
        this.addEventListener("click", this.handleClick.bind(this))
    }
    handleChange() {
        const e = this.buildUrl();
        m(this, "collection:filter-change", {
            url: e.toString()
        }, {
            bubbles: !0
        })
    }
    async handleClick(e) {
        if (!(e.target instanceof Element))
            return;
        const t = e.target.closest("[data-filter-link]");
        t instanceof HTMLAnchorElement && (e.preventDefault(),
        e.stopPropagation(),
        m(this, "collection:filter-change", {
            url: t.href
        }, {
            bubbles: !0
        }))
    }
    buildUrl() {
        const e = sa();
        return this.mergedFormData.forEach( (t, i) => {
            typeof t == "string" && t && e.searchParams.append(i, t)
        }
        ),
        e
    }
}
;
Dr = il([d("filter-form", {
    extends: "form"
})], Dr);
class Rn {
    constructor(t="ltr", i="horizontal") {
        this.mode = t,
        this.direction = i
    }
    getOffset(t) {
        const i = this.direction === "horizontal" ? t.offsetLeft : t.offsetTop;
        return this.mode === "ltr" || this.direction === "vertical" ? i : t.offsetParent instanceof HTMLElement ? -(this.getSize(t.offsetParent, "offset") - this.getSize(t, "offset") - i) : 0
    }
    getSize(t, i) {
        return t[this.getDimensionKey(i)]
    }
    getDimensionKey(t) {
        return `${t}${this.direction === "horizontal" ? "Width" : "Height"}`
    }
    getPadding(t, i) {
        const s = getComputedStyle(t);
        if (this.direction === "horizontal") {
            const r = this.mode === "ltr" ? i === "start" ? "paddingLeft" : "paddingRight" : i === "start" ? "paddingRight" : "paddingLeft";
            return parseFloat(s[r]) || 0
        } else
            return parseFloat(s[i === "start" ? "paddingTop" : "paddingBottom"]) || 0
    }
    getPaddingStart(t) {
        return this.getPadding(t, "start")
    }
    getPaddingEnd(t) {
        return this.getPadding(t, "end")
    }
    getInnerSize(t) {
        return this.getSize(t, "client") - this.getPaddingStart(t) - this.getPaddingEnd(t)
    }
    getScrollSize(t) {
        return this.getSize(t, "scroll") - this.getPaddingStart(t) - this.getPaddingEnd(t)
    }
    getScrollAmount(t) {
        return this.direction === "horizontal" ? this.mode === "rtl" ? -t.scrollLeft : t.scrollLeft : t.scrollTop
    }
    setScrollAmount(t, i) {
        this.direction === "horizontal" ? t.scrollLeft = this.mode === "rtl" ? -i : i : t.scrollTop = i
    }
    getScrollMax(t) {
        return this.getSize(t, "scroll") - this.getSize(t, "client")
    }
    getScrollProgress(t) {
        const i = this.getScrollMax(t);
        return i > 0 ? Math.ceil(this.getScrollAmount(t)) / i : 0
    }
    getScrollRatio(t) {
        const i = this.getScrollSize(t);
        return i > 0 ? this.getInnerSize(t) / i : 0
    }
    getElementEdge(t) {
        const i = t.getBoundingClientRect();
        return this.direction === "horizontal" ? i.left : i.top
    }
    getRelativeOffset(t, i) {
        const s = this.getElementEdge(t)
          , r = this.getElementEdge(i);
        return this.mode === "rtl" && this.direction === "horizontal" ? r - s : s - r
    }
    getMainAxisTranslation(t) {
        return this.direction === "horizontal" ? `translate3d(${this.mode === "ltr" ? -t : t}px, 0, 0)` : `translate3d(0, ${-t}px, 0)`
    }
    isRectInsideMainAxis(t, i, s=0) {
        return this.direction === "horizontal" ? t.left >= i.left - s && t.right <= i.right + s : t.top >= i.top - s && t.bottom <= i.bottom + s
    }
    isRectOverflowingMainAxisEnd(t, i, s=0) {
        return this.direction === "horizontal" ? this.mode === "ltr" ? t.right > i.right - s : t.left < i.left + s : t.bottom > i.bottom - s
    }
    isRectOverflowingMainAxisStart(t, i, s=0) {
        return this.direction === "horizontal" ? this.mode === "ltr" ? t.left < i.left - s : t.right > i.right + s : t.top < i.top - s
    }
}
class sl {
    constructor(t="ltr", i="horizontal") {
        this.state = {
            items: [],
            containerSize: 0,
            scrollAmount: 0
        },
        this.measurement = new Rn(t,i)
    }
    updateMeasurements(t, i, s) {
        this.state.items = this.computeItemOffsets(t),
        this.state.containerSize = this.measurement.getInnerSize(i),
        this.state.scrollAmount = this.measurement.getScrollAmount(s)
    }
    computeItemOffsets(t) {
        if (t.length === 0 || !t[0])
            return [];
        const i = []
          , s = t[0];
        for (let r = 0; r < t.length; r++) {
            const n = t[r];
            if (!n)
                continue;
            const o = r === 0 ? 0 : this.measurement.getRelativeOffset(n, s)
              , a = this.measurement.getSize(n, "client");
            i.push({
                offset: o,
                size: a
            })
        }
        return i
    }
    findNextItem(t=2) {
        const i = this.state.scrollAmount
          , s = this.state.containerSize;
        for (let o = 0; o < this.state.items.length; o++) {
            const a = this.state.items[o];
            if (a && a.offset + a.size > i + s + t)
                return {
                    targetOffset: a.offset,
                    itemIndex: o
                }
        }
        const r = this.state.items.length - 1
          , n = this.state.items[r];
        return n ? {
            targetOffset: n.offset,
            itemIndex: r
        } : null
    }
    findPrevItem(t=2) {
        const i = this.state.scrollAmount
          , s = this.state.containerSize;
        let r = -1;
        for (let n = this.state.items.length - 1; n >= 0; n--) {
            const o = this.state.items[n];
            if (o && o.offset < i - t) {
                r = n;
                break
            }
        }
        if (r === -1 && this.state.items.length > 0)
            return {
                targetOffset: 0,
                itemIndex: 0
            };
        if (r >= 0) {
            const n = this.state.items[r];
            return n ? {
                targetOffset: Math.max(0, n.offset + n.size - s),
                itemIndex: r
            } : null
        }
        return null
    }
    isItemVisible(t) {
        const i = this.state.items[t];
        if (!i)
            return !1;
        const s = this.state.scrollAmount
          , r = i.offset
          , n = r + i.size;
        return r >= s && n <= s + this.state.containerSize
    }
    setScrollAmount(t) {
        this.state.scrollAmount = t
    }
    getEffectiveScrollAmount() {
        return this.state.scrollAmount
    }
    getState() {
        return this.state
    }
    getMeasurement() {
        return this.measurement
    }
}
function Me(e, t) {
    return (e % t + t) % t
}
function rl(e, t, i, s, r, n=!1) {
    let o = (r - e) * (s - i) / (t - e) + i;
    if (n) {
        const a = Math.min(i, s)
          , c = Math.max(i, s);
        o = lt(o, a, c)
    }
    return o
}
var nl = Object.defineProperty
  , ol = Object.getOwnPropertyDescriptor
  , nt = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? ol(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && nl(t, i, r),
    r
}
;
const al = Symbol();
function Zi(e) {
    class t extends e {
        constructor(...s) {
            super(...s),
            this.activeIndex = 0,
            this.loop = !1,
            this.group = "",
            this.itemCount = 0,
            this.hasPrev = !1,
            this.hasNext = !1,
            this.isOverflowing = !1,
            this.firstUpdateDispatched = !1,
            this[al] = !0
        }
        get $activeItem() {
            return null
        }
        connectedCallback() {
            super.connectedCallback(),
            this.id || console.warn(`${this.tagName} requires an 'id' attribute to receive control events`)
        }
        handleControlTrigger(s) {
            s.detail.targetId === this.id && (s.detail.action === "prev" ? this.goPrev() : s.detail.action === "next" ? this.goNext() : typeof s.detail.index == "number" && this.goIndex(s.detail.index))
        }
        handleControlConnected(s) {
            s.detail.targetId === this.id && this.firstUpdateDispatched && this.dispatchCarouselUpdate()
        }
        handleGroupCarouselUpdate(s) {
            s.detail.targetId !== this.id && this.group && this.group === s.detail.group && (this.activeIndex = s.detail.activeIndex)
        }
        updated(s) {
            super.updated(s),
            Wi(s, ["activeIndex", "itemCount", "hasPrev", "hasNext", "isOverflowing"]) && this.dispatchCarouselUpdate()
        }
        updateCarouselState() {
            this.hasPrev = this.loop || this.activeIndex > 0,
            this.hasNext = this.loop || this.activeIndex < this.itemCount - 1,
            this.isOverflowing = this.hasPrev || this.hasNext
        }
        wrapIndex(s) {
            return this.loop ? Me(s, this.itemCount) : lt(s, 0, this.itemCount - 1)
        }
        goPrev() {
            this.activeIndex = this.wrapIndex(this.activeIndex - 1)
        }
        goNext() {
            this.activeIndex = this.wrapIndex(this.activeIndex + 1)
        }
        goIndex(s) {
            this.activeIndex = this.wrapIndex(s)
        }
        getState() {
            return {
                targetId: this.id,
                activeIndex: this.activeIndex,
                activeItem: this.$activeItem,
                itemCount: this.itemCount,
                hasPrev: this.hasPrev,
                hasNext: this.hasNext,
                group: this.group
            }
        }
        dispatchCarouselUpdate() {
            this.firstUpdateDispatched = !0,
            m(this, "carousel:update", this.getState(), {
                bubbles: !0
            })
        }
    }
    return nt([u({
        type: Number
    })], t.prototype, "activeIndex", 2),
    nt([u({
        type: Boolean
    })], t.prototype, "loop", 2),
    nt([u({
        type: String
    })], t.prototype, "group", 2),
    nt([b()], t.prototype, "itemCount", 2),
    nt([b()], t.prototype, "hasPrev", 2),
    nt([b()], t.prototype, "hasNext", 2),
    nt([b()], t.prototype, "isOverflowing", 2),
    nt([l("control:trigger", document)], t.prototype, "handleControlTrigger", 1),
    nt([l("control:connected", document)], t.prototype, "handleControlConnected", 1),
    nt([l("carousel:update", document)], t.prototype, "handleGroupCarouselUpdate", 1),
    t
}
class ll {
    constructor(t, i, s={}) {
        this.element = t,
        this.measurement = i,
        this.animation = null,
        this.options = Fi(s, {
            duration: 600,
            easing: "ease"
        })
    }
    isTransitioning() {
        return this.animation !== null
    }
    resolveFromOffset() {
        if (!this.isTransitioning()) {
            const t = this.measurement.getScrollAmount(this.element);
            return this.transitionScrollRatio = this.measurement.getScrollRatio(this.element),
            this.transitionScrollSize = this.measurement.getScrollSize(this.element),
            this.transitionScrollMax = this.measurement.getScrollMax(this.element),
            this.element.style.overflow = "visible",
            this.element.style.transform = this.measurement.getMainAxisTranslation(t),
            this.lastOffset = t,
            t
        }
        return this.lastOffset ?? 0
    }
    computeDurationMs(t, i) {
        const s = Math.abs(i - t);
        return Math.round(rl(100, 400, 300, 600, s, !0))
    }
    scrollTo(t) {
        var n;
        (n = this.animation) == null || n.stop(),
        this.targetOffset = t;
        const i = this.resolveFromOffset()
          , s = lt(t, 0, this.transitionScrollMax ?? Number.MAX_SAFE_INTEGER)
          , r = this.computeDurationMs(i, s);
        return this.animation = E(this.element, {
            transform: this.measurement.getMainAxisTranslation(s)
        }, {
            duration: r / 1e3,
            ease: this.options.easing,
            clearProps: ["transform", "overflow"]
        }),
        this.lastOffset = s,
        this.animation.finished.then( () => {
            var o, a;
            this.measurement.setScrollAmount(this.element, s),
            this.animation = null,
            this.transitionScrollSize = void 0,
            this.transitionScrollRatio = void 0,
            this.transitionScrollMax = void 0,
            this.targetOffset = void 0,
            this.lastOffset = void 0,
            (a = (o = this.options).onFinish) == null || a.call(o)
        }
        ),
        s
    }
    destroy() {
        var t;
        (t = this.animation) == null || t.complete()
    }
}
var cl = Object.defineProperty
  , hl = Object.getOwnPropertyDescriptor
  , te = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? hl(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && cl(t, i, r),
    r
}
;
let Y = class extends T(x, Zi) {
    constructor() {
        super(!0),
        this.direction = "horizontal",
        this.center = !1,
        this.initializeDebounced = k( () => this.initialize()),
        this.handleResize = po( () => {
            this.initialize()
        }
        , 50, {
            leading: !0
        }),
        this.calculator = new sl(Yi(),this.getAttribute("direction") ?? "horizontal"),
        this.updateComplete.then( () => {
            this.initialize(),
            this.initAnimation(),
            this.scrollAnimator = new ll(this.$track,this.calculator.getMeasurement()),
            new ResizeObserver(this.handleResize).observe(this, {
                box: "border-box"
            })
        }
        )
    }
    get selector() {
        return this.getAttribute("selector") ?? ":scope > *"
    }
    get $items() {
        return [...this.querySelectorAll(this.selector)].filter(e => e instanceof HTMLElement && !e.slot && !e.hidden)
    }
    get scrollProgress() {
        var e;
        return (e = this.scrollAnimator) != null && e.transitionScrollMax && this.scrollAnimator.targetOffset ? this.scrollAnimator.targetOffset / this.scrollAnimator.transitionScrollMax : this.calculator.getMeasurement().getScrollProgress(this.$track)
    }
    get scrollRatio() {
        var e;
        return ((e = this.scrollAnimator) == null ? void 0 : e.transitionScrollRatio) ?? this.calculator.getMeasurement().getScrollRatio(this.$track)
    }
    get scrollAmount() {
        return this.calculator.getMeasurement().getScrollAmount(this.$track)
    }
    get scrollSize() {
        var e;
        return ((e = this.scrollAnimator) == null ? void 0 : e.transitionScrollSize) ?? this.calculator.getMeasurement().getScrollSize(this.$track)
    }
    get scrollMax() {
        var e;
        return ((e = this.scrollAnimator) == null ? void 0 : e.transitionScrollMax) ?? this.calculator.getMeasurement().getScrollMax(this.$track)
    }
    initialize() {
        this.calculator.getMeasurement().setScrollAmount(this.$track, 0),
        this.calculator.updateMeasurements(this.$items, this.$container, this.$track),
        this.itemCount = this.$items.length,
        this.updateCarouselState(),
        this.emitScrollCarouselUpdate(this.scrollAmount, this.scrollSize, this.scrollRatio)
    }
    updateCarouselState() {
        this.isOverflowing = this.scrollRatio < 1 && this.scrollRatio > 0,
        this.hasPrev = this.isOverflowing && this.scrollProgress > 1e-6,
        this.hasNext = this.isOverflowing && this.scrollProgress < .999999
    }
    goNext() {
        const e = this.calculator.findNextItem();
        e && (this.activeIndex = e.itemIndex,
        this.scrollToOffset(e.targetOffset))
    }
    goPrev() {
        const e = this.calculator.findPrevItem();
        e && (this.activeIndex = e.itemIndex,
        this.scrollToOffset(e.targetOffset))
    }
    goIndex(e) {
        this.$items[e] && (this.activeIndex = e,
        this.scrollToItem(this.$items[e]))
    }
    emitScrollCarouselUpdate(e, t, i) {
        m(this, "scroll-carousel:update", {
            ...this.getState(),
            scrollAmount: e,
            scrollSize: t,
            scrollRatio: i
        }, {
            bubbles: !0
        })
    }
    handleSlotChange() {
        this.initializeDebounced()
    }
    handleScroll() {
        if (this.scrollAnimator && !this.scrollAnimator.isTransitioning()) {
            const e = this.calculator.getMeasurement().getScrollAmount(this.$track);
            this.calculator.setScrollAmount(e)
        }
        if (this.itemCount > 0) {
            const e = Math.round(this.scrollProgress * (this.itemCount - 1));
            e !== this.activeIndex && (this.activeIndex = e)
        }
        this.updateCarouselState()
    }
    initAnimation(e=!0) {
        var t;
        (t = this.animationInstance) == null || t.disconnect(),
        this.animation && (this.animationInstance = new Xs({
            root: this,
            selector: this.animationSelector,
            animation: this.animation,
            autoplay: e
        }),
        this.animationInstance.prepare())
    }
    playAnimation() {
        var e;
        (e = this.animationInstance) == null || e.play()
    }
    updateContent(e) {
        this.innerHTML = e,
        this.initAnimation(!1),
        this.playAnimation()
    }
    scrollToOffset(e) {
        if (!this.scrollAnimator)
            return;
        const t = this.scrollAnimator.scrollTo(e);
        this.calculator.setScrollAmount(t),
        this.updateCarouselState(),
        this.emitScrollCarouselUpdate(t, this.scrollSize, this.scrollRatio)
    }
    scrollToItem(e, t=!1) {
        const i = this.$items.indexOf(e);
        if (i === -1 || !t && this.calculator.isItemVisible(i))
            return;
        const r = this.calculator.getState().items[i];
        r && this.scrollToOffset(r.offset)
    }
    beforeMorphDOM(e) {
        return this.initializeDebounced(),
        !0
    }
    render() {
        return p`
      <slot name="before"></slot>
      <div id="center" part="center">
        <div id="container" part="container">
          <div id="track" part="track" @scroll=${this.handleScroll}>
            <slot @slotchange="${this.handleSlotChange}"></slot>
          </div>
        </div>
      </div>
      <slot name="after"></slot>
      ${this.isOverflowing ? p`<slot name="controls"></slot>` : ""}
    `
    }
}
;
Y.styles = [tt`
      :host {
        display: block;
      }

      #container {
        overflow: hidden;
        /* Ensure container itself doesn't get a fixed flex-direction if it becomes a flex container */
        display: block; /* Or whatever is appropriate if it's not meant to be flex */
      }

      #center {
        max-width: 100%;
        min-width: 0;
      }

      :host([center]) #center {
        margin: 0 auto;
        width: max-content;
      }

      /* Feathered edges effect */
      :host([fade]) #container {
        mask-image: linear-gradient(
          to right,
          transparent 0,
          black var(--carousel-bleed-x),
          black calc(100% - var(--carousel-bleed-x)),
          transparent 100%
        );

        mask-size: 100% 100%;
        mask-repeat: no-repeat;
      }

      #track {
        display: flex;
        gap: var(--carousel-gap, 0px);
        scrollbar-width: none;
        position: relative;

        /* Defaults for horizontal */
        flex-direction: row;
        overflow-x: auto;
        overflow-y: hidden;
        overscroll-behavior-x: contain;
        scroll-snap-type: var(--carousel-scroll-snap-type);
      }

      #container,
      #track {
        padding-inline: var(--carousel-bleed-left, var(--carousel-bleed-x, 0px))
          var(--carousel-bleed-right, var(--carousel-bleed-x, 0px));
        padding-block: var(--carousel-bleed-top, var(--carousel-bleed-y, 0px))
          var(--carousel-bleed-bottom, var(--carousel-bleed-y, 0px));

        scroll-padding-inline: var(--carousel-bleed-left, var(--carousel-bleed-x, 0px))
          var(--carousel-bleed-right, var(--carousel-bleed-x, 0px));
        scroll-padding-block: var(--carousel-bleed-top, var(--carousel-bleed-y, 0px))
          var(--carousel-bleed-bottom, var(--carousel-bleed-y, 0px));

        margin-inline: calc(var(--carousel-bleed-left, var(--carousel-bleed-x, 0px)) * -1)
          calc(var(--carousel-bleed-right, var(--carousel-bleed-x, 0px)) * -1);
        margin-block: calc(var(--carousel-bleed-top, var(--carousel-bleed-y, 0px)) * -1)
          calc(var(--carousel-bleed-bottom, var(--carousel-bleed-y, 0px)) * -1);
      }

      :host([direction="vertical"]) #track {
        flex-direction: column;
        overflow-x: hidden;
        overflow-y: auto;
        overscroll-behavior-x: auto; /* Reset for vertical */
        overscroll-behavior-y: contain;
      }

      #track::-webkit-scrollbar {
        display: none;
      }

      ::slotted(*) {
        /* transform: translateZ(0);
        backface-visibility: hidden; */
        flex: none;
      }
    `],
te([u({
    type: String
})], Y.prototype, "direction", 2),
te([u({
    type: String
})], Y.prototype, "animation", 2),
te([u({
    type: String,
    attribute: "animation-selector"
})], Y.prototype, "animationSelector", 2),
te([u({
    type: Boolean,
    reflect: !0
})], Y.prototype, "center", 2),
te([C("#container")], Y.prototype, "$container", 2),
te([C("#track")], Y.prototype, "$track", 2),
Y = te([d("scroll-carousel")], Y);
var dl = Object.defineProperty
  , ul = Object.getOwnPropertyDescriptor
  , pl = Object.getPrototypeOf
  , fl = Reflect.get
  , or = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? ul(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && dl(t, i, r),
    r
}
  , ml = (e, t, i) => fl(pl(e), i, t);
let zt = class extends Y {
    constructor() {
        super(...arguments),
        this.wrap = !1,
        this.wrapOnDesktop = !1,
        this.desktopQuery = new Ut(this,"(min-width: 768px)",e => {
            this.wrapOnDesktop && this.toggleAttribute("wrap", e)
        }
        )
    }
    wrapOnDesktopUpdated() {
        this.wrapOnDesktop && this.toggleAttribute("wrap", this.desktopQuery.matches)
    }
}
;
zt.styles = [...ml(zt, zt, "styles"), tt`
      :host {
        --carousel-columns: 3;
        --carousel-columns-offset: 0;
      }

      #track {
        --carousel-columns-actual: clamp(
          var(--carousel-columns-min, 1),
          var(--carousel-columns, 3) + var(--carousel-columns-offset, 0),
          var(--carousel-columns-max, 9999)
        );
        --carousel-item-width: calc(
          (100% / var(--carousel-columns-actual)) -
            (
              var(--carousel-gap, 0px) / var(--carousel-columns-actual) *
                (var(--carousel-columns-actual) - 1)
            )
        );

        display: grid;
        grid: auto / auto-flow var(--carousel-item-width);
      }

      :host([wrap]) #container {
        overflow: visible;
      }

      :host([wrap]) #track {
        overflow: visible;
        overscroll-behavior-x: auto;
        grid-template-columns: repeat(auto-fill, var(--carousel-item-width));
        grid-auto-flow: row;
        row-gap: var(--carousel-row-gap, var(--carousel-gap, 0px));
      }

      ::slotted(*) {
        min-width: 0;
      }
    `],
or([u({
    type: Boolean
})], zt.prototype, "wrap", 2),
or([u({
    type: Boolean,
    attribute: "wrap-on-desktop"
})], zt.prototype, "wrapOnDesktop", 2),
zt = or([d("grid-carousel")], zt);
var gl = Object.defineProperty
  , vl = Object.getOwnPropertyDescriptor
  , ar = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? vl(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && gl(t, i, r),
    r
}
;
const Lr = 500
  , ws = new Set;
let ki = class extends HTMLElement {
    constructor() {
        super(...arguments),
        this._isSetup = !1
    }
    get $lqipImages() {
        var e;
        return Array.from(((e = this.$lqipOverlay) == null ? void 0 : e.querySelectorAll("img")) ?? [])
    }
    connectedCallback() {
        this.setupAndStart()
    }
    setupAndStart() {
        if (!this._isSetup && (this._isSetup = !0,
        this.$mainImage = this.findMainImage(),
        this.$overlay = this.querySelector('[data-part="overlay"]') ?? void 0,
        this.$lqipOverlay = this.querySelector('[data-part="lqip"]') ?? void 0,
        this.initializeLoader(),
        this.animation && this.animation.trim() !== "")) {
            const e = this.querySelector('[data-part="animation-root"]')
              , t = e instanceof HTMLElement ? e : this;
            this.animationInstance = new Xs({
                root: t,
                animation: this.animation,
                autoplay: !this.test,
                waitForImages: !0
            }),
            this.test && Zt(2e3).then( () => {
                var i;
                return (i = this.animationInstance) == null ? void 0 : i.play()
            }
            ),
            this.animationInstance.prepare()
        }
    }
    findMainImage() {
        return this.querySelector("picture img") ?? void 0
    }
    async initializeLoader() {
        var e;
        if (this.isImageAlreadyLoaded() || !this.$overlay) {
            (e = this.$overlay) == null || e.classList.remove("active", "lqip", "loaded"),
            ws.add(this.getImageKey());
            return
        }
        this.$overlay.classList.remove("loaded", "lqip"),
        this.$overlay.classList.add("active"),
        this.$lqipImages.length && await this.handleLqipLoading(),
        await this.handleMainImageLoading(),
        this.$overlay.classList.add("loaded"),
        setTimeout( () => {
            requestIdleCallback( () => {
                var t;
                (t = this.$overlay) == null || t.classList.remove("active", "lqip", "loaded")
            }
            )
        }
        , 3e3)
    }
    getImageKey() {
        return this.$mainImage ? `${this.$mainImage.src}#${this.$mainImage.srcset}#${this.$mainImage.sizes}` : ""
    }
    isImageAlreadyLoaded() {
        return !!(ws.has(this.getImageKey()) || !this.$mainImage || this.$mainImage.complete && this.$mainImage.src)
    }
    async handleLqipLoading() {
        var e;
        this.$lqipImages.length !== 0 && (await xi(this.$lqipImages),
        await De({
            timeout: Lr
        }),
        (e = this.$overlay) == null || e.classList.add("lqip"))
    }
    async handleMainImageLoading() {
        this.$mainImage && (await xi(this.$mainImage),
        ws.add(this.getImageKey()),
        await De({
            timeout: Lr
        }))
    }
    removeLqipElements() {
        var e, t;
        this.test || ((e = this.$lqipOverlay) == null || e.remove(),
        (t = this.$overlay) == null || t.remove())
    }
    beforeMorphDOM(e) {
        return queueMicrotask( () => {
            this._isSetup = !1,
            this.setupAndStart()
        }
        ),
        !0
    }
    disconnectedCallback() {
        var e;
        (e = this.animationInstance) == null || e.disconnect()
    }
}
;
ar([g({
    type: Boolean
})], ki.prototype, "test", 2),
ar([g({
    type: String,
    optional: !0
})], ki.prototype, "animation", 2),
ki = ar([d("image-loader")], ki);
var yl = Object.getOwnPropertyDescriptor
  , bl = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? yl(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let kr = class extends HTMLElement {
    constructor() {
        super(),
        yn( () => {
            this.animate({
                opacity: "0"
            }, {
                duration: 250
            }).finished.finally( () => {
                this.style.display = "none"
            }
            )
        }
        ),
        window.addEventListener("click", this.handleLinkClick.bind(this)),
        window.addEventListener("pageshow", e => {
            e.persisted && document.body.classList.remove("unloading")
        }
        )
    }
    handleLinkClick(e) {
        if (e.defaultPrevented || Ks())
            return;
        const t = e.composedPath().find(i => i instanceof HTMLAnchorElement);
        if (t && t.href && t.origin === window.location.origin && !t.href.includes("#") && t.target !== "_blank") {
            if (e.preventDefault(),
            document.body.classList.add("unloading"),
            !document.querySelector(`link[rel="prefetch"][href="${t.href}"]`)) {
                const s = document.createElement("link");
                s.rel = "prefetch",
                s.fetchPriority = "high",
                s.as = "document",
                s.href = t.href,
                document.head.appendChild(s)
            }
            setTimeout( () => {
                window.location.href = t.href
            }
            , 200)
        }
    }
}
;
kr = bl([d("loading-screen")], kr);
var wl = Object.defineProperty
  , $l = Object.getOwnPropertyDescriptor
  , Ji = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? $l(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && wl(t, i, r),
    r
}
;
let ke = class extends Y {
    constructor() {
        super(...arguments),
        this.selectedIndex = -1
    }
    get controlsId() {
        return this.getAttribute("aria-controls") ?? ""
    }
    selectedIndexUpdated() {
        this.$items.forEach( (t, i) => {
            t.classList.toggle("active", i === this.selectedIndex)
        }
        );
        const e = this.$items[this.selectedIndex];
        e && this.scrollToItem(e)
    }
    handleMediaCarouselUpdated(e) {
        e.detail.targetId === this.controlsId && (this.selectedIndex = e.detail.activeIndex)
    }
    handleClick(e) {
        const t = e.target.closest("[data-media-id]");
        if (!t)
            return;
        const i = this.$items.indexOf(t);
        i !== -1 && (this.selectedIndex = i,
        m(document, "control:trigger", {
            targetId: this.controlsId,
            action: "index",
            index: i
        }, {
            bubbles: !0
        }))
    }
    beforeMorphDOM(e) {
        return zs(this, e, {
            childrenOnly: !0,
            onBeforeElUpdated(t, i) {
                return t.hidden = i.hidden,
                !1
            }
        }),
        this.initialize(),
        this.selectedIndexUpdated(),
        this.dispatchCarouselUpdate(),
        !1
    }
}
;
Ji([b()], ke.prototype, "selectedIndex", 2),
Ji([l("carousel:update", document)], ke.prototype, "handleMediaCarouselUpdated", 1),
Ji([l("click")], ke.prototype, "handleClick", 1),
ke = Ji([d("media-carousel-thumbnails")], ke);
const Sl = "modulepreload"
  , Cl = function(e) {
    return "/" + e
}
  , Rr = {}
  , qr = function(t, i, s) {
    let r = Promise.resolve();
    if (i && i.length > 0) {
        let o = function(h) {
            return Promise.all(h.map(f => Promise.resolve(f).then(v => ({
                status: "fulfilled",
                value: v
            }), v => ({
                status: "rejected",
                reason: v
            }))))
        };
        document.getElementsByTagName("link");
        const a = document.querySelector("meta[property=csp-nonce]")
          , c = a?.nonce || a?.getAttribute("nonce");
        r = o(i.map(h => {
            if (h = Cl(h),
            h in Rr)
                return;
            Rr[h] = !0;
            const f = h.endsWith(".css")
              , v = f ? '[rel="stylesheet"]' : "";
            if (document.querySelector(`link[href="${h}"]${v}`))
                return;
            const $ = document.createElement("link");
            if ($.rel = f ? "stylesheet" : Sl,
            f || ($.as = "script"),
            $.crossOrigin = "",
            $.href = h,
            c && $.setAttribute("nonce", c),
            document.head.appendChild($),
            f)
                return new Promise( (S, _) => {
                    $.addEventListener("load", S),
                    $.addEventListener("error", () => _(new Error(`Unable to preload CSS for ${h}`)))
                }
                )
        }
        ))
    }
    function n(o) {
        const a = new Event("vite:preloadError",{
            cancelable: !0
        });
        if (a.payload = o,
        window.dispatchEvent(a),
        !a.defaultPrevented)
            throw o
    }
    return r.then(o => {
        for (const a of o || [])
            a.status === "rejected" && n(a.reason);
        return t().catch(n)
    }
    )
};
class xl {
    constructor(t) {
        this.container = t,
        this.cssLoaded = !1,
        this.loading = !1
    }
    async show(t=null) {
        if (this.loading)
            throw new Error("Lightbox is already loading");
        this.loading = !0;
        try {
            const [i] = await Promise.all([qr( () => import("./photoswipe.esm.js"), []), this.cssLoaded ? Promise.resolve() : this.loadCss()]);
            this.loading = !1,
            this.cssLoaded = !0;
            const s = this.buildDataSource()
              , r = this.findInitialIndex(s, t)
              , n = this.initializePhotoSwipe(i.default, s, r);
            return n.init(),
            n
        } finally {
            this.loading = !1
        }
    }
    buildDataSource() {
        return this.getImageElements().map(t => {
            const i = t.querySelector("img")
              , s = t;
            return {
                src: this.getOriginalImageUrl(i.src),
                alt: i.alt,
                width: parseInt(s.dataset.mediaWidth || "0", 10),
                height: parseInt(s.dataset.mediaHeight || "0", 10),
                mediaId: s.dataset.mediaId || ""
            }
        }
        )
    }
    getImageElements() {
        return [...this.container.querySelectorAll("[data-media-type=image]")].filter(t => !t.closest("[hidden]"))
    }
    findInitialIndex(t, i) {
        if (!i)
            return 0;
        const s = t.findIndex(r => r.mediaId === i);
        return s === -1 ? 0 : s
    }
    initializePhotoSwipe(t, i, s) {
        const r = new t({
            bgOpacity: 1,
            mainClass: "pswp--custom",
            dataSource: i,
            index: s,
            returnFocus: !1,
            counter: !1,
            zoom: !1,
            close: !1,
            arrowPrev: !1,
            arrowNext: !1,
            preloader: !1
        });
        return this.setupPhotoSwipeFilters(r),
        this.setupCustomUI(r, i),
        this.setupFocusTrap(r),
        r
    }
    setupFocusTrap(t) {
        t.on("initialLayout", () => {
            t.element && (this.focusTrap || (this.focusTrap = zi(t.element, {
                escapeDeactivates: !1,
                returnFocusOnDeactivate: !0,
                preventScroll: !0,
                allowOutsideClick: !0,
                initialFocus: !1
            })),
            this.focusTrap.activate())
        }
        ),
        t.on("destroy", () => {
            var i;
            (i = this.focusTrap) == null || i.deactivate(),
            this.focusTrap = void 0
        }
        )
    }
    setupPhotoSwipeFilters(t) {
        t.addFilter("thumbEl", (i, s) => this.container.querySelector(`[data-media-id="${s.mediaId}"] img`) ?? i),
        t.addFilter("thumbBounds", (i, s) => {
            const r = this.container.querySelector(`[data-media-id="${s.mediaId}"] img`);
            if (!r)
                return i;
            const n = r.getBoundingClientRect();
            return this.calculateThumbBounds(s, n)
        }
        ),
        t.addFilter("placeholderSrc", (i, s) => {
            const r = this.container.querySelector(`[data-media-id="${s.data.mediaId}"] img`);
            return r ? r.currentSrc : i
        }
        )
    }
    setupCustomUI(t, i) {
        t.on("uiRegister", () => {
            var s, r, n;
            i.length > 1 && ((s = t.ui) == null || s.registerElement({
                name: "prev",
                ariaLabel: F("accessibility.previous_image"),
                isButton: !0,
                html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" class="icon-chevron-down">
          <rect width="256" height="256" fill="none"/><polyline points="208 96 128 176 48 96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="20"/>
        </svg>`,
                onClick: () => {
                    t.prev()
                }
            })),
            (r = t.ui) == null || r.registerElement({
                name: "close-custom",
                ariaLabel: F("accessibility.close"),
                isButton: !0,
                html: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 19L19 5" stroke="currentColor" stroke-width="2" />
          <path d="M5 5L19 19" stroke="currentColor" stroke-width="2" />
        </svg>`,
                onClick: () => {
                    t.close()
                }
            }),
            i.length > 1 && ((n = t.ui) == null || n.registerElement({
                name: "next",
                ariaLabel: F("accessibility.next_image"),
                isButton: !0,
                html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" class="icon-chevron-down">
          <rect width="256" height="256" fill="none"/><polyline points="208 96 128 176 48 96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="20"/>
        </svg>`,
                onClick: () => {
                    t.next()
                }
            }))
        }
        )
    }
    getOriginalImageUrl(t) {
        try {
            const i = new URL(t);
            return i.searchParams.delete("width"),
            i.toString()
        } catch {
            return t
        }
    }
    calculateThumbBounds(t, i) {
        const {width: s, height: r} = t
          , n = i.width / i.height
          , o = s / r;
        let a, c;
        o > n ? (a = i.width,
        c = i.width / o) : (c = i.height,
        a = i.height * o);
        const h = i.x + (i.width - a) / 2
          , f = i.y + (i.height - c) / 2;
        return {
            x: h,
            y: f,
            w: a
        }
    }
    async loadCss() {
        if (document.querySelector("#photoswipe-style"))
            return;
        const {default: t} = await qr(async () => {
            const {default: s} = await import("./photoswipe.js");
            return {
                default: s
            }
        }
        , [])
          , i = document.createElement("style");
        i.id = "photoswipe-style",
        i.textContent = t,
        document.head.prepend(i)
    }
}
var _l = Object.defineProperty
  , Ol = Object.getOwnPropertyDescriptor
  , ts = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Ol(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && _l(t, i, r),
    r
}
;
let Re = class extends HTMLElement {
    constructor() {
        super(...arguments),
        this.lightbox = new xl(this)
    }
    get openTarget() {
        return this.getAttribute("open-target")
    }
    async handleLightboxOpen(e) {
        await this.openLightbox(e.detail.mediaId)
    }
    handleClick(e) {
        if (!this.openTarget)
            return;
        const t = e.target instanceof HTMLElement && e.target.closest(this.openTarget);
        t instanceof HTMLElement && t.dataset.mediaType === "image" && this.openLightbox(t.dataset.mediaId)
    }
    handleKeydown(e) {
        if (e.key === "Enter") {
            if (!this.openTarget)
                return;
            const t = e.target instanceof HTMLElement && e.target.closest(this.openTarget);
            t instanceof HTMLElement && t.dataset.mediaType === "image" && this.openLightbox(t.dataset.mediaId)
        }
    }
    async openLightbox(e) {
        const t = await this.lightbox.show(e);
        t.on("change", () => {
            var i;
            m(this, "lightbox:change", {
                index: t.currIndex,
                mediaId: (i = t.currSlide) == null ? void 0 : i.data.mediaId
            }, {
                bubbles: !0
            })
        }
        )
    }
}
;
ts([l("lightbox:open")], Re.prototype, "handleLightboxOpen", 1),
ts([l("click")], Re.prototype, "handleClick", 1),
ts([l("keydown")], Re.prototype, "handleKeydown", 1),
Re = ts([d("media-lightbox")], Re);
var Pl = Object.defineProperty
  , Il = Object.getOwnPropertyDescriptor
  , Qe = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Il(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Pl(t, i, r),
    r
}
;
class Nt extends x {
    constructor() {
        super(...arguments),
        this.mediaId = "",
        this.loadingState = "idle",
        this.playing = !1
    }
    play() {
        this.playing = !0
    }
    pause() {
        this.playing = !1
    }
    playingUpdated(t) {
        t !== void 0 && this.playing ? m(this, "media:playing", void 0, {
            bubbles: !0
        }) : t !== void 0 && !this.playing && m(this, "media:paused", void 0, {
            bubbles: !0
        })
    }
    handleMediaPlay(t) {
        const {mediaId: i, container: s} = t.detail;
        !this.playing && i === this.mediaId && s.contains(this) && this.play()
    }
    handleMediaPause(t) {
        const {mediaId: i, container: s} = t.detail;
        s.contains(this) && this.playing && (i === "*" || i === this.mediaId) && this.pause()
    }
    cloneFromTemplate(t="*") {
        var s, r;
        const i = (r = (s = this.querySelector("template")) == null ? void 0 : s.content.querySelector(t)) == null ? void 0 : r.cloneNode(!0);
        if (!(i instanceof HTMLElement))
            throw new Error("Media template not found");
        return i
    }
    renderLoadingSpinner() {
        return p`<svg
      width="64"
      height="64"
      class="spinner"
      stroke="white"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g class="spinner__inner">
        <circle cx="12" cy="12" r="9.5" fill="none" stroke-width="1.5"></circle>
      </g>
    </svg>`
    }
}
Qe([u({
    type: String,
    attribute: "media-id"
})], Nt.prototype, "mediaId", 2),
Qe([b()], Nt.prototype, "loadingState", 2),
Qe([b()], Nt.prototype, "playing", 2),
Qe([l("media:play", document)], Nt.prototype, "handleMediaPlay", 1),
Qe([l("media:pause", document)], Nt.prototype, "handleMediaPause", 1);
var Al = Object.defineProperty
  , Ml = Object.getOwnPropertyDescriptor
  , Ze = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Ml(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Al(t, i, r),
    r
}
;
let Yt = class extends Nt {
    constructor() {
        super(...arguments),
        this.shadowDOM = !0
    }
    async play() {
        var e, t;
        super.play(),
        this.loadingState === "idle" && (this.loadingState = "loading",
        await this.createModelViewer(),
        this.loadingState = "loaded",
        E(this.$poster, {
            opacity: 0
        }, {
            duration: .5,
            delay: .1
        }).then( () => {
            this.$poster.style.display = "none"
        }
        )),
        (e = this.$modelViewer) != null && e.shadowRoot && ((t = this.$modelViewer.shadowRoot.querySelector(".userInput")) == null || t.focus()),
        this.runAnimations()
    }
    pause() {
        super.pause(),
        this.runAnimations(),
        document.fullscreenElement && document.exitFullscreen(),
        this.resetCamera()
    }
    firstUpdated() {
        this.runAnimations(!0)
    }
    runAnimations(e=!1) {
        let t, i;
        !this.playing && this.loadingState === "loaded" ? t = E(this.$pauseOverlay, {
            opacity: 1,
            visibility: "visible",
            pointerEvents: "auto"
        }, {
            duration: .2
        }) : t = E(this.$pauseOverlay, {
            opacity: 0,
            visibility: "hidden",
            pointerEvents: "none"
        }, {
            duration: .2
        }),
        this.playing && this.loadingState === "loaded" ? i = E(this.$menu, {
            opacity: 1,
            visibility: "visible"
        }, {
            duration: .2
        }) : i = E(this.$menu, {
            opacity: 0,
            visibility: "hidden"
        }, {
            duration: .2
        }),
        e && (t.complete(),
        i.complete())
    }
    async createModelViewer() {
        this.$modelViewer = this.cloneFromTemplate("model-viewer"),
        this.$modelViewer.slot = "model-viewer",
        this.$modelViewer.addEventListener("load", () => {
            var e;
            this.initialOrbit = (e = this.$modelViewer) == null ? void 0 : e.getCameraOrbit().toString()
        }
        , {
            once: !0
        }),
        this.$modelViewer.poster && await bn(this.$modelViewer.poster),
        this.appendChild(this.$modelViewer),
        await Ft("model-viewer")
    }
    async toggleFullscreen() {
        document.fullscreenElement ? await document.exitFullscreen() : await this.$wrapper.requestFullscreen()
    }
    resetCamera() {
        this.$modelViewer && (this.initialOrbit && (this.$modelViewer.cameraOrbit = this.initialOrbit),
        this.$modelViewer.fieldOfView = "45deg")
    }
    render() {
        return p`
      <div class="grid-stack grid size-full">
        ${this.renderViewer()} ${this.renderPoster()}

        <div id="pause-overlay" @click=${ () => this.play()} class="poster z-10">
          <button class="poster-button" aria-label="View 3D model">
            <icon-element icon="model-button"></icon-element>
          </button>
        </div>
      </div>
    `
    }
    renderViewer() {
        return p`
      <div id="wrapper">
        <slot name="model-viewer"></slot>
        <div class="model-viewer-menu">
          <button class="model-viewer-button" @click=${ () => this.pause()}>
            <icon-element icon="close"></icon-element>
          </button>
          <div class="grow"></div>
          <button class="model-viewer-button" @click=${ () => {
            var e;
            return (e = this.$modelViewer) == null ? void 0 : e.zoom(3)
        }
        }>
            <icon-element icon="plus"></icon-element>
          </button>
          <button class="model-viewer-button" @click=${ () => {
            var e;
            return (e = this.$modelViewer) == null ? void 0 : e.zoom(-3)
        }
        }>
            <icon-element icon="minus"></icon-element>
          </button>
          <button class="model-viewer-button" @click=${ () => this.toggleFullscreen()}>
            <icon-element icon="fullscreen"></icon-element>
          </button>
        </div>
      </div>
    `
    }
    renderPoster() {
        return p`
      <button @click=${ () => this.play()} class="poster" aria-label="View 3D model">
        <slot name="poster"></slot>
        <div class="poster-button">
          ${this.loadingState !== "idle" ? this.renderLoadingSpinner() : p`<icon-element icon="model-button"></icon-element>`}
        </div>
      </button>
    `
    }
}
;
Yt.styles = [x.themeCSS, tt`
      ::slotted(model-viewer) {
        width: 100%;
        height: auto;
        aspect-ratio: 1;
        --progress-bar-color: rgb(var(--text-color));
      }

      #wrapper {
        position: relative;
      }

      #wrapper:fullscreen {
        background: white;
      }

      #wrapper:fullscreen ::slotted(model-viewer) {
        position: absolute;
        width: 100%;
        height: 100%;
        aspect-ratio: auto;
      }
    `],
Ze([C("#wrapper")], Yt.prototype, "$wrapper", 2),
Ze([C(".poster")], Yt.prototype, "$poster", 2),
Ze([C("#pause-overlay")], Yt.prototype, "$pauseOverlay", 2),
Ze([C(".model-viewer-menu")], Yt.prototype, "$menu", 2),
Yt = Ze([d("model-media")], Yt);
var Tl = Object.defineProperty
  , El = Object.getOwnPropertyDescriptor
  , es = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? El(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Tl(t, i, r),
    r
}
;
let qe = class extends x {
    constructor() {
        super(),
        this.pageStack = [],
        this.skipTransition = !1
    }
    connectedCallback() {
        this.goHome(),
        super.connectedCallback()
    }
    get $pages() {
        return [...this.querySelectorAll("[data-page]")]
    }
    get $currentPage() {
        return this.pageStack.length === 0 ? null : this.querySelector(`[data-page="${this.pageStack.at(-1) ?? ""}"]`)
    }
    get $parent() {
        var e;
        return ((e = this.parentElement) == null ? void 0 : e.closest(this.getAttribute("parent") ?? "*")) ?? null
    }
    goHome() {
        var e;
        (e = this.$pages[0]) != null && e.dataset.page && (this.pageStack = [this.$pages[0].dataset.page])
    }
    goBack() {
        this.pageStack.length > 1 && (this.pageStack = this.pageStack.slice(0, -1))
    }
    goPage(e) {
        if (this.pageStack.at(-1) === e)
            return;
        const t = this.pageStack.indexOf(e);
        t !== -1 ? this.pageStack = this.pageStack.slice(0, t + 1) : this.pageStack = [...this.pageStack, e]
    }
    handleClick(e) {
        if (!(e.target instanceof Element))
            return;
        const t = e.target.closest("[data-page-link]");
        t && (e.preventDefault(),
        this.goPage(t.dataset.pageLink)),
        e.target.closest("[data-page-back]") && this.goBack()
    }
    handleModalShow() {
        this.skipTransition = !0,
        this.goHome()
    }
    pageStackUpdated(e) {
        var s;
        const t = e ? this.$pages.find(r => r.dataset.page === e.at(-1)) : void 0
          , i = e ? Math.sign(this.pageStack.length - e.length) : 0;
        this.skipTransition || !this.$currentPage || !t || i === 0 || this.$currentPage === t ? (ht(this.$pages),
        w(this.$pages, r => ({
            display: r === this.$currentPage ? "" : "none"
        })),
        this.skipTransition = !1) : ((s = this.transition) == null || s.stop(),
        w(this.$pages, r => ({
            display: r === t ? "" : "none",
            height: "",
            position: ""
        })),
        this.transition = this.animatePageTransition(this.$currentPage, t, i)),
        this.$currentPage && (this.$currentPage.tabIndex = -1,
        e !== void 0 && this.$currentPage.focus({
            preventScroll: !0
        }))
    }
    animatePageTransition(e, t, i) {
        wn(e),
        w(t, {
            height: `${t.clientHeight}px`,
            position: "absolute"
        }),
        w(e, {
            display: ""
        });
        const s = [];
        return s.push(...this.getPreviousPageTransition(t, i)),
        s.push(...this.getCurrentPageTransition(e, i)),
        A(s).tap(r => {
            r.then( () => {
                w(t, {
                    display: "none"
                })
            }
            )
        }
        )
    }
    getPreviousPageTransition(e, t) {
        return [[e, {
            transform: `translateX(${t === 1 ? "-10%" : "100%"}) scale(${t === 1 ? "0.97" : "1"})`,
            opacity: t === 1 ? 0 : 1
        }, {
            duration: .3,
            ease: "power1.inOut"
        }]]
    }
    getCurrentPageTransition(e, t) {
        return [[e, {
            transform: [`translateX(${t === 1 ? "100%" : "-10%"}) scale(${t === 1 ? "1" : "0.97"})`, "translateX(0%)"],
            opacity: 1
        }, {
            duration: .4,
            ease: "power3.out",
            at: "<"
        }]]
    }
}
;
es([b()], qe.prototype, "pageStack", 2),
es([l("click")], qe.prototype, "handleClick", 1),
es([l("modal:show", e => e.$parent)], qe.prototype, "handleModalShow", 1),
qe = es([d("page-navigation")], qe);
var Dl = Object.getOwnPropertyDescriptor
  , Ll = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Dl(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let Br = class extends Li {
    get $pageLinks() {
        return Array.from(this.querySelectorAll("[data-part=links]"))
    }
    get $currentActivePage() {
        return this.$pageLinks.find(e => e.matches("[data-active=true]"))
    }
    createUpdateDetail(e) {
        return {
            ...super.createUpdateDetail(e),
            scrollToTop: this.isForwardNavigation(e)
        }
    }
    updateActiveState(e) {
        const t = e.getAttribute("data-part");
        t === "prev" || t === "next" ? this.navigateToAdjacentPage(t) : super.updateActiveState(e)
    }
    isForwardNavigation(e) {
        var n, o;
        const t = e.getAttribute("data-part");
        if (t === "next")
            return !0;
        if (t === "prev")
            return !1;
        const i = this.$currentActivePage;
        if (!i)
            return !1;
        const s = parseInt(((n = i.textContent) == null ? void 0 : n.trim()) ?? "0", 10);
        return parseInt(((o = e.textContent) == null ? void 0 : o.trim()) ?? "0", 10) > s
    }
    navigateToAdjacentPage(e) {
        const t = this.$currentActivePage;
        if (!t)
            return;
        const s = this.$pageLinks.indexOf(t) + (e === "next" ? 1 : -1)
          , r = this.$pageLinks[s];
        r && (this.clearActiveStates(),
        r.setAttribute("data-active", "true"))
    }
    clearActiveStates() {
        this.$pageLinks.forEach(e => e.removeAttribute("data-active"))
    }
}
;
Br = Ll([d("pagination-element")], Br);
function kl(e, t, i, s, r, n=-12) {
    if (!s.arrow)
        return;
    const o = `${n}px`
      , {x: a, y: c} = s.arrow
      , h = r.split("-")
      , f = h[0] || "bottom"
      , $ = h[1] != null
      , S = {
        top: "",
        bottom: "",
        left: "",
        right: ""
    }
      , O = {
        top: "bottom",
        bottom: "top",
        left: "right",
        right: "left"
    }[f] || "top"
      , M = {
        top: "180deg",
        bottom: "0deg",
        left: "90deg",
        right: "-90deg"
    }[f] || "0deg";
    e.style.transform = `rotate(${M})`;
    const D = t.getBoundingClientRect()
      , R = D.width > i.clientWidth
      , rt = D.height > i.clientWidth;
    if ($ && (f === "top" || f === "bottom" ? R : rt)) {
        const li = {
            "top-start": "left",
            "top-end": "right",
            "bottom-start": "left",
            "bottom-end": "right",
            "left-start": "top",
            "left-end": "bottom",
            "right-start": "top",
            "right-end": "bottom"
        }[r] || "left";
        Object.assign(e.style, S),
        e.style[O] = o,
        e.style[li] = "min(15%, 15px)"
    } else
        Object.assign(e.style, S),
        a != null && (e.style.left = `${a}px`),
        c != null && (e.style.top = `${c}px`),
        e.style[O] = o
}
function Rl(e, t, i) {
    const [s="bottom",r="center"] = e.split("-")
      , n = s === "left" || s === "right"
      , o = s === "top" || s === "bottom";
    if (t) {
        const v = i?.clientWidth || 0
          , $ = i?.clientHeight || 0
          , S = $ / 2
          , _ = v / 2;
        if (n && typeof t.y == "number") {
            const O = s === "left" ? `calc(100% + ${v}px)` : `-${v}px`
              , P = `${t.y + S}px`;
            return `${O} ${P}`
        }
        if (o && typeof t.x == "number") {
            const O = `${t.x + _}px`
              , P = s === "top" ? `calc(100% + ${$}px)` : `-${$}px`;
            return `${O} ${P}`
        }
    }
    const c = {
        top: "bottom",
        bottom: "top",
        left: "left",
        right: "right"
    }[s] || s
      , f = {
        start: "left",
        end: "right",
        center: "center"
    }[r] || "center";
    return n ? `${f} ${c}` : `${c} ${f}`
}
class ql extends it {
    constructor(t, i) {
        super(t),
        this.options = Fi(i, {
            flip: !0,
            maxHeight: 1 / 0
        }),
        t.addController(this)
    }
    hostConnected() {
        this.boundary = this.host.closest("[data-floating-boundary]") ?? void 0
    }
    hostDisconnected() {
        this.stopAutoUpdatePositioning()
    }
    updateOptions(t) {
        Object.assign(this.options, t)
    }
    startAutoUpdate() {
        var t;
        (t = this.stopAutoUpdate) == null || t.call(this),
        this.updatePosition(),
        this.stopAutoUpdate = fo(this.options.reference, this.options.floating, this.updatePosition.bind(this))
    }
    stopAutoUpdatePositioning() {
        var t;
        (t = this.stopAutoUpdate) == null || t.call(this)
    }
    async updatePosition() {
        const {x: t, y: i, middlewareData: s, placement: r} = await mo(this.options.reference, this.options.floating, this.getFloatingOptions());
        this.applyFloatingStyles(t, i, r, s),
        this.applyArrowStyles(r, s)
    }
    applyFloatingStyles(t, i, s, r) {
        w(this.options.floating, {
            position: "absolute",
            left: `${t}px`,
            top: `${i}px`,
            transformOrigin: Rl(s, r.arrow, this.options.arrow ?? void 0)
        })
    }
    applyArrowStyles(t, i) {
        !i.arrow || !ct(this.options.arrow) || kl(this.options.arrow, this.options.reference, this.options.floating, i, t, this.options.arrowOffset)
    }
    getFloatingOptions() {
        return {
            placement: this.options.placement,
            middleware: this.buildMiddleware()
        }
    }
    buildMiddleware() {
        const t = [];
        return t.push(go({
            mainAxis: this.options.offset,
            crossAxis: this.options.crossOffset
        })),
        this.options.size && t.push(this.createSizeMiddleware()),
        this.options.flip && t.push(this.createFlipMiddleware()),
        t.push(vo(this.options.shift ?? {
            padding: this.boundary ? -16 : 20,
            boundary: this.boundary
        })),
        this.options.arrow && t.push(yo({
            element: this.options.arrow
        })),
        t
    }
    createSizeMiddleware() {
        return bo({
            padding: 8,
            apply: ({availableHeight: t, availableWidth: i, elements: s, rects: r}) => {
                const n = {};
                if (typeof this.options.minHeight == "number") {
                    const o = lt(t, this.options.minHeight, this.options.maxHeight);
                    n.maxHeight = `${o}px`
                }
                this.options.matchWidth && (n.minWidth = `${r.reference.width}px`),
                Object.assign(s.floating.style, n)
            }
        })
    }
    createFlipMiddleware() {
        return wo(typeof this.options.flip == "object" ? this.options.flip : void 0)
    }
}
var Bl = Object.defineProperty
  , jt = (e, t, i, s) => {
    for (var r = void 0, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(t, i, r) || r);
    return r && Bl(t, i, r),
    r
}
;
function lr(e) {
    class t extends e {
        get $arrow() {
            return null
        }
        firstUpdated(s) {
            super.firstUpdated(s),
            this.initializeFloatingController()
        }
        initializeFloatingController() {
            this.floatingController = new ql(this,this.getFloatingControllerOptions())
        }
        updateFloatingControllerOptions() {
            var s;
            (s = this.floatingController) == null || s.updateOptions(this.getFloatingControllerOptions())
        }
        getFloatingControllerOptions() {
            return {
                reference: this.$reference,
                floating: this.$floating,
                arrow: this.$arrow,
                ...this.getFloatingPositionOptions()
            }
        }
        getFloatingPositionOptions() {
            return {}
        }
        startFloatingAutoUpdate() {
            var s;
            (s = this.floatingController) == null || s.startAutoUpdate()
        }
        stopFloatingAutoUpdate() {
            var s;
            (s = this.floatingController) == null || s.stopAutoUpdatePositioning()
        }
        updateFloatingPosition() {
            var s;
            (s = this.floatingController) == null || s.updatePosition()
        }
    }
    return t
}
function cr(e) {
    class t extends e {
        updated(s) {
            var r;
            super.updated(s),
            Wi(s, ["placement", "offset", "crossOffset", "arrowOffset", "matchWidth", "minHeight"]) && ((r = this.onFloatingPropertiesUpdated) == null || r.call(this))
        }
        getFloatingDefaults() {
            return {}
        }
        getFloatingPositionOptions() {
            const s = un(this, ["placement", "offset", "crossOffset", "arrowOffset", "matchWidth", "minHeight", "maxHeight"]);
            return Fi(s, this.getFloatingDefaults())
        }
    }
    return jt([u({
        type: String
    })], t.prototype, "placement"),
    jt([u({
        type: Number
    })], t.prototype, "offset"),
    jt([u({
        type: Number,
        attribute: "cross-offset"
    })], t.prototype, "crossOffset"),
    jt([u({
        type: Number,
        attribute: "arrow-offset"
    })], t.prototype, "arrowOffset"),
    jt([u({
        type: Boolean,
        attribute: "match-width"
    })], t.prototype, "matchWidth"),
    jt([u({
        type: Number,
        attribute: "min-height"
    })], t.prototype, "minHeight"),
    jt([u({
        type: Number,
        attribute: "max-height"
    })], t.prototype, "maxHeight"),
    t
}
const Ri = new Set;
class Ul extends it {
    constructor(t, i, s, r= () => !0) {
        super(t),
        this.targetElements = i,
        this.callback = s,
        this.isActive = r,
        this.callbackDebounced = k(n => this.callback(n)),
        this.disabled = !1,
        Hl(),
        t.addController(this)
    }
    hostConnected() {
        Ri.add(this)
    }
    hostDisconnected() {
        Ri.delete(this)
    }
    disable() {
        this.disabled = !0
    }
    enable() {
        this.disabled = !1
    }
    handleDocumentEvent(t) {
        this.disabled || !this.isActive() || this.isEventInsideTargets(t) || this.callbackDebounced(t)
    }
    isEventInsideTargets(t) {
        return t.target instanceof HTMLLabelElement && t.target.htmlFor === this.host.id ? !0 : t.composedPath().filter(i => i instanceof Element).some(i => Z(this.targetElements).includes(i))
    }
}
let Ur = !1;
function Hl() {
    Ur || (document.addEventListener("click", e => {
        for (const t of Ri)
            t.handleDocumentEvent(e)
    }
    ),
    document.addEventListener("focusin", e => {
        for (const t of Ri)
            t.handleDocumentEvent(e)
    }
    ),
    Ur = !0)
}
class qn extends it {
    constructor(t, i) {
        super(t),
        this.options = i,
        this.outsideClickController = this.addController(new Ul(t,[t, ...this.elements], () => {
            this.close()
        }
        ,i.getOpen)),
        this.listen( () => this.elements, "keydown", this.handleKeyDown.bind(this)),
        t.addController(this)
    }
    get elements() {
        return [...this.buttons, this.options.popover].filter(t => t instanceof HTMLElement)
    }
    get buttons() {
        return Z(this.options.button)
    }
    hostConnected() {}
    close() {
        this.options.setOpen({
            open: !1,
            keyboardTriggered: !1
        }),
        this.clearActiveButton()
    }
    handleKeyDown(t) {
        t.key === "Escape" && (this.options.setOpen({
            open: !1,
            button: void 0,
            keyboardTriggered: !0
        }),
        this.clearActiveButton())
    }
    setActiveButton(t) {
        this.buttons.forEach(i => {
            i.setAttribute("aria-expanded", i === t ? "true" : "false")
        }
        ),
        this.activeButton = t
    }
    clearActiveButton() {
        this.buttons.forEach(t => {
            t.setAttribute("aria-expanded", "false")
        }
        ),
        this.activeButton = void 0
    }
}
class Nl extends qn {
    constructor(t, i) {
        super(t, i),
        this.listen( () => [...this.buttons, this.options.popover], "click", this.handleClick.bind(this))
    }
    handleClick(t) {
        if (t.composedPath().includes(this.options.popover))
            return;
        t.preventDefault();
        const i = t.currentTarget
          , s = t instanceof MouseEvent && t.detail === 0;
        !this.options.getOpen() || this.activeButton !== i ? (this.setActiveButton(i),
        this.options.setOpen({
            open: !0,
            button: i,
            keyboardTriggered: s
        })) : this.options.getOpen() && this.activeButton === i && (this.clearActiveButton(),
        this.options.setOpen({
            open: !1,
            keyboardTriggered: !1
        }))
    }
}
class jl extends qn {
    constructor(t, i) {
        var s;
        super(t, i),
        this.debouncedShow = k(r => {
            this.setActiveButton(r),
            this.options.setOpen({
                open: !0,
                button: r,
                keyboardTriggered: !1
            })
        }
        , this.options.openDelay ?? 100),
        this.debouncedHide = k( () => {
            var r, n;
            this.options.getOpen() && !((n = (r = this.options).preventMouseLeave) != null && n.call(r)) && (this.clearActiveButton(),
            this.options.setOpen({
                open: !1,
                keyboardTriggered: !1
            }))
        }
        , this.options.hideDelay ?? 250),
        this.setupDevMode = void 0,
        (s = this.setupDevMode) == null || s.call(this),
        this.listen( () => [...this.buttons, this.options.popover], "mouseenter", this.handleMouseEnter.bind(this)),
        this.listen( () => [...this.buttons, this.options.popover], "mouseleave", this.handleMouseLeave.bind(this))
    }
    handleMouseEnter(t) {
        if (this.debouncedHide.cancel(),
        t.currentTarget === this.options.popover)
            return;
        const i = t.currentTarget;
        this.debouncedShow(i)
    }
    handleKeyDown(t) {
        t.key === "Enter" ? t.currentTarget instanceof HTMLElement && this.buttons.includes(t.currentTarget) && (t.preventDefault(),
        this.debouncedShow.cancel(),
        this.debouncedHide.cancel(),
        this.setActiveButton(t.currentTarget),
        this.options.setOpen({
            open: !0,
            button: t.currentTarget,
            keyboardTriggered: !0
        })) : super.handleKeyDown(t)
    }
    handleMouseLeave() {
        this.debouncedShow.cancel(),
        this.debouncedHide()
    }
}
function Bn(e, t) {
    return t.trigger === "hover" && Ki() ? new jl(e,t) : new Nl(e,t)
}
var Vl = Object.defineProperty
  , zl = Object.getOwnPropertyDescriptor
  , $s = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? zl(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Vl(t, i, r),
    r
}
;
function hr(e) {
    class t extends e {
        constructor(...s) {
            super(...s),
            this.open = !1,
            this.trigger = "click",
            this.keyboardTriggered = !1,
            this.focusElementDebounced = k(r => r.focus(), 100),
            this.updateComplete.then( () => {
                this.setupPopoverBehavior()
            }
            )
        }
        get $autofocus() {
            return this.$popover.querySelector("[autofocus]")
        }
        get outsideClickController() {
            var s;
            return (s = this.triggerController) == null ? void 0 : s.outsideClickController
        }
        setupPopoverBehavior() {
            var s, r;
            this.id || (this.id = Ee("Popover-")),
            (s = this.$button).id || (s.id = `${this.id}-Button`),
            (r = this.$popover).id || (r.id = `${this.id}-Popover`),
            this.setupAriaAttributes(),
            this.createTriggerController()
        }
        setupAriaAttributes() {
            const s = this.getHasPopupType();
            this.$popover.setAttribute("tabindex", "-1"),
            this.$popover.setAttribute("aria-labelledby", this.$button.id),
            s ? this.$button.setAttribute("aria-haspopup", s) : this.$button.removeAttribute("aria-haspopup"),
            this.$button.setAttribute("aria-controls", this.$popover.id)
        }
        getHasPopupType() {
            if (this.$popover.role === "menu" || this.$popover.role === "listbox" || this.$popover.role === "dialog")
                return this.$popover.role
        }
        createTriggerController() {
            this.triggerController = Bn(this, this.getPopoverTriggerOptions())
        }
        getPopoverTriggerOptions() {
            return {
                trigger: this.trigger,
                button: this.$button,
                popover: this.$popover,
                getOpen: () => this.open,
                setOpen: ({open: s, keyboardTriggered: r}) => {
                    this.setOpen(s, r)
                }
            }
        }
        updated(s) {
            if (super.updated(s),
            s.has("open")) {
                const r = s.get("open");
                if (this.onOpenStateChange(r) === !1)
                    return;
                this.focusElementDebounced.cancel(),
                this.open ? (m(this, "popover:open", void 0, {
                    bubbles: !0
                }),
                r !== void 0 && (this.$autofocus ? this.focusElementDebounced(this.$autofocus) : this.keyboardTriggered && this.focusElementDebounced(this.$popover))) : this.keyboardTriggered && (this.contains(document.activeElement) || this.$popover.contains(document.activeElement)) && this.$button.focus()
            }
        }
        setOpen(s, r=!1) {
            this.keyboardTriggered = r,
            this.open = s
        }
        handlePopoverOpen(s) {
            var r;
            this.open && s.target !== this && ((r = this.triggerController) == null || r.close())
        }
    }
    return $s([u({
        type: Boolean,
        reflect: !0
    })], t.prototype, "open", 2),
    $s([u({
        type: String
    })], t.prototype, "trigger", 2),
    $s([l("popover:open", document)], t.prototype, "handlePopoverOpen", 1),
    t
}
function is(e) {
    return function(t, i, s) {
        if (s)
            return {
                get() {
                    return this.portalRoot.querySelector(e)
                },
                enumerable: !0,
                configurable: !0
            };
        Object.defineProperty(t, i, {
            get() {
                return this.portalRoot.querySelector(e)
            },
            enumerable: !0,
            configurable: !0
        })
    }
}
class Fl extends So {
    update(t, [i,s=!1]) {
        return (!this.previousInput || (s ? !this.areNodesEqual(this.previousInput, i) : !this.areIdentical(this.previousInput, i))) && (this.previousInput = i,
        this.clonedResult = this.cloneInput(i)),
        this.clonedResult
    }
    render(t, i) {
        return t
    }
    cloneInput(t) {
        return t instanceof Node ? t.cloneNode(!0) : Array.from(t).map(s => s.cloneNode(!0))
    }
    areIdentical(t, i) {
        if (t === i)
            return !0;
        if (t instanceof Node && i instanceof Node || t instanceof Node || i instanceof Node)
            return !1;
        const s = Array.from(t)
          , r = Array.from(i);
        return s.length !== r.length ? !1 : s.every( (n, o) => n === r[o])
    }
    areNodesEqual(t, i) {
        if (t === i)
            return !0;
        if (t instanceof Node && i instanceof Node)
            return t.isEqualNode(i);
        if (t instanceof Node || i instanceof Node)
            return !1;
        const s = Array.from(t)
          , r = Array.from(i);
        return s.length !== r.length ? !1 : s.every( (n, o) => n.isEqualNode(r[o] ?? null))
    }
}
const dr = $o(Fl);
var Wl = Object.defineProperty, Yl = Object.getOwnPropertyDescriptor, Un = e => {
    throw TypeError(e)
}
, be = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Yl(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Wl(t, i, r),
    r
}
, Hn = (e, t, i) => t.has(e) || Un("Cannot " + i), Kl = (e, t, i) => (Hn(e, t, "read from private field"),
i ? i.call(e) : t.get(e)), Xl = (e, t, i) => t.has(e) ? Un("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, i), Gl = (e, t, i, s) => (Hn(e, t, "write to private field"),
t.set(e, i),
i), fi;
let St = class extends T(x, hr, lr, cr) {
    constructor() {
        super(),
        this.mobileModal = !1,
        Xl(this, fi),
        this.mobileQuery = new Ut(this,"not all and (min-width: 768px)"),
        this.mobileQuery.query.addEventListener("change", () => this.createTriggerController())
    }
    get $modal() {
        return Kl(this, fi)
    }
    set $modal(e) {
        Gl(this, fi, e)
    }
    get $button() {
        return this.renderRoot.querySelector("button")
    }
    get $popover() {
        return this.renderRoot.querySelector("button + *, [data-part=reference] + *")
    }
    get $arrow() {
        return this.renderRoot.querySelector("[data-arrow]")
    }
    get $reference() {
        return this.querySelector("[data-part=reference]") ?? this.$button
    }
    get $floating() {
        return this.$popover
    }
    createTriggerController() {
        var e;
        this.mobileModal && this.mobileQuery.matches ? (e = this.triggerController) == null || e.remove() : super.createTriggerController()
    }
    handleClick(e) {
        this.mobileModal && this.mobileQuery.matches && this.$modal && this.$button.contains(e.target) && (this.$modal.open = !0)
    }
    onOpenStateChange(e) {
        const t = this.open ? this.animateIn() : this.animateOut();
        this.open ? (this.$popover.hidden = !1,
        this.startFloatingAutoUpdate()) : this.stopFloatingAutoUpdate(),
        e === void 0 ? (ve(t),
        this.open || (this.$popover.hidden = !0)) : A(t).then( () => {
            this.open || (this.$popover.hidden = !0)
        }
        )
    }
    animateIn() {
        return this.inAnimation && Ci(this.inAnimation) ? at(this.inAnimation, this.$popover) : [[this.$popover, {
            opacity: [0, 1],
            transform: ["translateY(8px)", "none"]
        }, {
            duration: .1
        }]]
    }
    animateOut() {
        return this.outAnimation && Ci(this.outAnimation) ? at(this.outAnimation, this.$popover) : [[this.$popover, {
            opacity: [1, 0]
        }, {
            duration: .1
        }]]
    }
    render() {
        const e = [];
        return this.mobileModal && this.mobileQuery.matches && e.push(this.renderMobileModal()),
        this.renderPortal(e),
        Dt
    }
    renderMobileModal() {
        return p`
      <modal-element @modal:hide=${ () => this.open = !1}>
        <div class="min-h-[25vh] p-4 pt-5">${dr(this.$popover.childNodes, !0)}</div>
      </modal-element>
    `
    }
    beforeMorphDOM(e, t) {
        const i = e.querySelector(":scope > button")
          , s = e.querySelector(":scope > button + *, :scope > [data-part=reference] + *");
        return i && t(this.$button, i),
        s && t(this.$popover, s, {
            childrenOnly: !0
        }),
        !1
    }
}
;
fi = new WeakMap,
be([u({
    type: Boolean,
    attribute: "mobile-modal"
})], St.prototype, "mobileModal", 2),
be([u({
    type: String,
    attribute: "in-animation"
})], St.prototype, "inAnimation", 2),
be([u({
    type: String,
    attribute: "out-animation"
})], St.prototype, "outAnimation", 2),
be([is("modal-element")], St.prototype, "$modal", 1),
be([l("click")], St.prototype, "handleClick", 1),
St = be([d("popover-element")], St);
var Ql = Object.defineProperty
  , Zl = Object.getOwnPropertyDescriptor
  , Je = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Zl(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Ql(t, i, r),
    r
}
;
let ce = class extends HTMLElement {
    get rangeMin() {
        return ot(this, "[data-range-min]")
    }
    get rangeMax() {
        return ot(this, "[data-range-max]")
    }
    get rangeGroup() {
        return ot(this, ".range-group")
    }
    get inputMin() {
        return ot(this, "[data-input-min]")
    }
    get inputMax() {
        return ot(this, "[data-input-max]")
    }
    connectedCallback() {
        this.updateRangeBackground()
    }
    onRangeMinInput(e) {
        const t = e.target
          , i = Number(t.value)
          , s = Number(this.rangeMax.value);
        t.value = Math.min(i, s - 1).toString(),
        this.updateRangeBackground(),
        this.inputMin.value = t.value
    }
    onRangeMaxInput(e) {
        const t = e.target
          , i = Number(t.value)
          , s = Number(this.rangeMin.value);
        t.value = Math.max(i, s + 1).toString(),
        this.updateRangeBackground(),
        this.inputMax.value = t.value
    }
    onInputMinChange(e) {
        const t = e.target;
        t.value = this.sanitizeNumericInput(t.value);
        const i = Number(t.value)
          , s = Number(this.inputMax.value || this.inputMax.max);
        t.value && i >= s && (t.value = (s - 1).toString()),
        this.rangeMin.value = t.value || this.rangeMin.min,
        this.updateRangeBackground()
    }
    onInputMaxChange(e) {
        const t = e.target;
        t.value = this.sanitizeNumericInput(t.value);
        const i = Number(t.value)
          , s = Number(this.inputMin.value || this.inputMin.min);
        t.value && i <= s && (t.value = (s + 1).toString()),
        this.rangeMax.value = t.value || this.rangeMax.max,
        this.updateRangeBackground()
    }
    sanitizeNumericInput(e) {
        return e.replace(",", ".").replace(/[^\d.]/g, "")
    }
    getRangePercentage(e) {
        return (Number(e.value) - Number(e.min)) / (Number(e.max) - Number(e.min)) * 100
    }
    updateRangeBackground() {
        this.rangeGroup.style.setProperty("--range-min", this.getRangePercentage(this.rangeMin).toString() + "%"),
        this.rangeGroup.style.setProperty("--range-max", this.getRangePercentage(this.rangeMax).toString() + "%")
    }
    beforeMorphDOM(e, t) {
        return t(this, e, {
            onBeforeElUpdated: i => !(i === this.inputMin && document.activeElement === this.inputMin || i === this.inputMax && document.activeElement === this.inputMax)
        }),
        this.updateRangeBackground(),
        !1
    }
}
;
Je([l("input", e => e.rangeMin)], ce.prototype, "onRangeMinInput", 1),
Je([l("input", e => e.rangeMax)], ce.prototype, "onRangeMaxInput", 1),
Je([l("change", e => e.inputMin, {
    capture: !0
})], ce.prototype, "onInputMinChange", 1),
Je([l("change", e => e.inputMax, {
    capture: !0
})], ce.prototype, "onInputMaxChange", 1),
ce = Je([d("price-range")], ce);
function Jl(e) {
    class t extends e {
        constructor() {
            super(...arguments),
            this._updateScheduled = !1,
            this._updatedMap = new Map,
            this.firstUpdate = !0
        }
        connectedCallback() {
            this.firstUpdate && this.scheduleUpdate()
        }
        updated(s) {}
        scheduleUpdate(s, r) {
            s && this._updatedMap.set(s, r),
            !this._updateScheduled && (this._updateScheduled = !0,
            queueMicrotask( () => {
                const n = new Map(this._updatedMap);
                this._updateScheduled = !1,
                this._updatedMap.clear(),
                this.updated(n),
                this.firstUpdate = !1
            }
            ))
        }
        attributeChangedCallback(s, r) {
            this.scheduleUpdate(s, r)
        }
    }
    return t
}
var tc = Object.defineProperty
  , ec = Object.getOwnPropertyDescriptor
  , ti = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? ec(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && tc(t, i, r),
    r
}
;
let pt = class extends Jl(HTMLButtonElement) {
    constructor() {
        super(),
        this.hanldeNotLoadingDebounced = k( () => this.handleNotLoading(), 0),
        window.addEventListener("pageshow", e => {
            e.persisted && (this.loading = !1)
        }
        )
    }
    get $content() {
        return this.querySelector("[data-part=label]")
    }
    get $spinner() {
        return this.querySelector("[data-part=spinner]")
    }
    updated(e) {
        e.has("loading") && (this.loading ? (this.hanldeNotLoadingDebounced.cancel(),
        this.handleLoading()) : this.firstUpdate ? this.handleNotLoading() : this.hanldeNotLoadingDebounced())
    }
    handleLoading() {
        this.style.pointerEvents = "none",
        this.$spinner.style.display = "";
        const e = this.animateLoading();
        this.firstUpdate && e.complete()
    }
    handleNotLoading() {
        this.style.pointerEvents = "";
        const e = this.animateNotLoading();
        e.then( () => {
            this.$spinner.style.display = "none",
            ht(this.$content)
        }
        ),
        this.firstUpdate && e.complete()
    }
    animateLoading() {
        const e = [[this.$content, {
            opacity: 0,
            transform: "translateY(-50%)"
        }, {
            duration: .3,
            ease: "power2.inOut"
        }], [this.$spinner, {
            opacity: [0, 1],
            transform: ["none", "none"]
        }, {
            duration: .5,
            ease: "power4.out",
            at: .15
        }]];
        return A(e)
    }
    animateNotLoading() {
        const e = [[this.$spinner, {
            opacity: 0,
            transform: "scale(0)"
        }, {
            duration: .2,
            ease: "power3.in"
        }], [this.$content, {
            opacity: [0, 1],
            transform: ["translateY(100%)", "translateY(0)"]
        }, {
            duration: .5,
            ease: "power3.out",
            at: "0.15"
        }]];
        return A(e)
    }
    handleFormSubmit() {
        this.autoLoading && (this.loading = !0)
    }
    handleCartUpdate(e) {
        this.type === "submit" && (this.loading = e.type === "cart:updating")
    }
    beforeMorphDOM(e) {
        return zs(this, e, {
            onBeforeElUpdated: (t, i) => t.matches("[data-part=spinner]") ? !1 : t.matches("[data-part=label]") ? (t.replaceChildren(...i.cloneNode(!0).childNodes),
            !1) : !0
        }),
        !1
    }
}
;
ti([g({
    type: Boolean
})], pt.prototype, "loading", 2),
ti([g({
    type: Boolean
})], pt.prototype, "autoLoading", 2),
ti([l("submit", e => e.closest("form"), {
    optional: !0
})], pt.prototype, "handleFormSubmit", 1),
ti([l(["cart:updating", "cart:updated"], e => e.closest("form"), {
    optional: !0
})], pt.prototype, "handleCartUpdate", 1),
pt = ti([d("button-element", {
    extends: "button"
})], pt);
var ic = Object.getOwnPropertyDescriptor
  , sc = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? ic(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let Hr = class extends HTMLFormElement {
    constructor() {
        super(),
        this.addEventListener("submit", this.handleSubmit.bind(this))
    }
    get $addToCartButton() {
        return this.querySelector("[data-part=btn-add-to-cart]")
    }
    get $errorMessage() {
        return this.querySelector("[role=alert]")
    }
    getRequestData() {
        const e = Mn(this);
        return e.items && typeof e.items == "object" && !Array.isArray(e.items) && (e.items = Object.values(e.items)),
        Array.isArray(e.items) && e.items.reverse(),
        e
    }
    async handleSubmit(e) {
        e.preventDefault(),
        this.updateErrorMessage(),
        this.$addToCartButton instanceof pt && (this.$addToCartButton.loading = !0),
        await En(this.getRequestData(), {
            eventTarget: this,
            onUpdated: ({error: t}) => {
                this.updateErrorMessage(t),
                this.$addToCartButton instanceof pt && (this.$addToCartButton.loading = !1)
            }
        })
    }
    updateErrorMessage(e="") {
        this.$errorMessage && (this.$errorMessage.textContent = e)
    }
}
;
Hr = sc([d("product-form", {
    extends: "form"
})], Hr);
var rc = Object.defineProperty
  , nc = Object.getOwnPropertyDescriptor
  , ee = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? nc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && rc(t, i, r),
    r
}
;
let kt = class extends HTMLElement {
    connectedCallback() {
        this.loading === "eager" && !this.placeholder ? this.setupEagerStrategy() : this.setupLazyStrategy()
    }
    disconnectedCallback() {
        var e;
        (e = this.disconnectObserver) == null || e.call(this)
    }
    async setupEagerStrategy() {
        this.placeholder = document.createComment(""),
        this.replaceWith(this.placeholder),
        await Xi(),
        await De(),
        await this.fetchAndUpdate()
    }
    setupLazyStrategy() {
        var e;
        (e = this.disconnectObserver) == null || e.call(this),
        this.disconnectObserver = Bt(this, this.fetchAndUpdate.bind(this), {
            rootMargin: `0px 0px ${this.threshold}px 0px`
        })
    }
    async fetchAndUpdate() {
        var t;
        const e = this.getURL();
        if (e) {
            (t = window.Shopify) != null && t.designMode && await Zt(250);
            try {
                const i = await Lt(e.toString()).get().text()
                  , r = dt(i).querySelector("product-recommendations");
                r && (this.replaceChildren(...r.children),
                this.children.length > 0 && this.placeholder && this.placeholder.replaceWith(this))
            } catch (i) {
                console.error(i)
            }
        }
    }
    getURL() {
        const e = window.routes.product_recommendations_url;
        if (!e)
            return null;
        const t = new URL(e,window.location.origin);
        return this.sectionId && t.searchParams.append("section_id", this.sectionId),
        this.productId && t.searchParams.append("product_id", this.productId),
        typeof this.limit == "number" && t.searchParams.append("limit", String(this.limit)),
        this.intent && t.searchParams.append("intent", this.intent),
        t
    }
}
;
ee([g({
    type: String,
    optional: !0
})], kt.prototype, "sectionId", 2),
ee([g({
    type: String,
    optional: !0
})], kt.prototype, "productId", 2),
ee([g({
    type: Number,
    optional: !0
})], kt.prototype, "limit", 2),
ee([g({
    type: String,
    optional: !0
})], kt.prototype, "intent", 2),
ee([g({
    type: Number,
    default: 600
})], kt.prototype, "threshold", 2),
ee([g({
    type: String,
    default: "lazy"
})], kt.prototype, "loading", 2),
kt = ee([d("product-recommendations")], kt);
var oc = Object.getOwnPropertyDescriptor
  , ac = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? oc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let Nr = class extends HTMLElement {
    constructor() {
        super(),
        this.makeRequest = Jt({
            cache: !0
        }),
        this.addEventListener("variant-picker:init", this.handleVariantInit.bind(this)),
        this.addEventListener("variant-picker:select", this.handleOptionSelect.bind(this))
    }
    get productUrl() {
        return this.getAttribute("product-url") ?? ""
    }
    get productOptions() {
        const e = this.querySelector("script[data-options-json]");
        return e ? JSON.parse(e.textContent) : null
    }
    get $addToCartButton() {
        return this.querySelector(".btn-add-to-cart")
    }
    get $section() {
        return this.closest(".shopify-section") ?? z("Shopify section not found")
    }
    get sectionId() {
        return this.getAttribute("section-id") ?? wt(this.$section)
    }
    get portable() {
        return this.hasAttribute("portable")
    }
    handleVariantInit(e) {
        Xi(async () => {
            var t;
            (t = window.Shopify) != null && t.designMode && await Zt(1e3),
            requestIdleCallback( () => this.preloadOptions(e.detail.optionValueIds))
        }
        )
    }
    async handleOptionSelect(e) {
        var t;
        if ((t = this.$addToCartButton) == null || t.setAttribute("disabled", "disabled"),
        m(this, "section:updating", void 0, {
            bubbles: !0
        }),
        e.detail.productUrl) {
            if (await this.handleCombinedListing(e.detail),
            !this.portable)
                return
        } else
            await this.handleRegularListing(e.detail);
        this.preloadOptions(e.detail.optionValueIds),
        m(this, "section:updated", void 0, {
            bubbles: !0
        })
    }
    async handleRegularListing(e) {
        const t = await this.fetchProductSection(e)
          , i = this.findUpdatedProductSection(t);
        this.updateHistoryState(e),
        Gs(this, i)
    }
    async handleCombinedListing(e) {
        var t;
        if (this.portable) {
            const i = await this.fetchProductSection(e)
              , s = this.findUpdatedProductSection(i);
            Ar(this, () => {
                this.innerHTML = s.innerHTML
            }
            ),
            Ke(this, s),
            (t = window.Shopify) == null || t.PaymentButton.init()
        } else {
            const i = await this.makeRequest(this.getOptionUrl(e))
              , r = dt(i).querySelector("main") ?? z("<main> element not found in the response")
              , n = document.querySelector("main") ?? z("<main> element not found");
            this.updateHistoryState(e),
            Ar(n, () => {
                n.innerHTML = r.innerHTML
            }
            )
        }
    }
    findUpdatedProductSection(e) {
        var i;
        const t = dt(e);
        return t.querySelector("product-section") ?? ((i = t.querySelector("quick-view-modal > template")) == null ? void 0 : i.content.querySelector("product-section")) ?? z("<product-section> element not found in the response")
    }
    updateHistoryState(e) {
        this.portable || history.replaceState({}, "", this.getOptionUrl(e))
    }
    fetchProductSection(e) {
        return this.makeRequest(`${this.getOptionUrl(e)}&section_id=${this.sectionId}`)
    }
    getOptionUrl(e) {
        return `${e.productUrl ? e.productUrl : this.productUrl}?${e.variantId ? `variant=${e.variantId}` : `option_values=${e.optionValueIds.join(",")}`}`
    }
    preloadOptions(e) {
        this.getOptionsToPreload(e).forEach(t => {
            this.fetchProductSection(t)
        }
        )
    }
    getOptionsToPreload(e) {
        const t = [];
        return this.productOptions && this.productOptions.forEach( (i, s) => {
            i.values.forEach(r => {
                if (r.id.toString() !== e[s]) {
                    const n = [...e];
                    n[s] = r.id.toString(),
                    t.push({
                        productUrl: r.product_url ?? "",
                        variantId: r.variant_id ?? "",
                        optionValueIds: n
                    })
                }
            }
            )
        }
        ),
        t
    }
}
;
Nr = ac([d("product-section")], Nr);
var lc = Object.defineProperty
  , cc = Object.getOwnPropertyDescriptor
  , Pt = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? cc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && lc(t, i, r),
    r
}
;
let ft = class extends N {
    constructor() {
        super(...arguments),
        this.defaultCountry = "",
        this.defaultProvince = "",
        this.provinces = [],
        this.selectedCountry = ""
    }
    connectedCallback() {
        super.connectedCallback(),
        this.defaultCountry ? (this.selectedCountry = this.defaultCountry,
        this.$countrySelect.value = this.defaultCountry) : this.selectedCountry = this.$countrySelect.value
    }
    willUpdate(e) {
        super.willUpdate(e),
        e.has("selectedCountry") && this.updateProvinces()
    }
    updated(e) {
        super.updated(e),
        e.has("provinces") && (this.$provinceWrapper.hidden = this.provinces.length === 0,
        Vs(this.renderProvinces(), this.$provinceSelect),
        this.defaultProvince && this.provinces.length > 0 && this.provinces.some( ([i]) => i === this.defaultProvince) && (this.$provinceSelect.value = this.defaultProvince))
    }
    handleChange(e) {
        e.target === this.$countrySelect && (this.selectedCountry = this.$countrySelect.value)
    }
    updateProvinces() {
        const e = this.$countrySelect.selectedOptions[0]
          , t = e?.getAttribute("data-provinces");
        if (!t) {
            this.provinces = [];
            return
        }
        try {
            this.provinces = JSON.parse(t)
        } catch (i) {
            console.error("Failed to parse provinces data:", i),
            this.provinces = []
        }
    }
    renderProvinces() {
        return p`
      ${this.provinces.map( ([e,t]) => p`<option value="${e}">${t}</option>`)}
    `
    }
}
;
Pt([C('[data-part="country-select"]')], ft.prototype, "$countrySelect", 2),
Pt([C('[data-part="province-select"]')], ft.prototype, "$provinceSelect", 2),
Pt([C('[data-part="province-wrapper"]')], ft.prototype, "$provinceWrapper", 2),
Pt([u({
    attribute: "default-country"
})], ft.prototype, "defaultCountry", 2),
Pt([u({
    attribute: "default-province"
})], ft.prototype, "defaultProvince", 2),
Pt([b()], ft.prototype, "provinces", 2),
Pt([b()], ft.prototype, "selectedCountry", 2),
Pt([l("change")], ft.prototype, "handleChange", 1),
ft = Pt([d("province-selector")], ft);
var hc = Object.defineProperty
  , dc = Object.getOwnPropertyDescriptor
  , ci = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? dc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && hc(t, i, r),
    r
}
;
function uc(e) {
    class t extends e {
        constructor() {
            super(...arguments),
            this.min = 0,
            this.step = 1
        }
        get canDecrement() {
            return Number(this.value) > this.min
        }
        get canIncrement() {
            return this.max === void 0 || Number(this.value) + this.step <= this.max
        }
        increment() {
            const s = Number(this.value) || 0;
            this.triggerChange(String(s + this.step))
        }
        decrement() {
            const s = Number(this.value) || 0;
            this.triggerChange(String(s - this.step))
        }
        snapToStep(s) {
            const r = Math.ceil((s - this.min) / this.step)
              , n = this.min + r * this.step;
            if (n < this.min)
                return this.min;
            if (this.max !== void 0 && n > this.max) {
                const o = Math.floor((this.max - this.min) / this.step);
                return this.min + o * this.step
            }
            return n
        }
        willUpdate(s) {
            if (super.willUpdate(s),
            !s.has("value"))
                return;
            if (!/^\d+$/.test(this.value)) {
                this.value = String(this.min);
                return
            }
            const r = Number(this.value);
            if (isNaN(r))
                return;
            const n = this.snapToStep(r);
            n !== r && (this.value = String(n))
        }
        handleNumericInputMixinKeyDown(s) {
            if (s.key === "ArrowUp") {
                s.preventDefault(),
                this.increment();
                return
            }
            if (s.key === "ArrowDown") {
                s.preventDefault(),
                this.decrement();
                return
            }
            !s.ctrlKey && !s.metaKey && !["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter", "Home", "End"].includes(s.key) && s.preventDefault()
        }
        triggerChange(s) {
            if (this.value === s)
                return;
            const r = this.value;
            this.value = s,
            this.updateComplete.then( () => {
                var n;
                this.value !== r && ((n = this.$input) == null || n.dispatchEvent(new Event("change",{
                    bubbles: !0
                })))
            }
            )
        }
    }
    return ci([u({
        type: Number
    })], t.prototype, "min", 2),
    ci([u({
        type: Number
    })], t.prototype, "max", 2),
    ci([u({
        type: Number
    })], t.prototype, "step", 2),
    ci([l("keydown", i => i.updateComplete.then( () => i.$input))], t.prototype, "handleNumericInputMixinKeyDown", 1),
    t
}
var pc = Object.defineProperty
  , fc = Object.getOwnPropertyDescriptor
  , It = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? fc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && pc(t, i, r),
    r
}
;
let mt = class extends T(N, uc) {
    constructor() {
        super(...arguments),
        this.value = "",
        this.disabled = !1
    }
    get cartItemKey() {
        return this.dataset.cartItem
    }
    get $input() {
        return this.querySelector("input")
    }
    get $btnDecrement() {
        return this.querySelector("[data-part=decrement]")
    }
    get $btnIncrement() {
        return this.querySelector("[data-part=increment]")
    }
    connectedCallback() {
        this.value = this.$input.value,
        super.connectedCallback()
    }
    updated() {
        this.$input.value = this.value,
        this.$btnDecrement.toggleAttribute("disabled", !this.canDecrement),
        this.$btnIncrement.toggleAttribute("disabled", !this.canIncrement),
        this.toggleAttribute("disabled", this.disabled),
        this.$input.toggleAttribute("disabled", this.disabled)
    }
    handleChange(e) {
        this.value = e.target.value
    }
    handleClick(e) {
        this.disabled || ct(e.target) && (this.$btnDecrement.contains(e.target) ? this.decrement() : this.$btnIncrement.contains(e.target) && this.increment())
    }
    handleInputPointerDown(e) {
        document.activeElement !== this.$input && (e.preventDefault(),
        this.$input.select())
    }
    handleCartEditing(e) {
        this.cartItemKey && (this.disabled = e.detail.key !== this.cartItemKey)
    }
    handleCartUpdating() {
        this.cartItemKey && (this.disabled = !0)
    }
    handleCartUpdated() {
        this.cartItemKey && (this.disabled = !1)
    }
    beforeMorphDOM() {
        return queueMicrotask( () => {
            this.value = this.$input.value,
            this.requestUpdate("value")
        }
        ),
        !0
    }
}
;
It([b()], mt.prototype, "value", 2),
It([b()], mt.prototype, "disabled", 2),
It([l("change")], mt.prototype, "handleChange", 1),
It([l("click")], mt.prototype, "handleClick", 1),
It([l("pointerdown", e => e.$input)], mt.prototype, "handleInputPointerDown", 1),
It([l("cart:editing", document)], mt.prototype, "handleCartEditing", 1),
It([l("cart:updating", document)], mt.prototype, "handleCartUpdating", 1),
It([l("cart:updated", document)], mt.prototype, "handleCartUpdated", 1),
mt = It([d("quantity-selector")], mt);
var mc = Object.defineProperty
  , gc = Object.getOwnPropertyDescriptor
  , we = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? gc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && mc(t, i, r),
    r
}
;
let Kt = class extends HTMLElement {
    constructor() {
        super(),
        this.internals = this.attachInternals(),
        this.setAttribute("role", "radiogroup")
    }
    static get formAssociated() {
        return !0
    }
    get options() {
        return Array.from(this.querySelectorAll("radio-option"))
    }
    get currentIndex() {
        return Math.max(0, this.options.findIndex(e => e.getAttribute("aria-checked") === "true"))
    }
    async connectedCallback() {
        await Ft("radio-option"),
        this.updateState()
    }
    attributeChangedCallback(e, t, i) {
        t !== i && this.updateState()
    }
    updateState() {
        this.setAttribute("aria-disabled", String(this.disabled)),
        this.setAttribute("aria-required", String(this.required)),
        this.internals.setFormValue(this.value),
        this.reportValidity();
        const e = this.options;
        e.forEach(s => {
            const r = this.value && s.value === this.value
              , n = this.disabled || s.disabled;
            s.setAttribute("aria-checked", String(r)),
            s.setAttribute("aria-disabled", String(n)),
            s.setAttribute("tabindex", "-1")
        }
        );
        const i = (this.value ? e.find(s => s.value === this.value) : null) || e[0];
        i && !i.disabled && i.setAttribute("tabindex", "0")
    }
    selectOption(e) {
        if (this.disabled || e.disabled)
            return;
        const t = this.value;
        this.value = e.value,
        this.dispatchEvent(new Event("input",{
            bubbles: !0
        })),
        t !== this.value && this.dispatchEvent(new Event("change",{
            bubbles: !0
        }))
    }
    handleKeyDown(e) {
        var r;
        if (this.disabled)
            return;
        const t = this.currentIndex;
        let i = t;
        switch (e.key) {
        case "ArrowDown":
        case "ArrowRight":
            e.preventDefault(),
            i = Me(t + 1, this.options.length);
            break;
        case "ArrowUp":
        case "ArrowLeft":
            e.preventDefault(),
            i = Me(t - 1, this.options.length);
            break;
        case "Home":
            e.preventDefault(),
            i = 0;
            break;
        case "End":
            e.preventDefault(),
            i = this.options.length - 1;
            break;
        default:
            return
        }
        for (; (r = this.options[i]) != null && r.disabled && i !== t; )
            e.key === "ArrowDown" || e.key === "ArrowRight" ? i = Me(i + 1, this.options.length) : i = Me(i - 1, this.options.length);
        const s = this.options[i];
        s && !s.disabled && (s.focus(),
        this.selectOption(s))
    }
    formResetCallback() {
        this.value = ""
    }
    formDisabledCallback(e) {
        this.toggleAttribute("disabled", e)
    }
    checkValidity() {
        return !this.required || !!this.value
    }
    reportValidity() {
        const e = this.checkValidity();
        return e ? this.internals.setValidity({}) : this.internals.setValidity({
            valueMissing: !0
        }, "Please select one of these options.", this.options[0]),
        e
    }
    beforeMorphDOM(e) {
        return Ke(this, e, ["value", "disabled"]),
        !1
    }
}
;
we([g({
    type: String,
    default: ""
})], Kt.prototype, "name", 2),
we([g({
    type: Boolean
})], Kt.prototype, "disabled", 2),
we([g({
    type: Boolean
})], Kt.prototype, "required", 2),
we([g({
    type: String
})], Kt.prototype, "value", 2),
we([l("keydown")], Kt.prototype, "handleKeyDown", 1),
Kt = we([d("radio-group")], Kt);
var vc = Object.defineProperty
  , yc = Object.getOwnPropertyDescriptor
  , ei = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? yc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && vc(t, i, r),
    r
}
;
let he = class extends HTMLElement {
    constructor() {
        super(),
        this.setAttribute("role", "radio")
    }
    handleClick(e) {
        if (e.preventDefault(),
        this.disabled)
            return;
        const t = this.closest("radio-group");
        t && t.selectOption(this)
    }
    handleKeyDown(e) {
        if (!this.disabled)
            switch (e.key) {
            case " ":
            case "Enter":
                {
                    e.preventDefault();
                    const t = this.closest("radio-group");
                    t && t.selectOption(this);
                    break
                }
            }
    }
}
;
ei([g({
    type: String
})], he.prototype, "value", 2),
ei([g({
    type: Boolean
})], he.prototype, "disabled", 2),
ei([l("click")], he.prototype, "handleClick", 1),
ei([l("keydown")], he.prototype, "handleKeyDown", 1),
he = ei([d("radio-option")], he);
const Te = class Te2 {
    constructor(t={}) {
        this.config = t,
        this.makeRequest = Jt({
            cache: !0
        })
    }
    getIds() {
        const t = new Set(this.config.excludeProductIds ?? [])
          , i = JSON.parse(localStorage.getItem(Te2.STORAGE_KEY) ?? "[]");
        if (!Array.isArray(i))
            return [];
        const s = i.filter(r => typeof r == "string" || typeof r == "number").map(r => String(r)).filter(r => !t.has(r));
        return this.config.limit ? s.slice(0, this.config.limit) : s
    }
    clear() {
        localStorage.removeItem(Te2.STORAGE_KEY)
    }
    hasViewedProducts() {
        return this.getIds().length > 0
    }
    getSearchQuery() {
        return this.getIds().map(t => `id:${t}`).join(" OR ")
    }
    getURL() {
        const t = new URL(window.routes.search_url,window.location.origin);
        return this.config.sectionId && t.searchParams.append("section_id", this.config.sectionId),
        t.searchParams.append("q", this.getSearchQuery()),
        t.searchParams.append("type", "product"),
        t.toString()
    }
    async fetch() {
        const t = await this.makeRequest(this.getURL())
          , s = dt(t).querySelector("recently-viewed-products");
        if (!s)
            throw new Error("<recently-viewed-products> element not found in the section html");
        const r = s.querySelector("[data-id]");
        return r != null && r.parentElement && this.sortElementsByViewedOrder(r.parentElement),
        s
    }
    sortElementsByViewedOrder(t) {
        const i = this.getIds()
          , s = Array.from(t.querySelectorAll("[data-id]"))
          , r = new Map(i.map( (o, a) => [o, a]))
          , n = Co(s, o => {
            const a = o.getAttribute("data-id");
            return a ? r.get(a) ?? 1 / 0 : 1 / 0
        }
        );
        for (const o of n)
            t.appendChild(o)
    }
    updateConfig(t) {
        this.config = {
            ...this.config,
            ...t
        }
    }
}
;
Te.STORAGE_KEY = "alloy:viewed-products";
let Ls = Te;
var bc = Object.defineProperty
  , wc = Object.getOwnPropertyDescriptor
  , ie = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? wc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && bc(t, i, r),
    r
}
;
let Ct = class extends HTMLElement {
    constructor() {
        super(...arguments),
        this.core = new Ls
    }
    connectedCallback() {
        var e;
        if (this.core.updateConfig({
            excludeProductIds: (e = this.productId) == null ? void 0 : e.split(","),
            sectionId: this.sectionId,
            limit: this.limit
        }),
        !this.core.hasViewedProducts()) {
            this.remove();
            return
        }
        this.dataset.loading = "",
        this.loading === "eager" ? this.setupEagerStrategy() : this.setupLazyStrategy()
    }
    disconnectedCallback() {
        var e;
        (e = this.disconnectObserver) == null || e.call(this)
    }
    handleClick(e) {
        ct(e.target) && e.target.closest("[data-action=clear]") && (this.core.clear(),
        this.replaceChildren())
    }
    async setupEagerStrategy() {
        await Xi(),
        await De(),
        await this.fetchAndUpdate()
    }
    setupLazyStrategy() {
        var e;
        (e = this.disconnectObserver) == null || e.call(this),
        this.disconnectObserver = Bt(this, async () => {
            var t;
            (t = window.Shopify) != null && t.designMode && await Zt(250),
            await this.fetchAndUpdate()
        }
        , {
            rootMargin: `0px 0px ${this.threshold}px 0px`
        })
    }
    async fetchAndUpdate() {
        const e = await this.core.fetch();
        delete this.dataset.loading,
        this.replaceChildren(...e.children),
        this.children.length === 0 && this.remove()
    }
}
;
ie([g({
    type: String,
    optional: !0
})], Ct.prototype, "productId", 2),
ie([g({
    type: String,
    optional: !0
})], Ct.prototype, "sectionId", 2),
ie([g({
    type: Number,
    default: 600
})], Ct.prototype, "threshold", 2),
ie([g({
    type: String,
    default: "lazy"
})], Ct.prototype, "loading", 2),
ie([g({
    type: Number,
    default: 5
})], Ct.prototype, "limit", 2),
ie([l("click")], Ct.prototype, "handleClick", 1),
Ct = ie([d("recently-viewed-products")], Ct);
function ii(e, t) {
    return function(i, s) {
        const {type: r, required: n=!0} = t ?? {};
        Object.defineProperty(i, s, {
            get() {
                const o = this.getAttribute(e);
                if (!o && n)
                    throw new Error(`Attribute '${e}' not found or empty`);
                if (!o)
                    return null;
                const a = this.getRootNode().getElementById(o);
                if (!a && n)
                    throw new Error(`Element with ID '${o}' not found`);
                if (!a)
                    return null;
                if (r && !(a instanceof r)) {
                    if (n)
                        throw new Error(`Element with ID '${o}' is not an instance of ${r.name}`);
                    return null
                }
                return a
            },
            enumerable: !0,
            configurable: !0
        })
    }
}
var $c = Object.defineProperty
  , Sc = Object.getOwnPropertyDescriptor
  , ur = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Sc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && $c(t, i, r),
    r
}
;
let qi = class extends HTMLElement {
    handleChange(e) {
        if (!(e.target instanceof HTMLInputElement) || !e.target.checked)
            return;
        const t = e.target.parentElement;
        if (!t)
            return;
        const i = t.querySelector("template");
        i && this.$target.updateContent(i.innerHTML)
    }
}
;
ur([ii("target", {
    type: Y
})], qi.prototype, "$target", 2),
ur([l("change")], qi.prototype, "handleChange", 1),
qi = ur([d("scroll-carousel-switcher")], qi);
var Cc = Object.getOwnPropertyDescriptor
  , xc = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Cc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let ks = class extends x {
    constructor() {
        super(!0)
    }
    render() {
        return p`
      <div id="container">
        <div id="wrapper">
          <slot></slot>
        </div>
      </div>
    `
    }
}
;
ks.styles = [tt`
      :host {
        display: block;
        height: 100%;
      }

      #container {
        height: 100%;
        overscroll-behavior: none;
        overflow-y: auto;
        overflow-x: hidden;
        scrollbar-width: none;
      }

      #container::-webkit-scrollbar {
        display: hidden;
      }

      #wrapper {
        height: calc(100% + 1px);
      }

      ::slotted(*) {
        height: 100%;
      }
    `],
ks = xc([d("scroll-lock")], ks);
var _c = Object.getOwnPropertyDescriptor
  , Oc = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? _c(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let jr = class extends HTMLElement {
    constructor() {
        super(),
        this._first = !0,
        this.updateVariablesDebounced = k(this.updateVariables.bind(this), 200, {
            leading: !0
        }),
        this.firstElementChild && new ResizeObserver(e => {
            const t = e[0];
            t && (this.raw || this._first ? (this._first = !1,
            this.updateVariables(t)) : this.updateVariablesDebounced(t))
        }
        ).observe(this.firstElementChild, {
            box: "border-box"
        })
    }
    get heightVariable() {
        const e = this.getAttribute("height-var");
        return e ? `--${e}` : null
    }
    get widthVariable() {
        const e = this.getAttribute("width-var");
        return e ? `--${e}` : null
    }
    get raw() {
        return this.hasAttribute("raw")
    }
    updateVariables(e) {
        const t = this.getSizes(e);
        this.heightVariable && document.documentElement.style.setProperty(this.heightVariable, `${t.height}px`),
        this.widthVariable && document.documentElement.style.setProperty(this.widthVariable, `${t.width}px`)
    }
    getSizes(e) {
        if (e) {
            const t = e.borderBoxSize[0];
            return t ? {
                width: t.inlineSize,
                height: t.blockSize
            } : {
                width: e.contentRect.width,
                height: e.contentRect.height
            }
        }
        return this.firstElementChild instanceof HTMLElement ? {
            width: this.firstElementChild.offsetWidth,
            height: this.firstElementChild.offsetHeight
        } : {
            width: 0,
            height: 0
        }
    }
}
;
jr = Oc([d("size-observer")], jr);
var Pc = Object.defineProperty
  , Ic = Object.getOwnPropertyDescriptor
  , pr = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Ic(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Pc(t, i, r),
    r
}
;
let de = class extends HTMLElement {
    constructor() {
        var e;
        super(),
        this.debouncedSplit = k(this.split.bind(this), 200),
        this.ready = Promise.resolve(),
        Yi() !== "rtl" && (this.attachShadow({
            mode: "open"
        }),
        this.shadowRoot && (this.shadowRoot.innerHTML = `
      <div class="sr-only">
        <slot></slot>
      </div>
      <div id="split"></div>
    `,
        xo(this.shadowRoot, [de.styles]),
        this.ready = this.split(),
        (e = window.Shopify) != null && e.designMode && this.setupContentObserver()))
    }
    get $lines() {
        var e;
        return ((e = this.splitInstance) == null ? void 0 : e.lines) ?? []
    }
    get $words() {
        var e;
        return ((e = this.splitInstance) == null ? void 0 : e.words) ?? []
    }
    get $chars() {
        var e;
        return ((e = this.splitInstance) == null ? void 0 : e.chars) ?? []
    }
    get $target() {
        return this.shadowRoot.getElementById("split")
    }
    get isReady() {
        return this.hasAttribute("ready")
    }
    connectedCallback() {
        this.mode === "lines" && !this.resizeObserver && (this.resizeObserver = new ResizeObserver( ([e]) => {
            if (!e)
                return;
            const t = Math.round(e.contentRect.width);
            if (this.previousWidth === void 0) {
                this.previousWidth = t;
                return
            }
            t !== this.previousWidth && (this.previousWidth = t,
            this.debouncedSplit())
        }
        ),
        this.resizeObserver.observe(this))
    }
    disconnectedCallback() {
        var e;
        (e = this.resizeObserver) == null || e.disconnect(),
        this.resizeObserver = void 0
    }
    async split() {
        this.$target.textContent = this.textContent;
        const e = getComputedStyle(this).font;
        await document.fonts.load(e).catch( () => {}
        ),
        this.splitInstance = _o.create(this.$target, {
            type: this.mode,
            aria: "hidden",
            mask: "words",
            wordsClass: "word",
            linesClass: "line",
            charsClass: "char",
            autoSplit: !1,
            onSplit: t => {
                t.lines[0] && (t.lines[0].part = "first-line"),
                this.setAttribute("ready", ""),
                this.previousWidth = Math.round(this.getBoundingClientRect().width),
                m(this, "split-text:split", void 0, {
                    bubbles: !0
                })
            }
        })
    }
    revert() {
        var e;
        this.shadowRoot && (this.shadowRoot.innerHTML = "<slot></slot>"),
        (e = this.splitInstance) == null || e.revert(),
        this.splitInstance = void 0
    }
    setupContentObserver() {
        new MutationObserver( () => {
            this.revert()
        }
        ).observe(this, {
            childList: !0,
            subtree: !0,
            characterData: !0
        })
    }
    getAnimationTargets() {
        return [this.$lines, this.$words, this.$chars].find(e => e.length) ?? [this]
    }
}
;
de.styles = tt`
    .word-mask,
    .line-mask {
      overflow: visible !important;
      clip-path: inset(-0.15em 0);
    }

    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip-path: inset(0);
      white-space: nowrap;
      border: 0;
    }
  `,
pr([g({
    type: String,
    default: "words"
})], de.prototype, "mode", 2),
pr([g({
    type: Boolean
})], de.prototype, "wrap", 2),
de = pr([d("split-text")], de);
var Ac = Object.defineProperty
  , Mc = Object.getOwnPropertyDescriptor
  , fr = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Mc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Ac(t, i, r),
    r
}
;
let Bi = class extends HTMLButtonElement {
    connectedCallback() {
        this.inert = !0
    }
    handleStickyHeaderUpdate({detail: e}) {
        this.setAttribute("aria-expanded", String(e.expanded)),
        e.state === "sticky" ? this.inert = !1 : this.inert = !0
    }
    handleClick() {
        m(this, "sticky-header:toggle-expanded", void 0, {
            bubbles: !0
        })
    }
}
;
fr([l("sticky-header:update", document)], Bi.prototype, "handleStickyHeaderUpdate", 1),
fr([l("click")], Bi.prototype, "handleClick", 1),
Bi = fr([d("sticky-header-expand-button", {
    extends: "button"
})], Bi);
class ss extends it {
    constructor(t, i, s, r) {
        super(t),
        this.elementsOrCallback = i,
        this.callback = s,
        this.options = r,
        this.resizeObserver = new ResizeObserver(n => {
            this.callback(n)
        }
        ),
        t.addController(this)
    }
    hostConnected() {
        Ws(this.elementsOrCallback, this.disconnected, t => {
            t && Z(t).forEach(i => this.resizeObserver.observe(i, this.options))
        }
        )
    }
    hostDisconnected() {
        this.resizeObserver.disconnect()
    }
}
var Tc = Object.defineProperty
  , Ec = Object.getOwnPropertyDescriptor
  , si = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Ec(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Tc(t, i, r),
    r
}
;
let ue = class extends N {
    constructor() {
        super(),
        this.state = "DEFAULT",
        this.lastScrollTop = 0,
        this.scrollDirection = "DOWN",
        this.stickyPadding = 32,
        this.scrollParent = window,
        new ss(this, () => this.updateComplete.then( () => this.getResizeControllerTargets()),this.handleResize.bind(this),{
            box: "border-box"
        }),
        this.updateComplete.then( () => {
            setTimeout( () => {
                this.updateState()
            }
            )
        }
        )
    }
    getResizeControllerTargets() {
        const e = [this.$body];
        return this.isWindow(this.scrollParent) || e.push(this.scrollParent),
        e
    }
    connectedCallback() {
        super.connectedCallback(),
        this.scrollParent = this.findScrollParent(this)
    }
    get startVisible() {
        return this.$body.getBoundingClientRect().top > this.topMargin
    }
    get endVisible() {
        return this.getViewportHeight(this.scrollParent) - this.$body.getBoundingClientRect().bottom > this.bottomMargin
    }
    get endOverflows() {
        return this.$body.getBoundingClientRect().bottom > this.getBoundingClientRect().bottom
    }
    get topMargin() {
        return (this.isWindow(this.scrollParent) ? Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-height-sticky") || "0") : 0) + this.stickyPadding
    }
    get bottomMargin() {
        return this.stickyPadding
    }
    handleResize() {
        if (this.$body.clientHeight >= this.clientHeight)
            return;
        const e = this.state === "STATIC" || this.state === "DEFAULT";
        e && this.endOverflows ? this.state = "STICKY_BOTTOM" : e && this.endVisible && !this.startVisible ? this.state = "STICKY_BOTTOM" : this.state === "STICKY_BOTTOM" && this.startVisible && (this.state = "STICKY_TOP")
    }
    handleScroll() {
        const e = this.getScrollTop(this.scrollParent);
        this.scrollDirection = e > this.lastScrollTop ? "DOWN" : "UP",
        this.updateState(),
        this.lastScrollTop = e
    }
    updateState() {
        if (this.$body.clientHeight >= this.clientHeight) {
            this.state = "DEFAULT";
            return
        }
        const e = this.getViewportHeight(this.scrollParent) - this.topMargin - this.bottomMargin;
        if (this.$body.clientHeight <= e) {
            this.state = "STICKY_TOP";
            return
        }
        switch (this.state) {
        case "DEFAULT":
            this.endVisible && (this.state = "STICKY_BOTTOM");
            break;
        case "STICKY_TOP":
            this.scrollDirection === "DOWN" && (this.state = "STATIC");
            break;
        case "STICKY_BOTTOM":
            this.scrollDirection === "UP" && (this.state = "STATIC");
            break;
        case "STATIC":
            this.scrollDirection === "UP" && this.startVisible ? this.state = "STICKY_TOP" : this.scrollDirection === "DOWN" && this.endVisible && (this.state = "STICKY_BOTTOM");
            break
        }
    }
    stateUpdated() {
        switch (this.state) {
        default:
            this.$body.style.cssText = "";
            break;
        case "STICKY_TOP":
            this.$body.style.cssText = "",
            w(this.$body, {
                position: "sticky",
                top: `${this.topMargin}px`
            });
            break;
        case "STICKY_BOTTOM":
            this.$body.style.cssText = "",
            w(this.$body, {
                position: "sticky",
                bottom: `${this.bottomMargin}px`,
                alignSelf: "flex-end"
            });
            break;
        case "STATIC":
            {
                const e = this.$body.getBoundingClientRect();
                this.$body.style.cssText = "";
                const t = this.$body.getBoundingClientRect();
                w(this.$body, {
                    position: "relative",
                    top: `${e.y - t.y}px`
                });
                break
            }
        }
    }
    isWindow(e) {
        return e === window
    }
    getScrollTop(e) {
        return this.isWindow(e) ? window.scrollY : e.scrollTop
    }
    getViewportHeight(e) {
        return this.isWindow(e) ? window.innerHeight : e.clientHeight
    }
    findScrollParent(e) {
        const t = e.parentElement;
        if (!t || t === document.body)
            return window;
        const s = getComputedStyle(t).getPropertyValue("overflow-y");
        return s === "auto" || s === "scroll" ? t : this.findScrollParent(t)
    }
    beforeMorphDOM(e, t) {
        const i = e.querySelector("sticky-sidebar-body");
        return i ? (t(this.$body, i, {
            childrenOnly: !0
        }),
        !1) : !0
    }
}
;
si([C("sticky-sidebar-body", !0)], ue.prototype, "$body", 2),
si([b()], ue.prototype, "state", 2),
si([u({
    type: Number,
    attribute: "padding"
})], ue.prototype, "stickyPadding", 2),
si([l("scroll", e => e.scrollParent, {
    passive: !0
})], ue.prototype, "handleScroll", 1),
ue = si([d("sticky-sidebar")], ue);
var Dc = Object.defineProperty
  , Lc = Object.getOwnPropertyDescriptor
  , rs = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Lc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Dc(t, i, r),
    r
}
;
let Be = class extends N {
    constructor() {
        super(...arguments),
        this.activeIndex = 0
    }
    get $tabButtons() {
        return Array.from(this.querySelectorAll('[role="tab"]'))
    }
    get $tabPanels() {
        return Array.from(this.querySelectorAll('[role="tabpanel"]'))
    }
    connectedCallback() {
        super.connectedCallback(),
        this.setAttribute("role", "tablist")
    }
    handleTabClick(e) {
        const i = e.target.closest('[role="tab"]');
        if (i instanceof HTMLElement) {
            const s = this.$tabButtons.indexOf(i);
            s >= 0 && (this.activeIndex = s)
        }
    }
    handleKeydown(e) {
        var s;
        const t = e.target;
        if (!t.hasAttribute("role") || t.getAttribute("role") !== "tab")
            return;
        const i = this.$tabButtons.indexOf(t);
        switch (e.key) {
        case "ArrowLeft":
            e.preventDefault(),
            this.activeIndex = i > 0 ? i - 1 : this.$tabButtons.length - 1;
            break;
        case "ArrowRight":
            e.preventDefault(),
            this.activeIndex = i < this.$tabButtons.length - 1 ? i + 1 : 0;
            break;
        case "Home":
            e.preventDefault(),
            this.activeIndex = 0;
            break;
        case "End":
            e.preventDefault(),
            this.activeIndex = this.$tabButtons.length - 1;
            break;
        default:
            return
        }
        (s = this.$tabButtons[this.activeIndex]) == null || s.focus()
    }
    activeIndexUpdated() {
        this.updateTabs()
    }
    updateTabs() {
        const e = this.id || Ee("tabs-");
        this.$tabButtons.forEach( (t, i) => {
            const s = i === this.activeIndex
              , r = `${e}-tab-${i}`
              , n = `${e}-panel-${i}`;
            t.id || (t.id = r),
            t.setAttribute("aria-selected", String(s)),
            t.setAttribute("aria-controls", n),
            t.setAttribute("tabindex", s ? "0" : "-1")
        }
        ),
        this.$tabPanels.forEach( (t, i) => {
            const s = i === this.activeIndex
              , r = `${e}-tab-${i}`
              , n = `${e}-panel-${i}`;
            t.id || (t.id = n),
            t.setAttribute("aria-hidden", String(!s)),
            t.setAttribute("aria-labelledby", r)
        }
        )
    }
    activateTab(e) {
        e >= 0 && e < this.$tabButtons.length && (this.activeIndex = e)
    }
    getActiveTab() {
        return this.$tabButtons[this.activeIndex]
    }
    getActivePanel() {
        return this.$tabPanels[this.activeIndex]
    }
    beforeMorphDOM(e, t) {
        return queueMicrotask( () => {
            this.activeIndex > this.$tabPanels.length - 1 ? this.activeIndex = 0 : this.updateTabs()
        }
        ),
        !0
    }
}
;
rs([u({
    type: Number
})], Be.prototype, "activeIndex", 2),
rs([l("click")], Be.prototype, "handleTabClick", 1),
rs([l("keydown")], Be.prototype, "handleKeydown", 1),
Be = rs([d("tabs-element")], Be);
var kc = Object.getOwnPropertyDescriptor
  , Rc = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? kc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let Vr = class extends N {
    constructor() {
        super(),
        this.addEventListener("change", this.handleChange.bind(this)),
        Bt(this, this.emitVariantInitialize.bind(this))
    }
    get $options() {
        return [...this.querySelectorAll("[data-product-option]")]
    }
    emitVariantInitialize() {
        m(this, "variant-picker:init", {
            optionValueIds: this.getSelectedOptionValueIds()
        }, {
            bubbles: !0
        })
    }
    handleChange(e) {
        if (!(e.target instanceof HTMLElement))
            return;
        let t = e.target;
        e.target instanceof HTMLSelectElement && (t = e.target.querySelector("option:checked")),
        m(this, "variant-picker:select", {
            productUrl: t.dataset.productUrl ?? "",
            variantId: t.dataset.variantId ?? "",
            optionValueIds: this.getSelectedOptionValueIds()
        }, {
            bubbles: !0
        })
    }
    getSelectedOptionValueIds() {
        return this.$options.map(e => (e.querySelector("input[type=radio]:checked, option:checked") ?? e).dataset.optionValueId ?? "")
    }
}
;
Vr = Rc([d("variant-picker")], Vr);
class mr {
    constructor(t) {
        this.parent = t
    }
}
class qc extends mr {
    async createPlayer() {
        const t = this.parent.cloneFromTemplate("video");
        if (!(t instanceof HTMLVideoElement))
            throw new Error("Video template was not found");
        t.controls = this.parent.controls,
        t.muted = this.parent.muted,
        t.loop = this.parent.loop,
        t.addEventListener("play", () => {
            this.parent.playing = !0
        }
        ),
        t.addEventListener("pause", () => {
            this.parent.playing = !1
        }
        ),
        this.parent.$player = t,
        this.video = t
    }
    async play() {
        var t;
        return (t = this.video) == null ? void 0 : t.play()
    }
    pause() {
        var t;
        (t = this.video) == null || t.pause()
    }
    async getPosterUrl() {
        return null
    }
}
class Bc extends mr {
    async createPlayer() {
        await this.loadAPI();
        const t = document.createElement("div");
        t.style.width = "100%",
        t.style.height = "100%",
        this.parent.$player = t,
        await this.parent.updateComplete,
        this.player = new window.Vimeo.Player(t,{
            id: Number(this.parent.videoId),
            autopause: !1,
            autoplay: !0,
            playsinline: !0,
            controls: this.parent.controls,
            muted: this.parent.muted,
            loop: this.parent.loop,
            background: this.parent.background
        }),
        this.player.on("playing", () => {
            this.parent.playing = !0
        }
        ),
        this.player.on("pause", () => {
            this.parent.playing = !1
        }
        ),
        this.player.on("seeking", () => {
            this.parent.playing = !1
        }
        ),
        await this.player.ready()
    }
    async play() {
        var t;
        await ((t = this.player) == null ? void 0 : t.play())
    }
    pause() {
        var t;
        (t = this.player) == null || t.pause()
    }
    async loadAPI() {
        var t;
        if (!((t = window.Vimeo) != null && t.Player)) {
            const i = document.createElement("script");
            i.src = "//player.vimeo.com/api/player.js",
            document.head.appendChild(i),
            await new Promise(s => {
                i.onload = () => s()
            }
            )
        }
    }
    async getPosterUrl() {
        if (!this.parent.videoId)
            return null;
        try {
            const t = await fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(`https://vimeo.com/${this.parent.videoId}`)}&width=1920&height=1080`, {
                mode: "cors"
            });
            return t.ok ? (await t.json()).thumbnail_url ?? null : null
        } catch {
            return null
        }
    }
}
class Uc extends mr {
    async createPlayer() {
        await this.loadAPI();
        const t = document.createElement("div");
        this.parent.$player = t,
        await this.parent.updateComplete,
        await new Promise(i => {
            this.player = new window.YT.Player(t,{
                videoId: this.parent.videoId ?? "",
                playerVars: {
                    playlist: this.parent.videoId ?? "",
                    controls: this.parent.controls ? 1 : 0,
                    autoplay: 1,
                    mute: this.parent.muted ? 1 : 0,
                    rel: 0,
                    modestbranding: 1,
                    playsinline: 1,
                    loop: this.parent.loop ? 1 : 0,
                    showinfo: 0
                },
                events: {
                    onReady: () => i(null),
                    onStateChange: s => {
                        this.parent.playing = s.data === YT.PlayerState.PLAYING || s.data === YT.PlayerState.BUFFERING
                    }
                }
            })
        }
        )
    }
    async play() {
        this.player && (this.player.playVideo(),
        this.player.getPlayerState() === YT.PlayerState.BUFFERING && await this.playerStateChanged())
    }
    pause() {
        var t;
        (t = this.player) == null || t.pauseVideo()
    }
    async getPosterUrl() {
        if (!this.parent.videoId)
            return null;
        const t = `https://i.ytimg.com/vi/${this.parent.videoId}/`
          , i = ["maxresdefault.jpg", "hqdefault.jpg"];
        for (const s of i) {
            const r = `${t}${s}`;
            if (await this.imageExists(r))
                return r
        }
        return null
    }
    imageExists(t) {
        return new Promise(i => {
            const s = new Image;
            s.onload = () => i(!0),
            s.onerror = () => i(!1),
            s.src = t
        }
        )
    }
    async loadAPI() {
        var t;
        (t = window.YT) != null && t.Player || await new Promise(i => {
            window.onYouTubeIframeAPIReady = () => i();
            const s = document.createElement("script");
            s.src = "//www.youtube.com/iframe_api",
            document.head.appendChild(s)
        }
        )
    }
    playerStateChanged() {
        return Promise.race([new Promise(t => {
            const i = () => {
                t(null),
                this.player.removeEventListener("onStateChange", i)
            }
            ;
            this.player.addEventListener("onStateChange", i)
        }
        ), Zt(3e3)])
    }
}
var Hc = Object.defineProperty
  , Nc = Object.getOwnPropertyDescriptor
  , st = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Nc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Hc(t, i, r),
    r
}
;
let K = class extends Nt {
    constructor() {
        var e, t;
        super(!0),
        this.host = "native",
        this.loop = !1,
        this.background = !1,
        this.autoplay = !1,
        this.autopause = !1,
        this.muted = !1,
        this.controls = !1,
        this.$posterImage = this.querySelector("[slot=poster]"),
        (e = this.$posterImage) == null || e.removeAttribute("slot"),
        (t = this.$posterImage) == null || t.setAttribute("id", "poster"),
        this.updateComplete.then( () => {
            this.autoplay && (this.muted = !0),
            this.strategy = Ts(this.host).with("youtube", () => new Uc(this)).with("vimeo", () => new Bc(this)).otherwise( () => new qc(this)),
            this.setupIntersectionObserver(),
            this.ensurePoster()
        }
        )
    }
    setupIntersectionObserver() {
        this.observer || (this.observer = new IntersectionObserver(e => {
            e.forEach(t => {
                t.isIntersecting && this.autoplay ? this.play() : this.autopause && this.pause()
            }
            )
        }
        ,{
            threshold: 0
        }),
        this.observer.observe(this))
    }
    async play() {
        this.strategy && (super.play(),
        this.loadingState === "idle" && (this.loadingState = "loading",
        await this.strategy.createPlayer(),
        await this.updateComplete),
        await this.strategy.play(),
        this.loadingState === "loading" && (this.loadingState = "loaded",
        E(this.$poster, {
            opacity: 0
        }, {
            duration: .5
        }).then( () => {
            w(this.$poster, {
                display: "none"
            })
        }
        )))
    }
    pause() {
        var e;
        super.pause(),
        (e = this.strategy) == null || e.pause()
    }
    async ensurePoster() {
        if (!(this.$posterImage || !this.videoId || !this.strategy))
            try {
                const e = await this.strategy.getPosterUrl();
                if (!e)
                    return;
                const t = document.createElement("img");
                t.id = "poster",
                t.src = e,
                t.alt = "Video poster",
                this.$posterImage = t,
                this.requestUpdate(),
                await this.updateComplete
            } catch {}
    }
    render() {
        const e = this.background ? "mode-background" : "mode-player";
        return p`
      <div id="main" class="${e}">
        <div id="player-wrapper">${this.$player ?? Dt}</div>
        ${this.renderPoster()}
      </div>
    `
    }
    renderPoster() {
        return this.background ? p`<div class="poster">${this.$posterImage}</div>` : p`
      <button
        class="poster ${this.loadingState !== "idle" ? "pointer-events-none" : ""}"
        @click=${ () => this.play()}
        aria-label="Play video"
      >
        ${this.$posterImage}
        <div class="poster-button">
          ${this.loadingState === "idle" ? p`<icon-element icon="play-button"></icon-element>` : this.renderLoadingSpinner()}
        </div>
      </button>
    `
    }
}
;
K.styles = [x.themeCSS, tt`
      :host {
        display: block;
        overflow: hidden;
        border-radius: var(--media-border-radius, var(--block-border-radius));
        min-height: var(--media-min-height, 0);
        max-height: var(--media-max-height, none);
        max-width: var(--media-max-width, 100%);
      }

      #main {
        display: grid;
        width: 100%;
        height: 100%;
        position: relative;
        aspect-ratio: var(--media-aspect-ratio, var(--media-aspect-ratio-original, 16 / 9));
      }

      #main > * {
        grid-area: 1/1;
        min-height: 0;
      }

      .mode-player :where(iframe, video) {
        width: 100%;
        height: 100%;
        object-fit: var(--media-object-fit, cover);
      }

      .mode-background :where(iframe, video) {
        user-select: none;
        pointer-events: none;
        object-fit: var(--media-object-fit, cover);
        position: absolute;
        inset: 0;
      }

      .mode-background #player-wrapper {
        aspect-ratio: var(--media-aspect-ratio, var(--media-aspect-ratio-original, 16 / 9));
        position: absolute;
        min-width: 100%;
        min-height: 100%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      .mode-background #player-wrapper * {
        width: 100%;
        height: 100%;
      }

      .mode-background #player-wrapper iframe {
        width: 100%;
        height: 200%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }

      #poster {
        width: 100%;
        height: 100%;
        object-fit: var(--media-object-fit, cover);
        pointer-events: none;
      }

      #poster > * {
        width: 100%;
        height: 100%;
        object-fit: var(--media-object-fit, cover);
      }
    `],
st([u({
    type: String
})], K.prototype, "host", 2),
st([u({
    type: String,
    attribute: "video-id"
})], K.prototype, "videoId", 2),
st([u({
    type: Boolean
})], K.prototype, "loop", 2),
st([u({
    type: Boolean
})], K.prototype, "background", 2),
st([u({
    type: Boolean
})], K.prototype, "autoplay", 2),
st([u({
    type: Boolean
})], K.prototype, "autopause", 2),
st([u({
    type: Boolean
})], K.prototype, "muted", 2),
st([u({
    type: Boolean
})], K.prototype, "controls", 2),
st([b()], K.prototype, "$player", 2),
st([C(".poster")], K.prototype, "$poster", 2),
K = st([d("video-media")], K);
const jc = e => {
    const t = e.getAttribute("data-flip-id");
    return t || console.warn("No data-flip-id found for item", e),
    t ?? ""
}
;
function Vc(e) {
    const {container: t, newItems: i, getItemKey: s=jc, enterAnimation: r, exitAnimation: n, moveAnimation: o, animateHeight: a} = e
      , c = a instanceof Element ? a : t;
    let h = 0
      , f = 0;
    h = t.scrollLeft,
    t.scrollLeft = 0;
    const v = a ? c.clientHeight : 0
      , $ = Array.from(t.children)
      , S = new Map;
    for (const y of $) {
        const I = s(y);
        S.set(I, y)
    }
    const _ = new Map;
    for (const y of i) {
        const I = s(y);
        _.set(I, y)
    }
    const O = [];
    for (const y of i) {
        const I = s(y);
        S.has(I) || O.push(y)
    }
    const P = [];
    for (const y of $) {
        const I = s(y);
        _.has(I) || P.push(y)
    }
    const M = new Map;
    for (const y of $) {
        const I = s(y);
        _.has(I) && M.set(I, y.getBoundingClientRect())
    }
    t.replaceChildren(...i);
    const D = a ? c.clientHeight : 0;
    f = t.scrollWidth;
    const R = new Map;
    for (const y of i) {
        const I = s(y);
        S.has(I) && R.set(I, y.getBoundingClientRect())
    }
    t.replaceChildren(...$);
    const rt = new Set;
    for (const y of O) {
        const I = i.indexOf(y);
        if (I === -1)
            continue;
        let q = 0;
        for (let B = 0; B < I; B++) {
            const Mt = i[B];
            Mt && (S.has(s(Mt)) || rt.has(Mt)) && q++
        }
        if (q >= t.children.length)
            t.appendChild(y);
        else {
            const B = t.children[q];
            B ? t.insertBefore(y, B) : t.appendChild(y)
        }
        rt.add(y)
    }
    const yt = [];
    for (const y of i) {
        const I = s(y);
        if (S.has(I)) {
            const q = M.get(I)
              , B = R.get(I);
            if (q && B) {
                const Mt = q.left - B.left
                  , xr = q.top - B.top
                  , _r = o?.threshold ?? 1;
                (Math.abs(Mt) > _r || Math.abs(xr) > _r) && yt.push({
                    key: I,
                    deltaX: Mt,
                    deltaY: xr
                })
            }
        }
    }
    P.map(y => ({
        item: y,
        left: y.offsetLeft,
        top: y.offsetTop
    })).forEach( ({item: y, left: I, top: q}) => w(y, {
        position: "absolute",
        left: `${I}px`,
        top: `${q}px`
    }));
    {
        const y = f - t.clientWidth;
        t.scrollLeft = h,
        t.scrollTo({
            left: lt(h, 0, y),
            behavior: "smooth"
        })
    }
    const V = [];
    P.length > 0 && V.push(...n(P));
    for (const y of i) {
        const I = s(y);
        if (S.has(I)) {
            const q = [...t.children].find(B => s(B) === I);
            q && q !== y && t.replaceChild(y, q)
        }
    }
    let li = !0;
    for (const {key: y, deltaX: I, deltaY: q} of yt) {
        const B = _.get(y);
        if (!B)
            continue;
        const Mt = [[B, {
            transform: [`translate(${I}px, ${q}px)`, "translate(0px, 0px)"]
        }, {
            duration: o?.duration ?? .4,
            ease: o?.ease ?? "power2.inOut",
            at: li ? o?.at : "<"
        }]];
        V.push(...Mt),
        li = !1
    }
    O.length > 0 && V.push(...r(O)),
    a && v !== D && V.unshift([c, {
        height: [`${v}px`, `${D}px`]
    }, {
        duration: .5,
        at: 0,
        ease: "power2.inOut"
    }]);
    const Cr = A(V);
    return (P.length > 0 || a) && Cr.finished.then( () => {
        for (const y of P)
            y.parentElement === t && t.removeChild(y);
        a && (c.style.height = "")
    }
    ),
    Cr
}
var zc = Object.getOwnPropertyDescriptor
  , Fc = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? zc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let zr = class extends HTMLElement {
    createLinkEnterAnimation(e) {
        return [[e, {
            opacity: [0, 1],
            transform: ["translateY(0.25rem)", "none"]
        }, {
            duration: .5,
            delay: W(.05),
            at: "-0.3",
            ease: "power2.out"
        }]]
    }
    createLinkExitAnimation(e) {
        return [[e, {
            opacity: [1, 0],
            transform: ["none", "translateY(0.25rem)"]
        }, {
            duration: .3,
            at: "<",
            ease: "power1.in",
            delay: W(.02)
        }]]
    }
    beforeMorphDOM(e) {
        const t = Array.from(e.querySelectorAll("ul > li"));
        return setTimeout( () => {
            Vc({
                container: this.querySelector("ul"),
                newItems: t,
                enterAnimation: this.createLinkEnterAnimation.bind(this),
                exitAnimation: this.createLinkExitAnimation.bind(this),
                animateHeight: this,
                moveAnimation: {
                    duration: .6,
                    ease: "power3.inOut",
                    threshold: 1,
                    at: "-0.3"
                }
            })
        }
        ),
        !1
    }
}
;
zr = Fc([d("active-filters-container")], zr);
var Wc = Object.defineProperty
  , Yc = Object.getOwnPropertyDescriptor
  , ns = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Yc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Wc(t, i, r),
    r
}
;
let Ue = class extends pt {
    get $quickViewModal() {
        return document.querySelector("quick-view-modal")
    }
    handleClick() {
        if (this.url && !this.variantId) {
            this.loading = !0,
            this.$quickViewModal.loadProduct(this.url).then( () => {
                this.$quickViewModal.open = !0,
                this.loading = !1
            }
            );
            return
        }
        this.variantId && (this.loading = !0,
        En({
            id: this.variantId
        }, {
            eventTarget: this,
            onUpdated: () => {
                this.loading = !1
            }
        }))
    }
}
;
ns([g()], Ue.prototype, "variantId", 2),
ns([g()], Ue.prototype, "url", 2),
ns([l("click")], Ue.prototype, "handleClick", 1),
Ue = ns([d("add-to-cart-button", {
    extends: "button"
})], Ue);
class os extends it {
    constructor(t, i, s, r) {
        super(t),
        this.elementsOrCallback = i,
        this.callback = s,
        this.options = r,
        this.intersectionObserver = new IntersectionObserver(n => {
            n[0] && this.callback(n[0])
        }
        ,this.options),
        t.addController(this)
    }
    hostConnected() {
        Ws(this.elementsOrCallback, this.disconnected, t => {
            t && Z(t).forEach(i => this.intersectionObserver.observe(i))
        }
        )
    }
    hostDisconnected() {
        this.intersectionObserver.disconnect()
    }
}
class Nn extends it {
    constructor(t, i, s) {
        super(t),
        this.settings = i,
        this.callback = s,
        this.isStopped = !1,
        t.addController(this),
        this.addController(new os(t,t,r => {
            r.isIntersecting && !this.isStopped ? this.play() : this.clearInterval()
        }
        ))
    }
    get $targets() {
        return [this.host, ...document.querySelectorAll(`[aria-controls="${this.host.id}"]`)]
    }
    hostDisconnected() {
        this.clearInterval(),
        this.killProgressAnimation()
    }
    play() {
        this.isStopped = !1,
        this.$targets.forEach(t => t.classList.add("autoplay-active")),
        this.settings.progressVar && this.startProgressAnimation(),
        this.intervalId || (this.intervalId = window.setInterval( () => {
            document.hidden || (this.callback(),
            this.settings.progressVar && this.startProgressAnimation())
        }
        , this.settings.interval))
    }
    stop() {
        this.isStopped = !0,
        this.clearInterval(),
        this.$targets.forEach(t => t.classList.remove("autoplay-active")),
        this.settings.progressVar && (this.killProgressAnimation(),
        w(this.$targets, {
            "--autoplay-progress": "0"
        }))
    }
    clearInterval() {
        this.intervalId !== void 0 && (clearInterval(this.intervalId),
        this.intervalId = void 0),
        this.settings.progressVar && this.progressAnimation && this.progressAnimation.pause()
    }
    startProgressAnimation() {
        this.killProgressAnimation();
        const t = this.$targets;
        this.progressAnimation = new dn({
            keyframes: [0, 1],
            ease: "linear",
            duration: this.settings.interval,
            onUpdate: i => {
                Et.render( () => {
                    w(t, {
                        "--autoplay-progress": i
                    })
                }
                )
            }
        })
    }
    killProgressAnimation() {
        this.progressAnimation && (this.progressAnimation.cancel(),
        this.progressAnimation = void 0)
    }
}
var Kc = Object.defineProperty
  , Xc = Object.getOwnPropertyDescriptor
  , jn = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Xc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Kc(t, i, r),
    r
}
;
let Rs = class extends T(x, Zi) {
    constructor() {
        var e;
        super(),
        this.speed = 4e3,
        this.autoplayController = new Nn(this,{
            interval: this.speed,
            progressVar: !1
        }, () => this.goNext()),
        this.itemCount = this.$announcements.length,
        this.loop = !0,
        (e = window.Shopify) != null && e.designMode && this.initShopifyDesignMode()
    }
    get $announcements() {
        return this.querySelectorAll(".block-announcement")
    }
    activeIndexUpdated(e) {
        this.$announcements.forEach( (t, i) => {
            i === this.activeIndex ? this.fadeIn(t) : i === e ? this.fadeOut(t) : (e !== void 0 && Lo(t),
            w(t, {
                opacity: "0",
                visibility: "hidden"
            }))
        }
        )
    }
    fadeIn(e) {
        e.style.visibility = "",
        A(at("fade-up", e, {
            delay: .2
        }))
    }
    fadeOut(e) {
        E(e, {
            transform: "scale(0.9)",
            opacity: 0,
            visibility: "hidden"
        })
    }
    initShopifyDesignMode() {
        this.addEventListener("shopify:block:select", e => {
            const t = [...this.$announcements].findIndex(i => i.id.includes(e.detail.blockId));
            this.activeIndex = t !== -1 ? t : this.activeIndex,
            this.updateComplete.then( () => this.autoplayController.stop())
        }
        )
    }
}
;
jn([u({
    type: Number
})], Rs.prototype, "speed", 2),
Rs = jn([d("announcement-bar")], Rs);
var Gc = Object.defineProperty
  , Qc = Object.getOwnPropertyDescriptor
  , _e = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Qc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Gc(t, i, r),
    r
}
;
function gr(e) {
    class t extends e {
        constructor() {
            super(...arguments),
            this.activeIndex = 0,
            this.itemCount = 0,
            this.hasPrev = !1,
            this.hasNext = !1
        }
        get controlsId() {
            return this.getAttribute("aria-controls") ?? z("'aria-controls' attribute must be set and pointing to a carousel element")
        }
        connectedCallback() {
            super.connectedCallback(),
            m(document, "control:connected", {
                targetId: this.controlsId
            }, {
                bubbles: !0
            })
        }
        handleCarouselUpdate(s) {
            s.detail.targetId === this.controlsId && Object.assign(this, s.detail)
        }
        goPrev() {
            m(document, "control:trigger", {
                targetId: this.controlsId,
                action: "prev"
            }, {
                bubbles: !0
            })
        }
        goNext() {
            m(document, "control:trigger", {
                targetId: this.controlsId,
                action: "next"
            }, {
                bubbles: !0
            })
        }
        goIndex(s) {
            m(document, "control:trigger", {
                targetId: this.controlsId,
                action: "index",
                index: s
            }, {
                bubbles: !0
            })
        }
    }
    return _e([b()], t.prototype, "activeIndex", 2),
    _e([b()], t.prototype, "itemCount", 2),
    _e([b()], t.prototype, "hasPrev", 2),
    _e([b()], t.prototype, "hasNext", 2),
    _e([l("carousel:update", document, {
        attachTiming: "before"
    })], t.prototype, "handleCarouselUpdate", 1),
    t
}
class Fr extends Map {
    push(t, i) {
        return this.has(t) || this.set(t, []),
        this.get(t).push(i),
        this
    }
    pop(t) {
        const i = this.get(t);
        if (!i || i.length === 0)
            return;
        const s = i.pop();
        return i.length === 0 && this.delete(t),
        s
    }
    shift(t) {
        const i = this.get(t);
        if (!i || i.length === 0)
            return;
        const s = i.shift();
        return i.length === 0 && this.delete(t),
        s
    }
    unshift(t, i) {
        return this.has(t) || this.set(t, []),
        this.get(t).unshift(i),
        this
    }
    splice(t, i, s, ...r) {
        const n = this.get(t);
        if (!n)
            return [];
        const o = n.splice(i, s ?? n.length - i, ...r);
        return n.length === 0 && this.delete(t),
        o
    }
    getLength(t) {
        const i = this.get(t);
        return i ? i.length : 0
    }
}
function as(e) {
    class t extends e {
        constructor() {
            super(...arguments),
            this._firstConnected = !1,
            this._storedChildren = new Fr,
            this._slotMarkers = new Map
        }
        slotted(s) {
            return this.slottedNodes(s).filter(r => r instanceof Element)
        }
        slottedHTMLElements(s) {
            return this.slottedNodes(s).filter(r => r instanceof HTMLElement)
        }
        slottedNodes(s) {
            return this._storedChildren.get(s ?? "") ?? []
        }
        connectedCallback() {
            this._firstConnected || (this._firstConnected = !0,
            this._captureChildren()),
            super.connectedCallback()
        }
        updated(s) {
            super.updated(s),
            this._processSlots()
        }
        _captureChildren() {
            this._storedChildren = this._groupChildrenBySlot(this),
            this.replaceChildren()
        }
        _processSlots() {
            const s = this.querySelectorAll("slot");
            for (const r of s) {
                const n = r.getAttribute("name") ?? ""
                  , o = this._storedChildren.get(n) || []
                  , a = document.createComment("")
                  , c = document.createComment("");
                r.parentNode.insertBefore(a, r);
                for (const h of o)
                    r.parentNode.insertBefore(h, r);
                r.parentNode.insertBefore(c, r),
                r.remove(),
                this._slotMarkers.set(n, {
                    start: a,
                    end: c
                })
            }
        }
        beforeMorphDOM(s, r) {
            this._storedChildren = this._groupChildrenBySlot(s);
            for (const [n,o] of this._slotMarkers)
                this._updateSlotContent(n, o);
            return !1
        }
        _getSlotName(s) {
            return s instanceof Element ? s.getAttribute("slot") ?? "" : ""
        }
        _groupChildrenBySlot(s) {
            const r = new Fr;
            for (const n of Array.from(s.childNodes)) {
                const o = this._getSlotName(n);
                n instanceof Element && n.removeAttribute("slot"),
                r.push(o, n)
            }
            return r
        }
        _updateSlotContent(s, r) {
            const {start: n, end: o} = r;
            if (!n.parentNode || !o.parentNode || n.parentNode !== o.parentNode)
                return;
            const a = this._storedChildren.get(s) || []
              , c = document.createRange();
            c.setStartAfter(n),
            c.setEndBefore(o),
            c.deleteContents();
            const h = document.createDocumentFragment();
            for (const f of a)
                h.appendChild(f.cloneNode(!0));
            c.insertNode(h)
        }
    }
    return t
}
var Zc = Object.getOwnPropertyDescriptor
  , Jc = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Zc(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let Wr = class extends T(x, as, gr) {
    constructor() {
        super(),
        this.classList.add("carousel-counter")
    }
    renderNavButton(e, t, i) {
        return p`
      <button
        type="button"
        class="${e === "prev" ? "carousel-counter__prev" : "carousel-counter__next"}"
        @click=${t}
        aria-label=${i}
      >
        <slot name="icon-${e}"></slot>
      </button>
    `
    }
    render() {
        if (this.itemCount <= 1)
            return p``;
        const e = this.activeIndex + 1
          , t = this.itemCount;
        return p`
      <div class="carousel-counter__inner">
        ${this.renderNavButton("prev", () => this.goPrev(), F("accessibility.previous"))}
        <span class="carousel-counter__label">${e}/${t}</span>
        ${this.renderNavButton("next", () => this.goNext(), F("accessibility.next"))}
      </div>
    `
    }
}
;
Wr = Jc([d("carousel-counter")], Wr);
var th = Object.getOwnPropertyDescriptor
  , eh = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? th(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let Yr = class extends T(x, gr) {
    constructor() {
        super(),
        this.classList.add("carousel-dots")
    }
    render() {
        return this.itemCount <= 1 ? p`` : [this.renderNavButton("prev", () => this.goPrev(), F("accessibility.previous_page")), ...Oo(this.itemCount, e => this.renderDot(e)), this.renderNavButton("next", () => this.goNext(), F("accessibility.next_page"))]
    }
    renderNavButton(e, t, i) {
        return p`
      <button
        type="button"
        class="${e === "prev" ? "carousel-dots__prev" : "carousel-dots__next"}"
        @click=${t}
        aria-label=${i}
      >
        <icon-element icon="chevron-down"></icon-element>
      </button>
    `
    }
    renderDot(e) {
        const t = this.activeIndex === e;
        return p`
      <button
        type="button"
        class=${fn({
            "carousel-dots__dot": !0,
            "carousel-dots__dot--active": t
        })}
        aria-label=${F("accessibility.go_to_page", {
            number: e + 1
        })}
        aria-current=${t ? "true" : "false"}
        @click=${ () => this.goIndex(e)}
      ></button>
    `
    }
}
;
Yr = eh([d("carousel-dots")], Yr);
var ih = Object.defineProperty
  , sh = Object.getOwnPropertyDescriptor
  , Vn = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? sh(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && ih(t, i, r),
    r
}
;
let qs = class extends T(x, gr) {
    constructor() {
        super(),
        this.classList.add("carousel-index-bar")
    }
    handleClick(e) {
        const i = e.currentTarget.getBoundingClientRect()
          , s = e.clientX - i.left
          , r = i.width;
        if (r > 0) {
            const n = s / r
              , o = Math.floor(n * this.itemCount)
              , a = lt(o, 0, this.itemCount - 1);
            this.goIndex(a)
        }
    }
    render() {
        if (this.itemCount <= 1)
            return p``;
        const e = Math.max(1, this.itemCount)
          , t = Math.max(0, Math.min(this.activeIndex, e - 1))
          , i = Math.max(1, e - 1)
          , s = t / i
          , r = `${100 / e}%`;
        return p`
      <div class="carousel-index-bar__track" aria-hidden="true">
        <div
          class="carousel-index-bar__container"
          style=${`--progress:${s}; --pill-width:${r}`}
        >
          <div class="carousel-index-bar__pill"></div>
        </div>
      </div>
    `
    }
}
;
Vn([l("click")], qs.prototype, "handleClick", 1),
qs = Vn([d("carousel-index-bar")], qs);
var rh = Object.defineProperty
  , nh = Object.getOwnPropertyDescriptor
  , zn = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? nh(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && rh(t, i, r),
    r
}
;
let Bs = class extends L {
    get strategyName() {
        return "drawer"
    }
    handleCartUpdated(e) {
        this.open = !1
    }
}
;
zn([l("cart:updated")], Bs.prototype, "handleCartUpdated", 1),
Bs = zn([d("cart-drawer-child")], Bs);
var oh = Object.defineProperty
  , ah = Object.getOwnPropertyDescriptor
  , Q = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? ah(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && oh(t, i, r),
    r
}
;
let X = class extends x {
    constructor() {
        super(),
        this.expires = "",
        this.daysLabel = "Days",
        this.hoursLabel = "Hours",
        this.minutesLabel = "Mins",
        this.secondsLabel = "Secs",
        this.daysRemaining = 0,
        this.hoursRemaining = 0,
        this.minutesRemaining = 0,
        this.secondsRemaining = 0,
        this.finished = !1,
        this.targetTimestampMs = 0,
        this.isInView = !1,
        this.setupIntersectionController()
    }
    setupIntersectionController() {
        new os(this,this,e => {
            const t = e.isIntersecting && e.intersectionRatio > 0;
            t !== this.isInView && (this.isInView = t,
            this.isInView ? this.restart() : this.clearTimer())
        }
        )
    }
    connectedCallback() {
        super.connectedCallback(),
        this.restart()
    }
    disconnectedCallback() {
        super.disconnectedCallback(),
        this.clearTimer()
    }
    expiresUpdated(e) {
        e !== void 0 && this.restart()
    }
    restart() {
        this.clearTimer(),
        this.parseExpires(),
        this.targetTimestampMs > 0 && (this.tick(),
        this.isInView && !this.finished && (this.intervalId = window.setInterval( () => this.tick(), 1e3)))
    }
    clearTimer() {
        this.intervalId !== void 0 && (clearInterval(this.intervalId),
        this.intervalId = void 0)
    }
    parseExpires() {
        const e = this.expires ? new Date(this.expires) : null;
        this.targetTimestampMs = e && !Number.isNaN(e.getTime()) ? e.getTime() : 0
    }
    tick() {
        const e = Date.now()
          , t = this.targetTimestampMs - e;
        if (t <= 0) {
            this.finished = !0,
            this.daysRemaining = 0,
            this.hoursRemaining = 0,
            this.minutesRemaining = 0,
            this.secondsRemaining = 0,
            this.clearTimer();
            return
        }
        this.finished = !1;
        const i = 1e3
          , s = 60 * i
          , r = 60 * s
          , n = 24 * r
          , o = Math.floor(t / n)
          , a = Math.floor(t % n / r)
          , c = Math.floor(t % r / s)
          , h = Math.floor(t % s / i);
        this.daysRemaining = o,
        this.hoursRemaining = a,
        this.minutesRemaining = c,
        this.secondsRemaining = h
    }
    render() {
        return this.targetTimestampMs ? this.finished && this.finishMessage ? p`<div class="countdown__finish-message">${this.finishMessage}</div>` : p`
      <div class="countdown__item">
        <span class="countdown__value">${this.daysRemaining}</span>
        <span class="countdown__label">${this.daysLabel}</span>
      </div>
      <div class="countdown__item">
        <span class="countdown__value">${this.hoursRemaining}</span>
        <span class="countdown__label">${this.hoursLabel}</span>
      </div>
      <div class="countdown__item">
        <span class="countdown__value">${this.minutesRemaining}</span>
        <span class="countdown__label">${this.minutesLabel}</span>
      </div>
      <div class="countdown__item">
        <span class="countdown__value">${this.secondsRemaining}</span>
        <span class="countdown__label">${this.secondsLabel}</span>
      </div>
    ` : Dt
    }
}
;
Q([u({
    type: String
})], X.prototype, "expires", 2),
Q([u({
    type: String,
    attribute: "finish-message"
})], X.prototype, "finishMessage", 2),
Q([u({
    type: String,
    attribute: "days-label"
})], X.prototype, "daysLabel", 2),
Q([u({
    type: String,
    attribute: "hours-label"
})], X.prototype, "hoursLabel", 2),
Q([u({
    type: String,
    attribute: "minutes-label"
})], X.prototype, "minutesLabel", 2),
Q([u({
    type: String,
    attribute: "seconds-label"
})], X.prototype, "secondsLabel", 2),
Q([b()], X.prototype, "daysRemaining", 2),
Q([b()], X.prototype, "hoursRemaining", 2),
Q([b()], X.prototype, "minutesRemaining", 2),
Q([b()], X.prototype, "secondsRemaining", 2),
Q([b()], X.prototype, "finished", 2),
X = Q([d("countdown-timer")], X);
var lh = Object.defineProperty
  , ch = Object.getOwnPropertyDescriptor
  , ls = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? ch(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && lh(t, i, r),
    r
}
;
let He = class extends x {
    constructor() {
        super(...arguments),
        this.duration = 2e3,
        this.hasAnimated = !1,
        this.canAnimate = !0,
        this.initialValue = ""
    }
    connectedCallback() {
        if (super.connectedCallback(),
        this.canAnimate = this.detectAnimationSupport(),
        !this.initialValue) {
            const e = (this.textContent || "").trim();
            this.initialValue = e,
            this.innerHTML = ""
        }
        this.canAnimate && (this.unsubscribeInView = Bt(this, () => this.play()))
    }
    firstUpdated() {
        document.fonts.ready.then( () => {
            this.updateGroupWidths()
        }
        )
    }
    disconnectedCallback() {
        var e;
        super.disconnectedCallback(),
        (e = this.unsubscribeInView) == null || e.call(this)
    }
    get items() {
        const e = this.initialValue || ""
          , t = [];
        for (const i of e)
            /\d/.test(i) ? t.push({
                type: "digit",
                value: Number(i)
            }) : t.push({
                type: "char",
                value: i
            });
        return t
    }
    renderItem(e, t, i) {
        if (e.type === "char")
            return p`<span class="counter__char">${e.value}</span>`;
        const s = e.value === 0 ? [...Array.from({
            length: 10
        }, (n, o) => o), 0] : Array.from({
            length: e.value + 1
        }, (n, o) => o)
          , r = i * 50;
        return p`
      <span class="counter__group" data-index=${t}>
        <span
          class="counter__track"
          data-target=${e.value}
          style=${`--counter-duration-offset: ${r}ms`}
        >
          ${s.map(n => p`<span class="counter__digit">${n}</span>`)}
        </span>
      </span>
    `
    }
    render() {
        const e = this.initialValue || "";
        if (!this.canAnimate)
            return p`<span class="counter">${e}</span>`;
        let t = 0;
        return p`
      <span
        class="counter ${this.hasAnimated ? "is-playing" : ""}"
        aria-hidden="true"
        style=${`--counter-duration: ${this.duration}ms`}
      >
        ${this.items.map( (i, s) => {
            const r = t;
            return i.type === "digit" && t++,
            this.renderItem(i, s, r)
        }
        )}
      </span>
      <span class="sr-only">${e}</span>
    `
    }
    play() {
        this.hasAnimated = !0
    }
    detectAnimationSupport() {
        try {
            if (!(typeof CSS < "u" && typeof CSS.supports == "function"))
                return !1;
            const t = CSS.supports("height", "1lh")
              , i = CSS.supports("overflow", "clip");
            return t && i
        } catch {
            return !1
        }
    }
    updateGroupWidths() {
        this.querySelectorAll(".counter__group").forEach(t => {
            const i = t.querySelector(".counter__track");
            if (!i)
                return;
            const s = i.querySelector(".counter__digit:last-child");
            if (!s)
                return;
            const n = s.getBoundingClientRect().width || s.offsetWidth;
            if (!n)
                return;
            const o = parseFloat(getComputedStyle(t).fontSize || "16")
              , a = n / (o || 16);
            w(i, {
                width: `${a}em`
            })
        }
        )
    }
}
;
ls([u({
    type: Number
})], He.prototype, "duration", 2),
ls([b()], He.prototype, "hasAnimated", 2),
ls([b()], He.prototype, "canAnimate", 2),
He = ls([d("counter-element")], He);
var hh = Object.getOwnPropertyDescriptor
  , dh = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? hh(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let Kr = class extends HTMLButtonElement {
    constructor() {
        super(),
        this.isClipboardSupported = !1,
        this.animateCopiedOut = k( () => {
            this.removeAttribute("copying")
        }
        , 2e3),
        this.checkClipboardSupport(),
        this.addEventListener("click", this.handleClick.bind(this))
    }
    get code() {
        return this.getAttribute("code")
    }
    checkClipboardSupport() {
        try {
            this.isClipboardSupported = "clipboard"in navigator && "writeText"in navigator.clipboard
        } catch {
            this.isClipboardSupported = !1
        }
        this.isClipboardSupported || this.setAttribute("manual", "")
    }
    handleClick() {
        !this.code || !this.isClipboardSupported || (this.setAttribute("copying", ""),
        navigator.clipboard.writeText(this.code).then( () => {
            this.animateCopiedOut()
        }
        ).catch( () => {
            this.setAttribute("manual", ""),
            this.removeAttribute("copying")
        }
        ))
    }
}
;
Kr = dh([d("discount-code-button", {
    extends: "button"
})], Kr);
var uh = Object.defineProperty
  , ph = Object.getOwnPropertyDescriptor
  , vr = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? ph(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && uh(t, i, r),
    r
}
;
let Ui = class extends N {
    constructor() {
        super(),
        this.handleEvent = t => {
            t.cancelable && t.preventDefault(),
            this.event && this.dispatchEvent(new CustomEvent(this.event,{
                bubbles: !0
            }))
        }
        ,
        this.on && this.on.split(",").map(t => t.trim()).forEach(t => {
            new Pn(this,this,t,this.handleEvent)
        }
        )
    }
}
;
vr([g()], Ui.prototype, "event", 2),
vr([g()], Ui.prototype, "on", 2),
Ui = vr([d("event-trigger")], Ui);
class fh {
    constructor(t, i) {
        this.sources = t,
        this.render = i,
        this.rafId = null,
        this.tick = () => {
            const r = this.sources.map(n => n.get());
            this.render(...r),
            this.sources.some(n => n.active) ? this.rafId = requestAnimationFrame(this.tick) : this.rafId = null
        }
        ;
        const s = () => this.start();
        for (const r of t)
            r.onUpdate(s)
    }
    update() {
        const t = this.sources.map(i => i.get());
        this.render(...t)
    }
    start() {
        this.rafId || (this.rafId = requestAnimationFrame(this.tick))
    }
    stop() {
        this.rafId && (cancelAnimationFrame(this.rafId),
        this.rafId = null)
    }
}
const Xr = .001
  , mh = .001;
class gh {
    constructor(t, i) {
        this.listeners = [],
        this._active = !1,
        this.startTime = 0,
        this.omega0 = 0,
        this.zeta = 0,
        this.omega1 = 0,
        this.r1 = 0,
        this.r2 = 0,
        this.startValue = t,
        this.targetValue = t,
        this._value = t,
        this.velocity = i.velocity ?? 0,
        this.mass = Math.max(i.mass, .01),
        this.stiffness = i.stiffness,
        this.damping = i.damping,
        this.calculateConstants()
    }
    get active() {
        return this._active
    }
    calculateConstants() {
        this.omega0 = Math.sqrt(this.stiffness / this.mass),
        this.zeta = this.damping / (2 * Math.sqrt(this.stiffness * this.mass)),
        Math.abs(this.zeta - 1) < mh && (this.zeta = 1),
        this.zeta < 1 ? this.omega1 = this.omega0 * Math.sqrt(1 - this.zeta * this.zeta) : this.zeta > 1 && (this.r1 = -this.omega0 * (this.zeta - Math.sqrt(this.zeta * this.zeta - 1)),
        this.r2 = -this.omega0 * (this.zeta + Math.sqrt(this.zeta * this.zeta - 1)))
    }
    set(t) {
        if (!(t === this.targetValue && !this.active)) {
            if (this.active) {
                const {x: i, v: s} = this.solve(this.getCurrentTime());
                this.startValue = i,
                this.velocity = s
            } else
                this.startValue = this.targetValue,
                this.velocity = 0;
            this.targetValue = t,
            this.startTime = performance.now(),
            this._active = !0,
            this.notify(this.targetValue)
        }
    }
    jump(t) {
        this.startValue = t,
        this.targetValue = t,
        this._value = t,
        this.velocity = 0,
        this._active = !1,
        this.notify(t)
    }
    onUpdate(t) {
        this.listeners.push(t)
    }
    notify(t) {
        for (const i of this.listeners)
            i(t)
    }
    getCurrentTime() {
        return (performance.now() - this.startTime) / 1e3
    }
    get() {
        if (!this.active)
            return this._value;
        const t = this.getCurrentTime()
          , {x: i, v: s} = this.solve(t);
        return this._value = i,
        Math.abs(s) < Xr && Math.abs(i - this.targetValue) < Xr ? (this.startValue = this.targetValue,
        this.velocity = 0,
        this._value = this.targetValue,
        this._active = !1,
        this.targetValue) : i
    }
    solve(t) {
        const i = this.startValue - this.targetValue
          , s = this.velocity;
        let r, n;
        if (this.zeta < 1) {
            const o = Math.exp(-this.zeta * this.omega0 * t)
              , a = i
              , c = (s + this.zeta * this.omega0 * i) / this.omega1
              , h = Math.sin(this.omega1 * t)
              , f = Math.cos(this.omega1 * t);
            r = o * (a * f + c * h),
            n = -this.zeta * this.omega0 * r + o * (c * this.omega1 * f - a * this.omega1 * h)
        } else if (this.zeta === 1) {
            const o = Math.exp(-this.omega0 * t)
              , a = i
              , c = s + this.omega0 * i;
            r = (a + c * t) * o,
            n = c * o - this.omega0 * r
        } else {
            const o = (s - i * this.r2) / (this.r1 - this.r2)
              , a = i - o
              , c = Math.exp(this.r1 * t)
              , h = Math.exp(this.r2 * t);
            r = o * c + a * h,
            n = o * this.r1 * c + a * this.r2 * h
        }
        return {
            x: this.targetValue + r,
            v: n
        }
    }
}
function Ss(e, t) {
    return new gh(e,t)
}
var vh = Object.defineProperty
  , yh = Object.getOwnPropertyDescriptor
  , $e = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? yh(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && vh(t, i, r),
    r
}
;
let Rt = class extends x {
    constructor() {
        super(!0),
        this.active = !1,
        this.panelSelector = "",
        this.insideContainer = !1,
        this.mouseMoved = !1,
        this.xSpring = Ss(0, {
            stiffness: 100,
            damping: 20,
            mass: 1.5
        }),
        this.ySpring = Ss(0, {
            stiffness: 100,
            damping: 20,
            mass: 1.5
        }),
        this.scaleSpring = Ss(0, {
            stiffness: 300,
            damping: 40,
            mass: 1
        }),
        this.loop = new fh([this.xSpring, this.ySpring, this.scaleSpring], (e, t, i) => {
            this.$close.style.transform = `translate(${e}px, ${t}px) scale(${i})`,
            this.$close.style.opacity = String(i)
        }
        ),
        !gs() && (this.addEventListener("mouseenter", this.handleMouseEnter.bind(this)),
        this.addEventListener("mouseleave", this.handleMouseLeave.bind(this)),
        this.addEventListener("mousemove", this.handleMouseMove.bind(this)),
        this.addEventListener("mouseover", this.handleMouseOver.bind(this)))
    }
    firstUpdated() {
        gs() || this.loop.update()
    }
    handleMouseEnter(e) {
        this.xSpring.jump(e.clientX),
        this.ySpring.jump(e.clientY)
    }
    handleMouseMove(e) {
        this.active && (this.xSpring.set(e.clientX),
        this.ySpring.set(e.clientY),
        this.mouseMoved = !0)
    }
    handleMouseLeave() {
        this.insideContainer = !1
    }
    handleMouseOver(e) {
        if (!this.panelSelector) {
            this.insideContainer = !0;
            return
        }
        this.insideContainer = !e.composedPath().some(t => t instanceof Element && t.matches(this.panelSelector))
    }
    updated() {
        const e = this.active && this.insideContainer && this.mouseMoved;
        this.scaleSpring.set(e ? 1 : 0)
    }
    activeWillUpdate(e) {
        e || (this.mouseMoved = !1)
    }
    render() {
        return gs() ? p`<slot></slot>` : p`
      <slot></slot>
      <div class="floating-close"><icon-element icon="close"></icon-element></div>
    `
    }
}
;
Rt.styles = [x.themeCSS, tt`
      :host {
        display: block;
        position: fixed;
        z-index: var(--floating-close-z-index);
        inset: 0;
        cursor: pointer;
        pointer-events: none;
      }

      :host([active]) {
        pointer-events: auto;
      }
    `],
$e([C(".floating-close")], Rt.prototype, "$close", 2),
$e([u({
    type: Boolean
})], Rt.prototype, "active", 2),
$e([u({
    type: String,
    attribute: "panel-selector"
})], Rt.prototype, "panelSelector", 2),
$e([b()], Rt.prototype, "insideContainer", 2),
$e([b()], Rt.prototype, "mouseMoved", 2),
Rt = $e([d("floating-close")], Rt);
var bh = Object.defineProperty
  , wh = Object.getOwnPropertyDescriptor
  , cs = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? wh(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && bh(t, i, r),
    r
}
;
let Ne = class extends HTMLElement {
    constructor() {
        super(),
        this.activeIndex = 0,
        this.loaded = !1,
        this.imagesPreloaded = !1
    }
    get $images() {
        return Array.from(this.querySelectorAll(":scope > .media"))
    }
    get $template() {
        return this.querySelector(":scope > template")
    }
    get imageCount() {
        return this.$images.length
    }
    get $eventTarget() {
        return this.closest("[data-hoverable-gallery-area]") ?? this
    }
    connectedCallback() {
        const e = this.$template
          , t = e ? e.content.querySelectorAll(".media").length : 0;
        if (this.$images.length + t <= 1 || !Ki()) {
            this.setAttribute("data-disabled", "");
            return
        }
        this.update(),
        this.observeVisibility()
    }
    disconnectedCallback() {
        var e;
        (e = this.observer) == null || e.disconnect()
    }
    observeVisibility() {
        this.imagesPreloaded || (this.observer = new IntersectionObserver(e => {
            for (const t of e)
                if (t.isIntersecting) {
                    this.preloadAllImages();
                    break
                }
        }
        ,{
            rootMargin: "200px"
        }),
        this.observer.observe(this))
    }
    handleMouseEnter() {
        this.hasAttribute("data-disabled") || (this.preloadAllImages(),
        this.loaded = !0,
        this.setAttribute("data-hovering", ""),
        this.update())
    }
    handleMouseMove(e) {
        if (this.hasAttribute("data-disabled") || !this.loaded || this.imageCount <= 1)
            return;
        const {left: t, width: i} = this.getBoundingClientRect()
          , s = e.clientX - t
          , r = Math.max(0, Math.min(1, s / Math.max(1, i)))
          , n = Math.min(this.imageCount - 1, Math.max(0, Math.floor(r * this.imageCount - 1e-6)));
        n !== this.activeIndex && (this.activeIndex = n,
        this.update())
    }
    handleMouseLeave() {
        this.hasAttribute("data-disabled") || (this.activeIndex = 0,
        this.loaded = !1,
        this.removeAttribute("data-hovering"),
        this.update())
    }
    preloadAllImages() {
        var t;
        if (this.imagesPreloaded)
            return;
        this.imagesPreloaded = !0,
        (t = this.observer) == null || t.disconnect();
        const e = this.$template;
        e && (e.outerHTML = e.innerHTML),
        this.update()
    }
    update() {
        this.$images.forEach( (i, s) => {
            const r = s === this.activeIndex;
            w(i, {
                visibility: r ? "visible" : "hidden"
            })
        }
        );
        const t = this.imageCount;
        t > 1 && w(this, {
            "--hoverable-indicator-index": String(this.activeIndex),
            "--hoverable-indicator-count": String(t)
        })
    }
    beforeMorphDOM() {
        var e;
        return this.imagesPreloaded = !1,
        (e = this.observer) == null || e.disconnect(),
        queueMicrotask( () => {
            this.connectedCallback()
        }
        ),
        !0
    }
}
;
cs([l("mouseenter", e => e.$eventTarget)], Ne.prototype, "handleMouseEnter", 1),
cs([l("mousemove", e => e.$eventTarget)], Ne.prototype, "handleMouseMove", 1),
cs([l("mouseleave", e => e.$eventTarget)], Ne.prototype, "handleMouseLeave", 1),
Ne = cs([d("hoverable-gallery")], Ne);
var $h = Object.getOwnPropertyDescriptor
  , Sh = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? $h(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
const Ch = {
    close: `<svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path
      d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
    />
  </svg>`,
    plus: `<svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path d="M417-417H166v-126h251v-251h126v251h251v126H543v251H417v-251Z" />
  </svg>`,
    minus: `<svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path d="M166-417v-126h628v126H166Z" />
  </svg>`,
    fullscreen: `<svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path
      d="M86-86v-260h126v134h134v126H86Zm529 0v-126h133v-134h126v260H615ZM86-615v-259h260v126H212v133H86Zm662 0v-133H615v-126h259v259H748Z"
    />
  </svg>`,
    "model-button": `<svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="32" cy="32" r="31" fill="white" stroke="#E5E7EB" stroke-width="1.25" />
    <path
      d="M30.3867 44.5583L22.5645 39.9083C22.0832 39.6171 21.6866 39.2105 21.4127 38.7274C21.1388 38.2442 20.9967 37.7007 21.0001 37.1488V27.8512C20.9972 27.2996 21.1392 26.7565 21.4126 26.2735C21.686 25.7905 22.0817 25.3837 22.5621 25.0916L30.3842 20.4488C30.8698 20.1564 31.4292 20.001 32.0001 20C32.5706 19.9998 33.13 20.154 33.6159 20.4453L41.4381 25.0881C41.92 25.3808 42.3167 25.7891 42.5903 26.274C42.8638 26.7588 43.0048 27.3039 43.0001 27.8571V37.1536C43.0033 37.7054 42.8612 38.2487 42.5876 38.7318C42.3139 39.2149 41.9178 39.6215 41.4369 39.9131L33.6146 44.5631C33.1277 44.8502 32.5692 45.0014 32.0001 45C31.4309 44.9998 30.8727 44.8469 30.3867 44.5583ZM31.6627 22.4738L23.8405 27.1167C23.7171 27.1959 23.6164 27.3042 23.5478 27.4316C23.4792 27.559 23.4449 27.7014 23.4482 27.8453V37.1429C23.4448 37.2863 23.479 37.4281 23.5474 37.5551C23.6158 37.6821 23.7163 37.7902 23.8393 37.869L30.7778 42V32.9988C30.7792 32.6187 30.886 32.2461 31.087 31.9201C31.2879 31.5943 31.5756 31.3274 31.9194 31.1476L39.8785 26.9536L32.3423 22.4762C32.2398 22.4135 32.1211 22.3805 32.0001 22.381C31.8809 22.3806 31.7641 22.4128 31.6627 22.4738Z"
      fill="currentColor"
    />
  </svg>`,
    "play-button": `<svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    class="transition-transform group-hover:scale-105 group-active:scale-100"
  >
    <circle cx="32" cy="32" r="31" fill="white" stroke="#E5E7EB" stroke-width="1.25" />
    <path d="M44 32L26 42.3923L26 21.6077L44 32Z" fill="#0A0C10" />
  </svg>`,
    "chevron-down": `<svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path d="M480-349 246-583l53-52 181 181 181-181 53 52-234 234Z" />
  </svg>`
};
let Gr = class extends HTMLElement {
    connectedCallback() {
        this.replaceWithSvg()
    }
    replaceWithSvg() {
        var s;
        const e = this.getAttribute("icon");
        if (!e)
            return;
        const t = Ch[e];
        if (!t)
            return;
        const i = gn(t);
        i instanceof SVGElement && (Array.from(this.attributes).filter(r => r.name !== "icon").forEach(r => i.setAttribute(r.name, r.value)),
        (s = this.parentNode) == null || s.replaceChild(i, this))
    }
}
;
Gr = Sh([d("icon-element")], Gr);
var xh = Object.defineProperty
  , _h = Object.getOwnPropertyDescriptor
  , Se = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? _h(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && xh(t, i, r),
    r
}
;
let Xt = class extends N {
    constructor() {
        super(...arguments),
        this.position = .5,
        this.startClientX = null,
        this.startPosition = .5,
        this.dragContainerWidth = null
    }
    connectedCallback() {
        super.connectedCallback(),
        this.setupAria()
    }
    get $handle() {
        return this.querySelector('[data-part="handle"]')
    }
    get $divider() {
        return this.querySelector('[data-part="divider"]')
    }
    setupAria() {
        const e = this.$handle;
        e && (e.hasAttribute("tabindex") || (e.tabIndex = 0),
        e.setAttribute("role", "slider"),
        e.setAttribute("aria-valuemin", "0"),
        e.setAttribute("aria-valuemax", "100"))
    }
    positionUpdated() {
        var e;
        this.style.setProperty("--image-comparison-progress", String(this.position)),
        (e = this.$handle) == null || e.setAttribute("aria-valuenow", String(Math.round(this.position * 100)))
    }
    handlePointerDown(e) {
        const t = this.$handle;
        if (t && typeof t.setPointerCapture == "function")
            try {
                t.setPointerCapture(e.pointerId)
            } catch {}
        this.startClientX = e.clientX,
        this.startPosition = this.position;
        const i = this.getBoundingClientRect();
        this.dragContainerWidth = i.width || null
    }
    handlePointerMove(e) {
        this.startClientX != null && this.updatePositionFromDelta(e.clientX)
    }
    handlePointerUp() {
        this.startClientX != null && (this.startClientX = null,
        this.dragContainerWidth = null)
    }
    updatePositionFromDelta(e) {
        if (this.startClientX == null || !this.dragContainerWidth)
            return;
        const t = e - this.startClientX
          , i = lt(this.startPosition + t / this.dragContainerWidth, 0, 1);
        this.position = i
    }
    handleKeyDown(e) {
        e.key === "ArrowLeft" ? (e.preventDefault(),
        this.position = lt(this.position - .02, 0, 1)) : e.key === "ArrowRight" && (e.preventDefault(),
        this.position = lt(this.position + .02, 0, 1))
    }
}
;
Se([u({
    type: Number
})], Xt.prototype, "position", 2),
Se([l("pointerdown", e => e.$handle)], Xt.prototype, "handlePointerDown", 1),
Se([l("pointermove", document)], Xt.prototype, "handlePointerMove", 1),
Se([l(["pointerup", "pointercancel"], document)], Xt.prototype, "handlePointerUp", 1),
Se([l("keydown", e => e.$handle)], Xt.prototype, "handleKeyDown", 1),
Xt = Se([d("image-comparison")], Xt);
var Oh = Object.getOwnPropertyDescriptor
  , Ph = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Oh(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let Qr = class extends St {
    getPopoverTriggerOptions() {
        return {
            ...super.getPopoverTriggerOptions(),
            openDelay: 0,
            hideDelay: 100,
            trigger: "hover"
        }
    }
    getFloatingDefaults() {
        return {
            placement: "bottom"
        }
    }
    animateIn() {
        return [[this.$popover, {
            opacity: 1,
            scale: 1
        }, {
            duration: .6,
            ease: "power3.out"
        }]]
    }
    animateOut() {
        return [[this.$popover, {
            opacity: 0,
            scale: 0
        }, {
            duration: .25,
            ease: "power1.in"
        }]]
    }
}
;
Qr = Ph([d("image-hotspot")], Qr);
var Ih = Object.defineProperty
  , Ah = Object.getOwnPropertyDescriptor
  , Fn = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Ah(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Ih(t, i, r),
    r
}
;
let Us = class extends x {
    constructor() {
        super()
    }
    get $text() {
        return this.querySelector(".media-with-text__text")
    }
    handleCarouselUpdate(e) {
        var i;
        const t = document.getElementById(e.detail.targetId);
        if (!(!t || !this.contains(t)) && (i = e.detail.activeItem) != null && i.closest(".media-with-text__text")) {
            const {style: s} = e.detail.activeItem.dataset;
            this.toggleAttribute("data-has-bg", e.detail.activeItem.hasAttribute("data-has-bg")),
            typeof s == "string" && (this.style.cssText = s)
        }
    }
}
;
Fn([l("carousel:update", document)], Us.prototype, "handleCarouselUpdate", 1),
Us = Fn([d("image-with-text-slider")], Us);
var Mh = Object.defineProperty
  , Th = Object.getOwnPropertyDescriptor
  , Cs = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Th(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Mh(t, i, r),
    r
}
;
function Eh(e) {
    const i = class extends e {
        constructor(...r) {
            super(...r),
            this.value = "",
            this.internals = this.attachInternals()
        }
        static get formAssociated() {
            return !0
        }
        handleInputMixinChange(r) {
            r.target instanceof HTMLInputElement && this.triggerChange(r.target.value)
        }
        handleInputMixinKeyDown(r) {
            r.target instanceof HTMLInputElement && r.key === "Enter" && (r.preventDefault(),
            this.triggerChange(r.target.value),
            this.updateComplete.then( () => {
                var n;
                (n = this.internals.form) == null || n.requestSubmit()
            }
            ))
        }
        updated(r) {
            super.updated(r),
            r.has("value") && this.internals.setFormValue(this.value)
        }
        triggerChange(r) {
            if (this.value === r)
                return;
            const n = this.value;
            this.value = r,
            this.updateComplete.then( () => {
                this.value !== n && this.dispatchEvent(new Event("change",{
                    bubbles: !0
                }))
            }
            )
        }
        get name() {
            return this.getAttribute("name") ?? ""
        }
    }
    ;
    i.shadowRootOptions = {
        mode: "open",
        delegatesFocus: !0
    };
    let t = i;
    return Cs([u({
        type: String
    })], t.prototype, "value", 2),
    Cs([l("change", s => s.updateComplete.then( () => s.$input), {
        optional: !0
    })], t.prototype, "handleInputMixinChange", 1),
    Cs([l("keydown", s => s.updateComplete.then( () => s.$input), {
        optional: !0
    })], t.prototype, "handleInputMixinKeyDown", 1),
    t
}
function Hs(e, t) {
    if (Array.isArray(e) || e instanceof NodeList) {
        e.forEach(i => Hs(i, t));
        return
    }
    typeof t == "function" && (t = t(e)),
    Object.entries(t).forEach( ([i,s]) => {
        s === !1 || s === null || s === void 0 ? e.removeAttribute(i) : s === !0 ? e.setAttribute(i, "") : e.setAttribute(i, String(s))
    }
    )
}
var Dh = Object.defineProperty
  , Lh = Object.getOwnPropertyDescriptor
  , Vt = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Lh(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Dh(t, i, r),
    r
}
;
function Wn(e) {
    class t extends T(e, Eh) {
        constructor() {
            super(...arguments),
            this.open = !1,
            this.data = [],
            this.query = "",
            this.activeIndex = -1,
            this.itemsInitialized = !1,
            this.keyboardNavigation = !1,
            this.appliedDatasetKeys = new Set
        }
        connectedCallback() {
            this.loadSelectedItemOnly(),
            super.connectedCallback()
        }
        get filteredData() {
            if (!this.query.trim())
                return this.data;
            const s = this.query.toLowerCase();
            return this.data.filter(r => {
                const n = this.getItemTitle(r).toLowerCase();
                return Po(s, n)
            }
            )
        }
        get selectedItemData() {
            return this.data.find(s => s.value === this.value)
        }
        get $input() {
            return null
        }
        get $itemsTemplate() {
            return this.querySelector("template")
        }
        get $itemElements() {
            return [...this.$popover.querySelectorAll("[role=option]:not([hidden])")]
        }
        get $activeItem() {
            return this.$itemElements[this.activeIndex]
        }
        get buttonAttributes() {
            return {
                type: "button",
                "aria-expanded": String(this.open)
            }
        }
        get popoverAttributes() {
            return {
                role: "listbox",
                "aria-activedescendant": this.open && this.$activeItem ? this.$activeItem.id : void 0
            }
        }
        loadItems() {
            const s = this.$itemsTemplate;
            s && (this.data = Array.from(s.content.children).filter(r => r instanceof HTMLElement && r.hasAttribute("data-value")).map(r => ({
                value: r.dataset.value ?? "",
                dataset: r.dataset,
                element: r
            })))
        }
        ensureItemsLoaded(s=!1) {
            !s && this.itemsInitialized || (this.loadItems(),
            this.itemsInitialized = !0)
        }
        loadSelectedItemOnly() {
            const s = this.$itemsTemplate;
            if (!s)
                return;
            const r = this.value ? Array.from(s.content.children).find(n => n instanceof HTMLElement && n.getAttribute("data-value") === this.value) : null;
            r instanceof HTMLElement ? this.data = [{
                value: r.dataset.value ?? "",
                dataset: r.dataset,
                element: r
            }] : this.data = [],
            this.applyDataAttributes()
        }
        applyDataAttributes() {
            var r;
            for (const n of this.appliedDatasetKeys)
                delete this.dataset[n];
            this.appliedDatasetKeys.clear();
            const s = (r = this.selectedItemData) == null ? void 0 : r.dataset;
            if (s)
                for (const [n,o] of Object.entries(s))
                    n !== "value" && (this.dataset[n] = o ?? "",
                    this.appliedDatasetKeys.add(n))
        }
        handlePanelMouseMove() {
            this.keyboardNavigation = !1
        }
        handleItemMouseOver(s) {
            !this.keyboardNavigation && Ki() && (this.activeIndex = s)
        }
        async handleItemClick(s) {
            this.triggerChange(s.value),
            this.open = !1
        }
        handleKeyDown(s) {
            switch (s.key) {
            case "ArrowUp":
                s.preventDefault(),
                this.keyboardNavigation = !0,
                this.open ? (this.activeIndex = Math.max(0, this.activeIndex - 1),
                this.updateComplete.then( () => this.scrollToActiveItem())) : this.open = !0;
                break;
            case "ArrowDown":
                s.preventDefault(),
                this.keyboardNavigation = !0,
                this.open ? (this.activeIndex = Math.min(this.filteredData.length - 1, this.activeIndex + 1),
                this.updateComplete.then( () => this.scrollToActiveItem())) : this.open = !0;
                break;
            case "Enter":
                if (this.open) {
                    s.preventDefault();
                    const r = this.filteredData[this.activeIndex];
                    this.open = !1,
                    this.updateComplete.then( () => {
                        this.triggerChange(r?.value.toString() ?? "")
                    }
                    )
                }
                break
            }
        }
        scrollToActiveItem() {
            if (!this.$activeItem)
                return;
            const s = this.$activeItem
              , n = this.$popover.getBoundingClientRect()
              , o = s.getBoundingClientRect()
              , a = o.top < n.top
              , c = o.bottom > n.bottom;
            (a || c) && s.scrollIntoView({
                block: "nearest"
            })
        }
        willUpdate(s) {
            super.willUpdate(s),
            s.has("open") && this.open && (this.ensureItemsLoaded(),
            this.query = "",
            this.activeIndex = this.filteredData.findIndex(r => r.value === this.value)),
            s.has("query") && !s.has("open") && (this.activeIndex = 0),
            s.has("value") && !this.itemsInitialized && this.loadSelectedItemOnly()
        }
        updated(s) {
            super.updated(s),
            Hs(this.$button, this.buttonAttributes),
            Hs(this.$popover, this.popoverAttributes),
            s.has("value") && this.applyDataAttributes()
        }
        getItemTitle(s) {
            return s?.dataset.title ?? s?.element.textContent.trim() ?? s?.value ?? ""
        }
        renderListboxItems() {
            if (!this.itemsInitialized)
                return [];
            const s = new Set(this.filteredData.map(r => r.value));
            return this.data.map( (r, n) => {
                const o = s.has(r.value)
                  , a = this.filteredData.findIndex(c => c.value === r.value);
                return this.renderListboxItem(r, n, o, a)
            }
            )
        }
        renderListboxItem(s, r, n, o) {
            return p`<div
        id=${`${this.id}-${r}`}
        class="listbox__item"
        role="option"
        ?hidden=${!n}
        data-active=${o === this.activeIndex}
        data-selected=${s.value === this.value}
        @click=${ () => this.handleItemClick(s)}
        @mouseover=${ () => this.handleItemMouseOver(o)}
      >
        ${this.renderListboxItemContent(s, r, o)}
      </div>`
        }
        renderListboxItemContent(s, r, n) {
            return dr(s.element.childNodes)
        }
        beforeMorphDOM(s, r) {
            this.value = s.getAttribute("value") ?? "";
            const n = this.$itemsTemplate
              , o = s.querySelector("template");
            return n && o && (n.content.replaceChildren(...o.content.cloneNode(!0).children),
            this.open || this.itemsInitialized ? this.ensureItemsLoaded(!0) : this.loadSelectedItemOnly()),
            !1
        }
    }
    return Vt([u({
        type: Boolean,
        reflect: !0
    })], t.prototype, "open", 2),
    Vt([b()], t.prototype, "data", 2),
    Vt([b()], t.prototype, "query", 2),
    Vt([b()], t.prototype, "activeIndex", 2),
    Vt([u({
        type: String
    })], t.prototype, "label", 2),
    Vt([l("mousemove", i => i.updateComplete.then( () => i.$popover))], t.prototype, "handlePanelMouseMove", 1),
    Vt([l("keydown", i => i.updateComplete.then( () => [i.$button, i.$popover]))], t.prototype, "handleKeyDown", 1),
    t
}
var kh = Object.defineProperty, Rh = Object.getOwnPropertyDescriptor, Yn = e => {
    throw TypeError(e)
}
, se = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Rh(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && kh(t, i, r),
    r
}
, Kn = (e, t, i) => t.has(e) || Yn("Cannot " + i), xs = (e, t, i) => (Kn(e, t, "read from private field"),
i ? i.call(e) : t.get(e)), _s = (e, t, i) => t.has(e) ? Yn("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, i), Os = (e, t, i, s) => (Kn(e, t, "write to private field"),
t.set(e, i),
i), mi, gi, vi;
let xt = class extends T(x, hr, Wn, lr, cr) {
    constructor() {
        super(...arguments),
        this.autoWidth = !1,
        _s(this, mi),
        _s(this, gi),
        _s(this, vi),
        this.mobileQuery = new Ut(this,"not all and (min-width: 768px)")
    }
    get $button() {
        return xs(this, mi)
    }
    set $button(e) {
        Os(this, mi, e)
    }
    get $popover() {
        return xs(this, gi)
    }
    set $popover(e) {
        Os(this, gi, e)
    }
    get $modal() {
        return xs(this, vi)
    }
    set $modal(e) {
        Os(this, vi, e)
    }
    get $floating() {
        return this.$popover
    }
    get $reference() {
        return this.$button
    }
    getFloatingDefaults() {
        return {
            placement: "bottom-start",
            offset: 8,
            flip: {
                crossAxis: !1,
                mainAxis: !0
            },
            size: !0,
            minHeight: 260,
            maxHeight: 480,
            matchWidth: !this.autoWidth
        }
    }
    onOpenStateChange(e) {
        var i, s;
        if (Ro(768))
            return this.$modal.open = this.open,
            (i = this.outsideClickController) == null || i.disable(),
            !1;
        (s = this.outsideClickController) == null || s.enable();
        let t;
        this.open ? (this.$popover.hidden = !1,
        this.startFloatingAutoUpdate(),
        t = this.animateIn()) : (this.stopFloatingAutoUpdate(),
        t = this.animateOut(),
        t.then( () => {
            this.$popover.hidden = !0
        }
        )),
        e === void 0 && t.complete()
    }
    animateIn() {
        return E(this.$popover, {
            opacity: [0, 1],
            transform: ["translateY(8px)", "none"]
        }, {
            duration: .1
        })
    }
    animateOut() {
        return E(this.$popover, {
            opacity: [1, 0]
        }, {
            duration: .1
        })
    }
    render() {
        const e = [this.renderPopover()];
        return this.mobileQuery.matches && e.push(this.renderMobileModal()),
        this.renderPortal(e),
        this.renderButton()
    }
    renderButton() {
        return p`
      <button
        data-part="button"
        class="listbox__button"
        data-variant=${this.variant ?? "default"}
        data-size=${this.size ?? "medium"}
      >
        ${this.renderButtonContent()}
      </button>
    `
    }
    renderPopover() {
        return p`
      <div data-part="popover" class="listbox__popover" hidden>
        ${this.mobileQuery.matches ? Dt : this.renderListboxItems()}
      </div>
    `
    }
    renderButtonContent() {
        var t;
        const e = (t = this.selectedItemData) == null ? void 0 : t.element.querySelector(".listbox-swatch");
        return p`
      ${this.variant === "inline" && this.label ? p`<span class="listbox__button-label">${this.label}:</span>` : Dt}
      ${e ? p`<div class="align-first-line">${dr(e)}</div>` : Dt}
      <span>${this.getItemTitle(this.selectedItemData)}</span>
      <icon-element class="align-first-line" icon="chevron-down"></icon-element>
    `
    }
    renderMobileModal() {
        return p`
      <modal-element @modal:hide=${ () => this.open = !1}>
        <div class="bg-white p-6">
          <div class="mb-4 flex justify-between">
            <div class="h6">${this.label}</div>
          </div>
          <div class="-mx-3">${this.renderListboxItems()}</div>
        </div>
      </modal-element>
    `
    }
}
;
mi = new WeakMap,
gi = new WeakMap,
vi = new WeakMap,
xt.styles = [x.themeCSS, tt`
      :host {
        display: block;
        position: relative;
      }
    `],
se([u({
    type: String
})], xt.prototype, "variant", 2),
se([u({
    type: String
})], xt.prototype, "size", 2),
se([u({
    type: Boolean,
    attribute: "auto-width"
})], xt.prototype, "autoWidth", 2),
se([C("[data-part=button]")], xt.prototype, "$button", 1),
se([is("[data-part=popover]")], xt.prototype, "$popover", 1),
se([is("modal-element")], xt.prototype, "$modal", 1),
xt = se([d("listbox-element")], xt);
function qh(e) {
    return function(t, i, s) {
        if (s)
            return {
                get() {
                    return this.slotted(e)[0]
                },
                enumerable: !0,
                configurable: !0
            };
        Object.defineProperty(t, i, {
            get() {
                return this.slotted(e)[0]
            },
            enumerable: !0,
            configurable: !0
        })
    }
}
function Bh(e) {
    return function(t, i, s) {
        if (s)
            return {
                get() {
                    const r = this.renderRoot.querySelectorAll(e);
                    return Array.from(r)
                },
                enumerable: !0,
                configurable: !0
            };
        Object.defineProperty(t, i, {
            get() {
                const r = this.renderRoot.querySelectorAll(e);
                return Array.from(r)
            },
            enumerable: !0,
            configurable: !0
        })
    }
}
var Uh = Object.defineProperty, Hh = Object.getOwnPropertyDescriptor, Xn = e => {
    throw TypeError(e)
}
, re = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Hh(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Uh(t, i, r),
    r
}
, Gn = (e, t, i) => t.has(e) || Xn("Cannot " + i), Oe = (e, t, i) => (Gn(e, t, "read from private field"),
i ? i.call(e) : t.get(e)), Pe = (e, t, i) => t.has(e) ? Xn("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, i), Ie = (e, t, i, s) => (Gn(e, t, "write to private field"),
t.set(e, i),
i), yi, bi, wi, $i, Si;
let _t = class extends T(x, as, hr, lr, cr) {
    constructor() {
        super(...arguments),
        this.backdrop = "",
        Pe(this, yi),
        Pe(this, bi),
        Pe(this, wi),
        Pe(this, $i),
        Pe(this, Si)
    }
    get $button() {
        return Oe(this, yi)
    }
    set $button(e) {
        Ie(this, yi, e)
    }
    get $popover() {
        return Oe(this, bi)
    }
    set $popover(e) {
        Ie(this, bi, e)
    }
    get $animationItems() {
        return Oe(this, wi)
    }
    set $animationItems(e) {
        Ie(this, wi, e)
    }
    get $panel() {
        return Oe(this, $i)
    }
    set $panel(e) {
        Ie(this, $i, e)
    }
    get $corners() {
        return Oe(this, Si)
    }
    set $corners(e) {
        Ie(this, Si, e)
    }
    get $reference() {
        return this.closest("[data-navigation-dropdown-reference") ?? this
    }
    get $floating() {
        return this.$popover
    }
    get isTopAligned() {
        var e;
        return (e = this.getFloatingPositionOptions().placement) == null ? void 0 : e.startsWith("top")
    }
    getFloatingDefaults() {
        return {
            placement: "bottom-start",
            offset: -1,
            flip: !1
        }
    }
    onOpenStateChange(e) {
        this.handleAnimation(e)
    }
    onFloatingPropertiesUpdated() {
        this.classList.toggle("header-dropdown--flip", this.isTopAligned)
    }
    async handleAnimation(e) {
        const t = []
          , i = this.isTopAligned ? "" : "-";
        this.backdrop && m(document, this.open ? "backdrop:show" : "backdrop:hide", {
            name: this.backdrop,
            activator: this
        }),
        this.open ? (ht(this.$animationItems),
        this.$popover.hidden = !1,
        this.startFloatingAutoUpdate(),
        t.push([this.$corners, {
            scale: "1 1"
        }, {
            duration: .38,
            at: 0,
            ease: "power2.inOut"
        }], [this.$panel, {
            transform: `translateY(${i}0)`
        }, {
            duration: .38,
            ease: "power2.inOut",
            at: "<"
        }], [this.$animationItems.slice(0, 20), {
            transform: ["translateX(0.5rem)", "none"],
            opacity: [0, 1]
        }, {
            at: "<+0.18",
            duration: .8,
            ease: "power3.out",
            delay: W(.05)
        }])) : (this.stopFloatingAutoUpdate(),
        t.push([this.$panel, {
            transform: `translateY(${i}100%)`
        }, {
            duration: .25,
            ease: "power2.in"
        }], [this.$corners, {
            scale: "1 0"
        }, {
            duration: .17,
            at: "<+0.075",
            ease: "power2.in"
        }], [this.$animationItems.slice(0, 20), {
            transform: "none",
            opacity: 0
        }, {
            at: 0,
            duration: .16,
            ease: "power2.out"
        }])),
        e === void 0 ? ve(t) : await A(t),
        this.open || (this.$popover.hidden = !0)
    }
    render() {
        return p`
      <slot></slot>
      <slot name="button"></slot>
      <div data-part="popover" class="dropdown-base" hidden>
        ${this.renderRoundSVGLeft()} ${this.renderPanel()} ${this.renderRoundSVGRight()}
      </div>
    `
    }
    renderPanel() {
        return p`
      <div class="header-dropdown__clip">
        <div class="header-dropdown__panel" data-part="panel">${this.renderContent()}</div>
      </div>
    `
    }
    renderContent() {
        return p`<slot></slot>`
    }
    renderRoundSVGLeft() {
        return p`
      <svg
        class="header-dropdown__corner-svg"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d=${this.getLeftPath()} fill="rgb(var(--background-color))" />
      </svg>
    `
    }
    renderRoundSVGRight() {
        return p`
      <svg
        class="header-dropdown__corner-svg"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d=${this.getRightPath()} fill="rgb(var(--background-color))" />
      </svg>
    `
    }
    getLeftPath() {
        return this.isTopAligned ? "M24.0033 24H0C18.9005 23.8195 23.8918 18.3064 24.0033 0V24Z" : "M25 25H24V24.7168C23.8386 6.63671 18.8027 1.17954 0 1V0H25V25Z"
    }
    getRightPath() {
        return this.isTopAligned ? "M0.00325966 24H24.0065C5.10601 23.8195 0.114735 18.3064 0.00325966 0V24Z" : "M0 25H1V24.7168C1.16139 6.63671 6.1973 1.17954 25 1V0H0V25Z"
    }
}
;
yi = new WeakMap,
bi = new WeakMap,
wi = new WeakMap,
$i = new WeakMap,
Si = new WeakMap,
re([u({
    type: String
})], _t.prototype, "backdrop", 2),
re([qh("button")], _t.prototype, "$button", 1),
re([C("[data-part=popover]")], _t.prototype, "$popover", 1),
re([Bh("[data-part=animation-item]")], _t.prototype, "$animationItems", 1),
re([C("[data-part=panel]")], _t.prototype, "$panel", 1),
re([Fs(".header-dropdown__corner-svg")], _t.prototype, "$corners", 1),
_t = re([d("navigation-dropdown")], _t);
var Nh = Object.defineProperty
  , jh = Object.getOwnPropertyDescriptor
  , yr = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? jh(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Nh(t, i, r),
    r
}
;
let Hi = class extends T(_t, Wn) {
    constructor() {
        super(...arguments),
        this.type = "country",
        this.mobileQuery = new Ut(this,"not all and (min-width: 1024px)")
    }
    get $animationItems() {
        return [...super.$animationItems, ...this.$itemElements]
    }
    triggerChange(e) {
        const t = this.closest("form");
        if (t && e) {
            const i = document.createElement("input");
            i.type = "hidden",
            i.name = this.type === "country" ? "country_code" : "locale_code",
            i.value = e,
            t.appendChild(i),
            t.submit()
        }
    }
    onOpenStateChange(e) {
        var t, i;
        if (this.mobileQuery.matches)
            return (t = this.outsideClickController) == null || t.disable(),
            !1;
        (i = this.outsideClickController) == null || i.enable(),
        super.onOpenStateChange(e),
        this.open && this.updateMinHeight()
    }
    updateMinHeight() {
        Et.render( () => {
            this.$panel.style.minHeight = ""
        }
        ),
        Et.read( () => {
            const e = this.$panel.clientHeight;
            Et.render( () => {
                this.$panel.style.minHeight = `${e}px`
            }
            )
        }
        )
    }
    render() {
        return this.mobileQuery.matches ? this.renderPortal(p`
        <modal-element ?open=${this.open} @modal:hide=${ () => this.open = !1}>
          <div class="p-4">${this.renderContent()}</div>
        </modal-element>
      `) : this.renderPortal(Dt),
        super.render()
    }
    renderContent() {
        const e = this.type === "country" ? "general.localization.country.heading" : "general.localization.language.heading";
        return p`
      <h2 class="localization-listbox__heading">${F(e)}</h2>
      ${this.type === "country" ? p`
            <div class="input input--small mb-3">
              <input
                data-part="animation-item"
                type="text"
                placeholder=${F("general.listbox.search_placeholder")}
                @input=${t => this.query = t.target.value}
                .value=${this.query}
              />
            </div>
          ` : Dt}
      <div class="localization-listbox-list" data-drag-close-container>
        ${this.renderListboxItems()}
      </div>
    `
    }
}
;
yr([u({
    type: String
})], Hi.prototype, "type", 2),
yr([is("modal-element")], Hi.prototype, "$modal", 2),
Hi = yr([d("localization-listbox")], Hi);
var Vh = Object.defineProperty
  , zh = Object.getOwnPropertyDescriptor
  , hs = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? zh(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Vh(t, i, r),
    r
}
;
let je = class extends N {
    constructor() {
        super(),
        this.speed = 80,
        this.isInView = !1,
        this.rebuildDebounced = k( () => this.rebuildImmediate(), 50),
        this.style.visibility = "hidden",
        new os(this,this,e => {
            this.isInView = e.isIntersecting,
            this.toggleAttribute("animate", this.isInView)
        }
        ),
        new ss(this, () => [this, this.$track].filter(e => !!e), () => this.rebuildDebounced())
    }
    connectedCallback() {
        super.connectedCallback(),
        this.rebuildDebounced()
    }
    get $track() {
        return this.querySelector('[data-part="track"]')
    }
    rebuildImmediate() {
        const e = this.$track;
        if (!e)
            return;
        this.querySelectorAll('[data-part="track"][data-clone="true"]').forEach(n => n.remove());
        const t = this.getBoundingClientRect().width
          , i = e.getBoundingClientRect().width;
        if (!t || !i)
            return;
        const s = Math.max(3, Math.ceil((t + i) / i));
        for (let n = 1; n < s; n++) {
            const o = e.cloneNode(!0);
            o.setAttribute("data-clone", "true"),
            this.appendChild(o)
        }
        const r = i / this.speed;
        this.style.setProperty("--scrolling-text-duration", `${r}s`),
        this.restartAnimations(),
        this.style.visibility = ""
    }
    restartAnimations() {
        const e = this.isInView;
        this.toggleAttribute("animate", !1),
        this.offsetWidth,
        e && this.toggleAttribute("animate", !0)
    }
    handleMouseOver(e) {
        e.target.closest("a") && this.toggleAttribute("paused", !0)
    }
    handleMouseOut(e) {
        e.target.closest("a") && this.toggleAttribute("paused", !1)
    }
}
;
hs([u({
    type: Number
})], je.prototype, "speed", 2),
hs([l("mouseover")], je.prototype, "handleMouseOver", 1),
hs([l("mouseout")], je.prototype, "handleMouseOut", 1),
je = hs([d("marquee-element")], je);
var Fh = Object.defineProperty
  , Wh = Object.getOwnPropertyDescriptor
  , bt = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Wh(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Fh(t, i, r),
    r
}
;
function Yh(e) {
    class t extends T(e, Zi) {
        constructor(...s) {
            super(...s),
            this.autoplay = !1,
            this.mediaId = "",
            this.isScrolling = !1,
            this.loop = !0,
            this.slideHeightCache = new WeakMap,
            this.cachedMinimumHeight = 0,
            this.measurement = new Rn(Yi(),"horizontal"),
            this.slidesResizeObserver = new ResizeObserver(r => {
                var o;
                let n = !1;
                for (const a of r) {
                    const c = a.target
                      , h = ((o = a.borderBoxSize[0]) == null ? void 0 : o.blockSize) ?? c.clientHeight
                      , f = c.closest('[data-part="media-carousel-carousel"] > *');
                    f && (this.slideHeightCache.set(f, h),
                    f === this.$activeItem && (n = !0))
                }
                n && this.applyHeight()
            }
            )
        }
        connectedCallback() {
            super.connectedCallback(),
            this.handleSlotChange(),
            this.observeSlides(),
            this.updateCompleteAndConnected( () => {
                this.measureMinimumHeight(),
                this.applyHeight()
            }
            )
        }
        disconnectedCallback() {
            var s;
            super.disconnectedCallback(),
            (s = this.slidesResizeObserver) == null || s.disconnect()
        }
        handleKeydown(s) {
            if (s.key === "Enter") {
                if (!this.$activeItem)
                    return;
                if (this.$activeItem.dataset.mediaLightbox === "true") {
                    s.preventDefault(),
                    m(this, "lightbox:open", {
                        mediaId: this.mediaId
                    }, {
                        bubbles: !0
                    });
                    return
                }
            }
        }
        get $items() {
            return Array.from(this.$carousel.children).filter(s => s instanceof HTMLElement && !s.slot && !s.hidden)
        }
        get $activeItem() {
            return this.$items[this.activeIndex]
        }
        async activeIndexUpdated(s) {
            !this.isScrolling && this.$activeItem && this.scrollToItem(this.$activeItem),
            this.updateHeight(),
            this.isScrolling = !1,
            this.preloadNextImage(),
            this.updateCarouselState()
        }
        preloadNextImage() {
            const s = this.$items[this.wrapIndex(this.activeIndex + 1)];
            s && s.querySelectorAll("img").forEach(n => {
                n.fetchPriority = "low",
                n.loading = "eager"
            }
            )
        }
        activeIndexWillUpdate(s) {
            var n;
            if (s === void 0)
                return;
            const r = (n = this.$activeItem) == null ? void 0 : n.dataset.mediaId;
            r && (this.mediaId = r),
            this.handleMediaAutoplay()
        }
        mediaIdWillUpdate(s) {
            this.mediaId && this.syncActiveIndexToMediaId()
        }
        syncActiveIndexToMediaId() {
            const s = this.getIndexByMediaId(this.mediaId);
            s !== -1 && s !== this.activeIndex && (this.activeIndex = s)
        }
        handleMediaAutoplay() {
            m(document, "media:pause", {
                mediaId: "*",
                container: this
            }),
            this.autoplay && m(document, "media:play", {
                mediaId: this.mediaId,
                container: this
            })
        }
        scrollToItem(s) {
            var n;
            const r = this.$carousel;
            (n = r.parentNode) == null || n.replaceChild(r, r),
            r.scrollLeft = s.offsetLeft
        }
        handleScroll() {
            const s = this.measurement.getScrollProgress(this.$carousel)
              , r = Math.round(s * (this.$items.length - 1));
            r !== this.activeIndex && (this.isScrolling = !0,
            this.activeIndex = r)
        }
        handleSlotChange() {
            this.itemCount = this.$items.length,
            this.updateCarouselState(),
            this.observeSlides()
        }
        observeSlides() {
            if (this.slidesResizeObserver) {
                this.slidesResizeObserver.disconnect();
                for (const s of this.$items) {
                    const r = s.querySelector(".media-carousel-slide-content") ?? s;
                    r instanceof HTMLElement && this.slidesResizeObserver.observe(r, {
                        box: "border-box"
                    })
                }
            }
        }
        measureMinimumHeight() {
            this.$heightWrapper.style.height = "0px",
            this.cachedMinimumHeight = this.clientHeight,
            this.$heightWrapper.style.height = ""
        }
        handleWindowResize() {
            this.measureMinimumHeight(),
            this.applyHeight()
        }
        beforeMorphDOM(s, r) {
            return this.mediaId = s.getAttribute("media-id") ?? this.mediaId,
            r(this, s, {
                childrenOnly: !0,
                onBeforeElUpdated(n, o) {
                    return n.hidden = o.hidden,
                    !1
                }
            }),
            this.handleSlotChange(),
            this.dispatchCarouselUpdate(),
            !1
        }
        handleScrollUnlocked() {
            this.$activeItem && this.scrollToItem(this.$activeItem)
        }
        handleLightboxChange(s) {
            const r = this.getIndexByMediaId(s.detail.mediaId);
            r !== -1 && (this.activeIndex = r)
        }
        updateHeight() {
            !this.$activeItem || this.$activeItem.clientHeight === 0 || this.applyHeight()
        }
        applyHeight() {
            if (!this.$activeItem)
                return;
            const s = this.getCachedHeight(this.$activeItem);
            this.$heightWrapper.style.maxHeight = `${Math.max(this.cachedMinimumHeight, s)}px`
        }
        getCachedHeight(s) {
            let r = this.slideHeightCache.get(s);
            return r === void 0 && (r = this.getTargetHeight(s),
            this.slideHeightCache.set(s, r)),
            r
        }
        getIndexByMediaId(s) {
            return this.$items.findIndex(r => r.dataset.mediaId === s)
        }
        getTargetHeight(s) {
            return s = s.querySelector(".media-carousel-slide-content") ?? s,
            s.clientHeight
        }
    }
    return bt([u({
        type: Boolean
    })], t.prototype, "autoplay", 2),
    bt([u({
        type: String,
        attribute: "media-id",
        reflect: !0
    })], t.prototype, "mediaId", 2),
    bt([C('[data-part="media-carousel-carousel"]')], t.prototype, "$carousel", 2),
    bt([C('[data-part="media-carousel-height-wrapper"]')], t.prototype, "$heightWrapper", 2),
    bt([l("keydown")], t.prototype, "handleKeydown", 1),
    bt([l("scroll", i => i.$carousel, {
        passive: !0
    })], t.prototype, "handleScroll", 1),
    bt([l("resize", window)], t.prototype, "handleWindowResize", 1),
    bt([l("scroll:unlocked", document)], t.prototype, "handleScrollUnlocked", 1),
    bt([l("lightbox:change", document)], t.prototype, "handleLightboxChange", 1),
    t
}
var Kh = Object.defineProperty
  , Xh = Object.getOwnPropertyDescriptor
  , Ce = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Xh(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Kh(t, i, r),
    r
}
;
let Gt = class extends T(N, Yh) {
    constructor() {
        super(...arguments),
        this.showOverlay = !0,
        this.playedMedia = new Set
    }
    handleClick(e) {
        const t = e.target
          , i = t.closest('[data-part="media-carousel-nav-overlay"]');
        if (i) {
            i.classList.contains("media-carousel__nav-overlay--prev") ? this.goPrev() : i.classList.contains("media-carousel__nav-overlay--next") && this.goNext();
            return
        }
        if (t.closest('[data-part="media-carousel-lightbox-button"]')) {
            this.openLightbox();
            return
        }
        t.closest('[data-part="media-carousel-carousel"]') && this.activeItemHasLightbox() && this.openLightbox()
    }
    handleMediaPlaying(e) {
        e.target instanceof Nt && this.playedMedia.add(e.target.mediaId),
        this.showOverlay = !1
    }
    updated(e) {
        if (super.updated(e),
        e.has("showOverlay") || e.has("itemCount")) {
            const t = this.showOverlay && this.itemCount > 1;
            this.$overlay.classList.toggle("media-carousel__overlay--active", this.showOverlay),
            this.$navOverlays.forEach(i => {
                i.hidden = !t
            }
            )
        }
        if (e.has("activeIndex")) {
            const t = this.activeItemHasLightbox();
            this.$carousel.classList.toggle("media-carousel--has-lightbox", t),
            this.classList.toggle("media-carousel--has-lightbox", t)
        }
    }
    activeIndexWillUpdate(e) {
        this.showOverlay = !0,
        super.activeIndexWillUpdate(e),
        this.playedMedia.has(this.mediaId) && (this.showOverlay = !1)
    }
    openLightbox() {
        var e;
        m(this, "lightbox:open", {
            mediaId: (e = this.$activeItem) == null ? void 0 : e.dataset.mediaId
        }, {
            bubbles: !0
        })
    }
    activeItemHasLightbox() {
        var e;
        return ((e = this.$activeItem) == null ? void 0 : e.dataset.mediaLightbox) === "true"
    }
    updateHeight() {
        if (super.updateHeight(),
        this.$activeItem && this.$activeItem.clientHeight !== 0) {
            const e = this.getCachedHeight(this.$activeItem);
            this.$overlay.style.height = `${e}px`
        }
    }
}
;
Ce([C('[data-part="media-carousel-overlay"]')], Gt.prototype, "$overlay", 2),
Ce([Fs('[data-part="media-carousel-nav-overlay"]')], Gt.prototype, "$navOverlays", 2),
Ce([u({
    type: Boolean
})], Gt.prototype, "showOverlay", 2),
Ce([l("click")], Gt.prototype, "handleClick", 1),
Ce([l("media:playing")], Gt.prototype, "handleMediaPlaying", 1),
Gt = Ce([d("media-carousel")], Gt);
var Gh = Object.defineProperty
  , Qh = Object.getOwnPropertyDescriptor
  , ne = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Qh(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Gh(t, i, r),
    r
}
;
let qt = class extends N {
    constructor() {
        super(...arguments),
        this.activeIndex = 0
    }
    get $pageRoot() {
        return this.closest(".mega-menu-tabs-page")
    }
    get $tabs() {
        return [...this.querySelectorAll("[data-mega-menu-tab]")]
    }
    get $panels() {
        return [...this.querySelectorAll("[data-mega-menu-tab-panel]")]
    }
    connectedCallback() {
        super.connectedCallback(),
        this.syncTabs()
    }
    activeIndexUpdated() {
        this.syncTabs()
    }
    handleMouseOver(e) {
        const t = e.target.closest("[data-mega-menu-tab]");
        if (!t || !this.contains(t))
            return;
        const i = this.$tabs.indexOf(t);
        i >= 0 && (this.activeIndex = i)
    }
    handleFocusIn(e) {
        const t = e.target.closest("[data-mega-menu-tab]");
        if (!t || !this.contains(t))
            return;
        const i = this.$tabs.indexOf(t);
        i >= 0 && (this.activeIndex = i)
    }
    handleKeydown(e) {
        var s;
        const t = e.target.closest("[data-mega-menu-tab]");
        if (!t || !this.contains(t))
            return;
        let i;
        switch (e.key) {
        case "ArrowDown":
        case "ArrowRight":
            e.preventDefault(),
            i = this.activeIndex < this.$tabs.length - 1 ? this.activeIndex + 1 : 0;
            break;
        case "ArrowUp":
        case "ArrowLeft":
            e.preventDefault(),
            i = this.activeIndex > 0 ? this.activeIndex - 1 : this.$tabs.length - 1;
            break;
        case "Home":
            e.preventDefault(),
            i = 0;
            break;
        case "End":
            e.preventDefault(),
            i = this.$tabs.length - 1;
            break;
        default:
            return
        }
        this.$tabs.length && (this.activeIndex = i,
        (s = this.$tabs[i]) == null || s.focus())
    }
    handleMegaOpen(e) {
        var i;
        const t = (i = this.$pageRoot) == null ? void 0 : i.id;
        t && e.detail.activeMenu === t && (this.activeIndex = 0)
    }
    handleMegaMenuChange(e) {
        var i;
        const t = (i = this.$pageRoot) == null ? void 0 : i.id;
        t && e.detail.activeMenu === t && (this.activeIndex = 0)
    }
    syncTabs() {
        var t;
        const e = ((t = this.$pageRoot) == null ? void 0 : t.id) ?? "mega-menu-tabs";
        this.$tabs.forEach( (i, s) => {
            const r = s === this.activeIndex;
            i.setAttribute("aria-selected", String(r)),
            i.setAttribute("tabindex", r ? "0" : "-1");
            const n = `${e}-tab-${s}`
              , o = `${e}-panel-${s}`;
            i.id = n,
            i.setAttribute("aria-controls", o)
        }
        ),
        this.$panels.forEach( (i, s) => {
            const r = s === this.activeIndex;
            i.setAttribute("aria-hidden", String(!r)),
            i.toggleAttribute("inert", !r);
            const n = `${e}-panel-${s}`
              , o = `${e}-tab-${s}`;
            i.id = n,
            i.setAttribute("aria-labelledby", o)
        }
        )
    }
}
;
ne([u({
    type: Number
})], qt.prototype, "activeIndex", 2),
ne([l("mouseover", void 0)], qt.prototype, "handleMouseOver", 1),
ne([l("focusin", void 0)], qt.prototype, "handleFocusIn", 1),
ne([l("keydown", void 0)], qt.prototype, "handleKeydown", 1),
ne([l("mega-menu:open", document)], qt.prototype, "handleMegaOpen", 1),
ne([l("mega-menu:menu-change", document)], qt.prototype, "handleMegaMenuChange", 1),
qt = ne([d("mega-menu-tabs")], qt);
function Zh(e, t={}) {
    var i = t.ease && Io(t.ease), s = t.from || 0, r = t.base || 0, n = t.axis, o = {
        center: .5,
        end: 1,
        edges: .5
    }[s] || 0, a, c = e.length, h, f, v, $, S, _, O, P, M, D, R;
    for (a = [],
    O = M = 1 / 0,
    P = D = -O,
    R = [],
    _ = 0; _ < c; _++)
        S = e[_].getBoundingClientRect(),
        v = (S.left + S.right) / 2,
        $ = (S.top + S.bottom) / 2,
        v < O && (O = v),
        v > P && (P = v),
        $ < M && (M = $),
        $ > D && (D = $),
        R[_] = {
            x: v,
            y: $
        };
    for (h = isNaN(s) ? O + (P - O) * o : R[s].x || 0,
    f = isNaN(s) ? M + (D - M) * o : R[s].y || 0,
    P = 0,
    O = 1 / 0,
    _ = 0; _ < c; _++)
        v = R[_].x - h,
        $ = f - R[_].y,
        a[_] = S = n ? Math.abs(n === "y" ? $ : v) : Math.sqrt(v * v + $ * $),
        S > P && (P = S),
        S < O && (O = S);
    return a.max = P - O,
    a.min = O,
    a.v = c = (t.amount || t.each * c || 0) * (s === "edges" ? -1 : 1),
    a.b = c < 0 ? r - c : r,
    function(rt) {
        var yt = a.max === 0 ? 0 : (a[rt] - a.min) / a.max;
        return a.b + (i ? i(yt) : yt) * a.v
    }
}
var Jh = Object.defineProperty
  , Ps = (e, t, i, s) => {
    for (var r = void 0, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(t, i, r) || r);
    return r && Jh(t, i, r),
    r
}
;
function td(e) {
    class t extends e {
        constructor(...s) {
            super(...s),
            this.open = !1,
            this.activeMenu = null,
            this.keyboardTriggered = !1,
            this.setupLinkController()
        }
        get $links() {
            return [...document.querySelectorAll("[data-mega-menu-link]")]
        }
        get $activePage() {
            return this.activeMenu ? this.getPage(this.activeMenu) ?? null : null
        }
        getPage(s) {
            return this.slottedHTMLElements().find(r => r.id === s)
        }
        setupLinkController() {
            this.popoverTriggerController = Bn(this, {
                trigger: "hover",
                button: this.$links,
                popover: this,
                getOpen: () => this.open,
                setOpen: ({open: s, button: r, keyboardTriggered: n}) => {
                    if (r instanceof HTMLElement) {
                        const o = r.dataset.megaMenuLink ?? null;
                        s && o !== this.activeMenu && (this.activeMenu = o),
                        s && (this.$returnFocusTo = r)
                    }
                    this.open = s,
                    this.keyboardTriggered = n
                }
                ,
                preventMouseLeave: () => this.preventMouseLeave()
            })
        }
        preventMouseLeave() {
            return !1
        }
        updated(s) {
            super.updated(s),
            (s.has("open") || s.has("activeMenu")) && this.updateAriaAttributes(),
            (s.has("open") || s.has("activeMenu") || s.has("keyboardTriggered")) && this.manageFocusTrap(),
            s.has("open") && (this.open ? m(this, "mega-menu:open", {
                activeMenu: this.activeMenu
            }, {
                bubbles: !0
            }) : (m(this, "mega-menu:close", {
                activeMenu: this.activeMenu
            }, {
                bubbles: !0
            }),
            this.handleClose())),
            s.has("activeMenu") && this.activeMenu && m(this, "mega-menu:menu-change", {
                activeMenu: this.activeMenu,
                previousMenu: s.get("activeMenu")
            }, {
                bubbles: !0
            })
        }
        manageFocusTrap() {
            if (this.focusTrap && (this.focusTrap.deactivate(),
            this.focusTrap = void 0),
            this.open && this.keyboardTriggered && this.activeMenu) {
                const s = this.$activePage;
                s && (this.focusTrap = zi(s, {
                    escapeDeactivates: !1,
                    returnFocusOnDeactivate: !1,
                    preventScroll: !0,
                    allowOutsideClick: !0,
                    initialFocus: !1
                }),
                this.focusTrap.activate())
            }
        }
        handleClose() {
            this.keyboardTriggered && this.$returnFocusTo && this.$returnFocusTo.focus(),
            this.$returnFocusTo = null
        }
        updateAriaAttributes() {
            this.$links.forEach(s => {
                const r = s.dataset.megaMenuLink
                  , n = r === this.activeMenu && this.open;
                s.setAttribute("aria-expanded", String(n)),
                r && s.setAttribute("aria-controls", r)
            }
            ),
            this.slotted().forEach(s => {
                const r = s.id === this.activeMenu && this.open;
                s.setAttribute("aria-hidden", String(!r))
            }
            )
        }
    }
    return Ps([b()], t.prototype, "open"),
    Ps([b()], t.prototype, "activeMenu"),
    Ps([b()], t.prototype, "keyboardTriggered"),
    t
}
var ed = Object.defineProperty
  , id = Object.getOwnPropertyDescriptor
  , br = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? id(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && ed(t, i, r),
    r
}
;
let Ve = class extends T(x, td) {
    constructor() {
        var e;
        super(!0),
        this.skipOpenAnimation = !1,
        this.openedViaThemeEditor = !1,
        this.handleShopifyBlockDeselect = k( () => {
            this.open = !1
        }
        , 100),
        (e = window.Shopify) != null && e.designMode && (this.addEventListener("shopify:block:select", this.handleShopifyBlockSelect),
        this.addEventListener("shopify:block:deselect", this.handleShopifyBlockDeselect))
    }
    async openUpdated(e) {
        var i;
        (i = this.transition) == null || i.stop(),
        this.style.visibility = "",
        this.$panel.style.height = "",
        m(document, this.open ? "backdrop:show" : "backdrop:hide", {
            name: "header",
            activator: this
        }),
        w(this.slotted(), s => ({
            display: s.id === this.activeMenu ? "" : "none",
            pointerEvents: "",
            opacity: ""
        }));
        const t = this.animateOpenOrClose();
        e === void 0 || this.skipOpenAnimation ? (ve(t),
        this.open || (this.style.visibility = "hidden"),
        this.skipOpenAnimation = !1) : A(t).then( () => {
            this.open || (this.style.visibility = "hidden")
        }
        ),
        this.open || (this.openedViaThemeEditor = !1)
    }
    activeMenuUpdated(e, t) {
        if (this.open && t.get("open") !== !1 && typeof e == "string") {
            const s = this.$activePage
              , r = this.getPage(e);
            if (!s || !r)
                return;
            this.animateTransition(s, r)
        } else
            w(this.slotted(), s => ({
                display: s.id === this.activeMenu ? "" : "none",
                pointerEvents: "",
                opacity: ""
            }))
    }
    preventMouseLeave() {
        return this.openedViaThemeEditor
    }
    animateOpenOrClose() {
        const e = [];
        return e.push([this.$panel, {
            clipPath: this.open ? "inset(0% 0% 0% 0%)" : "inset(0% 0% 100% 0%)"
        }, {
            duration: .5,
            ease: this.open ? "power3.out" : "power3.inOut"
        }]),
        e.push([this.$panel, {
            opacity: this.open ? [0, 1, 1] : [1, 1, 0]
        }, {
            duration: .5,
            ease: "power1.inOut",
            at: "<"
        }]),
        this.open && this.$activePage && (e.push(...this.animatePageIn(this.$activePage, "-0.25")),
        this.keyboardTriggered && Bt(this.$activePage, () => {
            var t;
            (t = this.$activePage) == null || t.focus()
        }
        )),
        e
    }
    async animateTransition(e, t) {
        var n;
        const i = this.$panel.clientHeight;
        (n = this.transition) == null || n.stop(),
        w(this.slotted(), o => ({
            display: o === e ? "" : "none",
            pointerEvents: o === e ? "" : "none",
            opacity: ""
        })),
        this.$panel.style.height = "";
        const s = this.$panel.clientHeight
          , r = [];
        r.push([this.$panel, {
            height: [`${i}px`, `${s}px`]
        }, {
            duration: .5,
            ease: "power3.inOut",
            clearProps: "height"
        }]),
        r.push(...this.animatePageOut(t, "<")),
        r.push(...this.animatePageIn(e, "-0.1")),
        t.style.display = "",
        this.transition = A(r),
        this.transition.then( () => {
            t.style.display = "none"
        }
        )
    }
    animatePageIn(e, t) {
        const i = e.querySelectorAll("[data-link-group]")
          , s = e.querySelectorAll("[data-promotion-card]")
          , r = [];
        return i.length > 0 && r.push([i, {
            transform: ["translateX(24px)", "translateX(0px)"],
            opacity: [0, 1]
        }, {
            duration: .7,
            delay: Zh(i, {
                each: .04,
                axis: "x"
            }),
            ease: "power3.out",
            at: t
        }]),
        s.length && r.push([s, {
            opacity: [0, 1],
            transform: ["translateX(24px) scale(0.95)", "translateX(0px) scale(1)"]
        }, {
            duration: .7,
            at: "<",
            delay: W(.05, {
                startDelay: i.length > 0 ? .1 : .2
            }),
            ease: "power3.out"
        }]),
        r
    }
    animatePageOut(e, t) {
        return [[e, {
            opacity: 0
        }, {
            duration: .3,
            at: t
        }]]
    }
    handleStickyHeaderUpdated(e) {
        e.detail.expanded || (this.open = !1)
    }
    render() {
        return p`
      <div class="mega-menu-panel">
        <slot></slot>
      </div>
    `
    }
    async handleShopifyBlockSelect(e) {
        this.handleShopifyBlockDeselect.cancel();
        const t = e.target;
        await this.updateComplete;
        const i = this.slotted().find(s => s.contains(t));
        i && (this.activeMenu = i.id,
        this.open = !0,
        this.skipOpenAnimation = e.detail.load,
        this.openedViaThemeEditor = !0)
    }
}
;
Ve.styles = [x.themeCSS],
br([C(".mega-menu-panel", !0)], Ve.prototype, "$panel", 2),
br([l("sticky-header:update", document)], Ve.prototype, "handleStickyHeaderUpdated", 1),
Ve = br([d("mega-menu")], Ve);
var sd = Object.getOwnPropertyDescriptor
  , rd = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? sd(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let Zr = class extends HTMLElement {
    constructor() {
        super(...arguments),
        this.effectElements = document.getElementsByTagName("menu-item-effect")
    }
    connectedCallback() {
        this.applyEffect()
    }
    applyEffectByType(e) {
        e.type === "color" && e.color && (this.style.color = e.color)
    }
    applyEffect() {
        const e = this.textContent.trim();
        if (!e)
            return;
        const i = this.getEffects().find(s => s.menuItem === e.toLowerCase());
        i && this.applyEffectByType(i)
    }
    getEffects() {
        return Array.from(this.effectElements).map(e => ({
            menuItem: (e.dataset.menuItem || "").trim().toLowerCase(),
            type: e.dataset.type || "",
            color: e.dataset.color
        }))
    }
}
;
Zr = rd([d("menu-item-label")], Zr);
var nd = Object.getOwnPropertyDescriptor
  , od = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? nd(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let Jr = class extends L {
    constructor() {
        super(...arguments),
        this.imagesLoaded = !1,
        this.desktopQuery = new Ut(this,"(min-width: 1024px)",this.handleDesktopBreakpoint.bind(this))
    }
    get strategyName() {
        return "drawer"
    }
    get mobileStrategyName() {
        return "mobile"
    }
    handleDesktopBreakpoint(e) {
        e && this.open && (this.open = !1)
    }
    afterAnimateIn() {
        super.afterAnimateIn(),
        this.imagesLoaded || (this.imagesLoaded = !0,
        this.querySelectorAll("img").forEach(e => {
            e.loading = "eager"
        }
        ))
    }
}
;
Jr = od([d("mobile-menu")], Jr);
var ad = Object.defineProperty
  , tn = (e, t, i, s) => {
    for (var r = void 0, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(t, i, r) || r);
    return r && ad(t, i, r),
    r
}
;
function ld(e) {
    var s;
    const t = (s = class extends e {
        constructor() {
            super(...arguments),
            this.delay = 5e3,
            this.frequency = 30
        }
        firstUpdated(n) {
            var o, a;
            if (super.firstUpdated(n),
            this.getAttribute("test-mode") === "true" && !((o = window.Shopify) != null && o.designMode)) {
                this.open = !0;
                return
            }
            if (!(window.location.pathname === "/challenge" || (a = window.Shopify) != null && a.designMode)) {
                if (window.location.hash && this.querySelector(window.location.hash)) {
                    this.open = !0;
                    return
                }
                this.isSubscribed() || Uo(async () => {
                    const c = localStorage.getItem(s.DISMISSED_KEY);
                    (!c || this.isTimestampExpired(Number(c))) && (this.preloadImages(),
                    await Zt(this.delay),
                    this.open = !0)
                }
                )
            }
        }
        afterAnimateOut() {
            var n;
            if (!((n = window.Shopify) != null && n.designMode))
                try {
                    localStorage.setItem(s.DISMISSED_KEY, String(Date.now()))
                } catch {}
            super.afterAnimateOut()
        }
        isTimestampExpired(n) {
            return (Date.now() - n) / 864e5 >= this.frequency
        }
        isSubscribed() {
            try {
                return !!localStorage.getItem(s.SUBSCRIBED_KEY)
            } catch {
                return !1
            }
        }
        preloadImages() {
            this.querySelectorAll("img").forEach(n => {
                n.setAttribute("loading", "eager")
            }
            )
        }
    }
    ,
    s.DISMISSED_KEY = "alloy:newsletter:popup-dismissed",
    s.SUBSCRIBED_KEY = "alloy:newsletter:subscribed",
    s);
    return tn([u({
        type: Number
    })], t.prototype, "delay"),
    tn([u({
        type: Number
    })], t.prototype, "frequency"),
    t
}
var cd = Object.getOwnPropertyDescriptor
  , hd = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? cd(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let en = class extends T(L, ld) {
    constructor() {
        super(...arguments),
        this.themeEditorSync = !0
    }
}
;
en = hd([d("newsletter-modal")], en);
var dd = Object.defineProperty
  , ud = Object.getOwnPropertyDescriptor
  , ds = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? ud(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && dd(t, i, r),
    r
}
;
let ze = class extends pt {
    get href() {
        return this.getAttribute("data-href") ?? z("data-href attribute is required")
    }
    async handleClick() {
        const e = window.scrollY;
        m(this, "section:update", {
            url: this.href,
            scrollTop: e,
            mode: "append"
        }, {
            bubbles: !0
        })
    }
    handleUpdateStart() {
        this.loading = !0
    }
    handleUpdateEnd() {
        this.loading = !1
    }
}
;
ds([l("click")], ze.prototype, "handleClick", 1),
ds([l("section:updating", "section")], ze.prototype, "handleUpdateStart", 1),
ds([l("section:updated", "section")], ze.prototype, "handleUpdateEnd", 1),
ze = ds([d("pagination-load-more", {
    extends: "button"
})], ze);
var pd = Object.defineProperty
  , fd = Object.getOwnPropertyDescriptor
  , wr = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? fd(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && pd(t, i, r),
    r
}
;
let Ni = class extends HTMLElement {
    connectedCallback() {
        this.computeDisabled()
    }
    disconnectedCallback() {}
    get $button() {
        return this.querySelector("[data-part=btn-add-to-cart]")
    }
    get $sections() {
        return this.querySelectorAll("product-section")
    }
    handleSectionUpdated() {
        this.computeDisabled()
    }
    handleSectionUpdating() {
        var e;
        (e = this.$button) == null || e.setAttribute("disabled", "disabled")
    }
    computeDisabled() {
        var t, i;
        Array.from(this.$sections).some(s => {
            const r = s.querySelector('[data-section-ref="id"]')
              , n = s.querySelector('[data-section-ref="availability"]')
              , o = !!(r && r.value)
              , a = n?.dataset.available === "true";
            return !o || !a
        }
        ) ? (t = this.$button) == null || t.setAttribute("disabled", "disabled") : (i = this.$button) == null || i.removeAttribute("disabled")
    }
}
;
wr([l("section:updated")], Ni.prototype, "handleSectionUpdated", 1),
wr([l("section:updating")], Ni.prototype, "handleSectionUpdating", 1),
Ni = wr([d("product-bundle")], Ni);
var md = Object.getOwnPropertyDescriptor
  , gd = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? md(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let sn = class extends HTMLElement {
    constructor() {
        super(),
        this.makeRequest = Jt({
            abortRequest: !0,
            cache: !0
        }),
        this.addEventListener("change", this.handleChange.bind(this)),
        Ki() ? this.addEventListener("mouseenter", () => this.preload(), {
            once: !0
        }) : Bt(this, () => this.preload())
    }
    connectedCallback() {
        this.closest("[data-product-card-has-bg]") && this.setAttribute("data-has-bg", "")
    }
    async handleChange(e) {
        if (!(e.target instanceof Element))
            return;
        const t = this.getProductCardUrl(e.target);
        if (!t)
            return;
        const i = await this.fetchProductCardElement(t);
        i && ut(this, i)
    }
    preload() {
        Array.from(this.querySelectorAll("[data-product-card-url]")).map(t => this.getProductCardUrl(t)).filter(Ao).forEach(t => this.makeRequest(t, !0))
    }
    async fetchProductCardElement(e) {
        const t = await this.makeRequest(e.toString())
          , i = dt(t);
        return i.querySelectorAll("img").forEach(r => {
            r.hasAttribute("sizes") || r.setAttribute("sizes", `${this.clientWidth}px`)
        }
        ),
        i.querySelector("product-card")
    }
    getProductCardUrl(e) {
        var i;
        const t = (i = e.closest("[data-product-card-url]")) == null ? void 0 : i.getAttribute("data-product-card-url");
        return t ? Zs("product-card", t).toString() : null
    }
    beforeMorphDOM(e, t) {
        return t(this, e, {
            childrenOnly: !0,
            onBeforeElUpdated(i) {
                return !i.classList.contains("product-card__swatches")
            }
        }),
        !1
    }
}
;
sn = gd([d("product-card")], sn);
var vd = Object.defineProperty
  , yd = Object.getOwnPropertyDescriptor
  , Qn = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? yd(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && vd(t, i, r),
    r
}
;
let Ns = class extends L {
    get strategyName() {
        return "drawer"
    }
    get mobileStrategyName() {
        return "drawer"
    }
    async loadProduct(e) {
        const t = await Lt(e).query({
            section_id: wt(this.$section)
        }).get().text()
          , i = dt(t).querySelector("quick-view-modal > template") ?? z("Quick view modal content not found");
        this.replaceChildren(i.content)
    }
    handleAddedToCart(e) {
        e.detail.type === "add" && !e.detail.error && (this.open = !1)
    }
    handleSectionSelect(e) {
        var t;
        super.handleSectionSelect(e),
        this.themeEditorSync && (t = window.Shopify) != null && t.designMode && this.updateComplete.then( () => {
            const i = this.querySelector(":scope > template");
            i && (this.replaceChildren(i.content),
            i.remove())
        }
        )
    }
}
;
Qn([l("cart:updated")], Ns.prototype, "handleAddedToCart", 1),
Ns = Qn([d("quick-view-modal")], Ns);
var bd = Object.defineProperty
  , wd = Object.getOwnPropertyDescriptor
  , us = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? wd(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && bd(t, i, r),
    r
}
;
let Fe = class extends Ct {
    async fetchAndUpdate() {
        var t;
        await super.fetchAndUpdate();
        const e = this.querySelector("grid-carousel");
        e && (this.columnsMin && e.style.setProperty("--carousel-columns-min", this.columnsMin),
        this.columnsMax && e.style.setProperty("--carousel-columns-max", this.columnsMax),
        this.enableCarousel !== "true" && (e.setAttribute("wrap", ""),
        (t = this.querySelector("[slot=controls]")) == null || t.remove()))
    }
}
;
us([g({
    type: String,
    optional: !0
})], Fe.prototype, "columnsMin", 2),
us([g({
    type: String,
    optional: !0
})], Fe.prototype, "columnsMax", 2),
us([g({
    type: String,
    default: "true"
})], Fe.prototype, "enableCarousel", 2),
Fe = us([d("recently-viewed-section")], Fe);
var $d = Object.defineProperty
  , Sd = Object.getOwnPropertyDescriptor
  , Zn = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Sd(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && $d(t, i, r),
    r
}
;
let js = class extends HTMLElement {
    get $checkbox() {
        return this.querySelector(".recipient-form__checkbox input[type='checkbox']")
    }
    get $control() {
        return this.querySelector(".recipient-form__control")
    }
    get $offset() {
        return this.querySelector(".recipient-form__offset")
    }
    get $fields() {
        return this.querySelector(".recipient-form__fields")
    }
    connectedCallback() {
        this.$offset && (this.$offset.value = new Date().getTimezoneOffset().toString()),
        this.updateState()
    }
    handleChange() {
        this.updateState()
    }
    updateState() {
        var i, s;
        const e = !!((i = this.$checkbox) != null && i.checked);
        this.$control && (this.$control.disabled = !e),
        this.$offset && (this.$offset.disabled = !e);
        const t = (s = this.$fields) == null ? void 0 : s.querySelectorAll(".input input, .input textarea");
        t?.forEach(r => {
            r.disabled = !e
        }
        ),
        this.$fields && (e ? (this.$fields.hidden = !1,
        w(this.$fields, {
            display: ""
        })) : (this.$fields.hidden = !0,
        w(this.$fields, {
            display: ""
        })))
    }
}
;
Zn([l("change")], js.prototype, "handleChange", 1),
js = Zn([d("recipient-form")], js);
var Cd = Object.defineProperty
  , xd = Object.getOwnPropertyDescriptor
  , ps = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? xd(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Cd(t, i, r),
    r
}
;
let pe = class extends x {
    constructor() {
        super(...arguments),
        this.shadowDOM = !0
    }
    get controlsId() {
        return this.getAttribute("aria-controls") ?? ""
    }
    get isRTL() {
        return Yi() === "rtl"
    }
    connectedCallback() {
        super.connectedCallback(),
        m(document, "control:connected", {
            targetId: this.controlsId
        }, {
            bubbles: !0
        })
    }
    calculateTranslateX(e, t, i) {
        const s = e / t * 100 / i;
        return this.isRTL ? -s : s
    }
    handleScrollCarouselUpdate(e) {
        if (e.detail.targetId !== this.controlsId)
            return;
        const t = this.renderRoot.querySelector(".scrollbar-thumb");
        if (!t)
            return;
        const i = this.calculateTranslateX(e.detail.scrollAmount, e.detail.scrollSize, e.detail.scrollRatio);
        t.classList.add("transition-enabled"),
        t.style.width = `${e.detail.scrollRatio * 100}%`,
        t.style.transform = `translate3d(${i}%, 0, 0)`
    }
    handleScroll() {
        const e = this.renderRoot.querySelector(".scrollbar-thumb");
        if (!e)
            return;
        const t = this.calculateTranslateX(this.$controls.scrollAmount, this.$controls.scrollSize, this.$controls.scrollRatio);
        e.classList.remove("transition-enabled"),
        e.style.width = `${this.$controls.scrollRatio * 100}%`,
        e.style.transform = `translate3d(${t}%, 0, 0)`
    }
    render() {
        return p`
      <div class="scrollbar-container">
        <div class="scrollbar-track">
          <div class="scrollbar-thumb"></div>
        </div>
      </div>
    `
    }
}
;
pe.styles = tt`
    :host {
      display: block;
      width: 100%;
    }

    .scrollbar-container {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 1rem 0;
      margin: -1rem 0;
      cursor: pointer;
    }

    .scrollbar-track {
      position: relative;
      background-color: rgb(var(--text-color) / 3.9%);
      width: 100%;
      height: 4px;
      border-radius: 2px;
      user-select: none;
    }

    .scrollbar-thumb {
      position: absolute;
      background-color: rgb(var(--text-color) / 21%);
      height: 4px;
      border-radius: 4px;
      user-select: none;
    }

    .scrollbar-thumb.transition-enabled {
      transition: transform 600ms ease;
    }

    .scrollbar-thumb:hover {
      background-color: #666;
    }

    .scrollbar-thumb:active {
      background-color: #333;
    }
  `,
ps([ii("aria-controls", {
    type: Y
})], pe.prototype, "$controls", 2),
ps([l("scroll-carousel:update", document, {
    attachTiming: "before"
})], pe.prototype, "handleScrollCarouselUpdate", 1),
ps([l("scroll", e => Ft("scroll-carousel").then( () => e.$controls.$track))], pe.prototype, "handleScroll", 1),
pe = ps([d("scroll-carousel-bar")], pe);
var _d = Object.defineProperty
  , Od = Object.getOwnPropertyDescriptor
  , $r = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Od(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && _d(t, i, r),
    r
}
;
let ji = class extends N {
    firstUpdated() {
        this.$headings.forEach(e => {
            ms(E(e, {
                opacity: [0, 0, 1, 1, 1, 0, 0]
            }), {
                target: e,
                offset: ["start end", "start start"]
            }),
            ms(E(e, {
                translate: ["0 -100px", "0 100px"]
            }, {
                ease: "linear"
            }), {
                target: e,
                offset: ["start end", "start start"]
            })
        }
        ),
        ms(E(this.$media, {
            clipPath: ["inset(50% 50% 0% 50%)", "inset(0)"]
        }), {
            target: this,
            offset: ["start end", "start start"]
        })
    }
}
;
$r([Fs('[data-part="heading"]')], ji.prototype, "$headings", 2),
$r([C(".scroll-reveal-headings__media")], ji.prototype, "$media", 2),
ji = $r([d("scroll-reveal-headings")], ji);
class fe {
    constructor(t) {
        this.options = t,
        this.currentState = fe.getInitialState(),
        this.makeRequest = Jt({
            cache: !0,
            debounce: 250
        }),
        t.section ?? (t.section = "predictive-search")
    }
    static getInitialState() {
        return {
            state: "empty",
            isLoading: !1
        }
    }
    get $results() {
        return mn(this.options.resultsContainer)
    }
    updateState(t) {
        var i, s;
        this.currentState = {
            ...this.currentState,
            ...t
        },
        (s = (i = this.options).onStateChange) == null || s.call(i, this.currentState)
    }
    async search(t) {
        var i, s, r;
        if (!t.trim()) {
            this.reset();
            return
        }
        try {
            this.updateState({
                isLoading: !0
            });
            const root = ((i = window.Shopify) == null ? void 0 : i.routes.root) ?? "/";
            const searchFields = "title,product_type,variants.title,vendor,variants.sku";
            const url = `${root}search/suggest?section_id=${this.options.section}&q=${encodeURIComponent(t)}&resources[options][fields]=${searchFields}`;
            const n = await this.makeRequest(url);
            this.updateResults(n),
            (r = (s = this.options).onSearchCompleted) == null || r.call(s),
            this.updateState({
                state: "results",
                isLoading: !1
            })
        } catch (n) {
            if (n?.name !== "AbortError")
                throw this.updateState({
                    state: "error",
                    isLoading: !1
                }),
                n
        }
    }
    reset() {
        var t, i;
        this.makeRequest.abort(),
        this.$results.replaceChildren(),
        (i = (t = this.options).onReset) == null || i.call(t),
        this.updateState({
            state: "empty",
            isLoading: !1
        })
    }
    updateResults(t) {
        const i = le(t);
        ut(this.$results, i, {
            childrenOnly: !0
        })
    }
}
var Pd = Object.defineProperty
  , Id = Object.getOwnPropertyDescriptor
  , At = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Id(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Pd(t, i, r),
    r
}
;
let gt = class extends T(x, as) {
    constructor() {
        super(),
        this.open = !1,
        this.active = !1,
        this.searchState = fe.getInitialState(),
        this.search = new fe({
            section: "predictive-search-mobile",
            resultsContainer: () => this.$results,
            onStateChange: e => {
                this.searchState = e
            }
        }),
        new Ut(this,"(min-width: 768px)",e => {
            this.active = !e,
            e && this.open && (this.open = !1)
        }
        )
    }
    get $searchInput() {
        var e;
        return (e = this.slotted("input")[0]) == null ? void 0 : e.querySelector("input[name=q]")
    }
    handleSearchTouch(e) {
        var t;
        e instanceof TouchEvent && e.cancelable && e.touches.length === 1 && this.open && document.activeElement !== this.$searchInput && (e.preventDefault(),
        e.stopImmediatePropagation(),
        (t = this.$searchInput) == null || t.focus({
            preventScroll: !0
        }))
    }
    show() {
        this.open || !this.active || (this.open = !0,
        ir(this.$panel, !0),
        this.updateComplete.then( () => {
            var e;
            (e = this.$searchInput) == null || e.focus({
                preventScroll: !0
            })
        }
        ))
    }
    hide() {
        this.open && (Ai(this.$panel),
        this.open = !1,
        this.search.reset(),
        this.$searchInput && (this.$searchInput.value = ""))
    }
    handleSearchInput(e) {
        e.target instanceof HTMLInputElement && this.search.search(e.target.value)
    }
    handleResultsScroll() {
        var e;
        document.activeElement === this.$searchInput && ((e = this.$searchInput) == null || e.blur())
    }
    handleSearchOpen() {
        this.show()
    }
    render() {
        return p`
      <div
        data-part="panel"
        class=${fn({
            "search-panel-mobile": !0,
            "search-panel-mobile--open": this.open,
            [`search-panel-mobile--${this.searchState.isLoading ? "loading" : this.searchState.state}`]: !0
        })}
      >
        <div class="search-panel-mobile__top">
          <div class="search-panel-mobile__input-wrapper-outer">
            <div
              class="search-panel-mobile__input-wrapper"
              data-part="input-wrapper"
              @touchend=${this.handleSearchTouch}
              @input=${this.handleSearchInput}
            >
              <slot name="input"></slot>
            </div>
          </div>
          <div
            class="search-panel-mobile__close-wrapper"
            data-part="close-wrapper"
            @click=${this.hide}
          >
            <slot name="close"></slot>
          </div>
        </div>
        <div
          data-part="main"
          class="search-panel-mobile__main"
          @touchmove=${this.handleResultsScroll}
        >
          <div class="search-panel-mobile__empty-state">
            <slot name="empty-state"></slot>
          </div>
          <div class="search-panel-mobile__skeleton">
            <slot name="skeleton"></slot>
          </div>
          <div class="search-panel-mobile__results" data-part="results"></div>
        </div>
      </div>
    `
    }
}
;
At([u({
    type: Boolean,
    reflect: !0
})], gt.prototype, "open", 2),
At([b()], gt.prototype, "searchState", 2),
At([C("[data-part='input-wrapper']")], gt.prototype, "$inputWrapper", 2),
At([C("[data-part='close-wrapper']")], gt.prototype, "$closeWrapper", 2),
At([C("[data-part='results']")], gt.prototype, "$results", 2),
At([C("[data-part='panel']")], gt.prototype, "$panel", 2),
At([C("[data-part='main']")], gt.prototype, "$mainContainer", 2),
At([l("search:open", document)], gt.prototype, "handleSearchOpen", 1),
gt = At([d("search-panel-mobile")], gt);
var Ad = Object.defineProperty
  , Md = Object.getOwnPropertyDescriptor
  , j = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Md(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Ad(t, i, r),
    r
}
;
let U = class extends T(x, as) {
    constructor() {
        super(),
        this.open = !1,
        this.searchState = fe.getInitialState(),
        this.isTrapActive = !1,
        this.search = new fe({
            resultsContainer: () => this.$results,
            onStateChange: e => this.searchState = e
        }),
        new Ut(this,"(min-width: 768px)",e => {
            !e && this.open && (this.open = !1)
        }
        )
    }
    openUpdated(e) {
        var s;
        e !== void 0 && document.body.setAttribute("data-search-panel-open", String(this.open)),
        this.open || (this.$input.value = ""),
        ht(this.$panelWrapper);
        const t = [[this.$panel, {
            clipPath: this.open ? "inset(0% 0% 0% 0%)" : "inset(0% 0% 100% 0%)"
        }, {
            duration: this.open ? .8 : .4,
            ease: this.open ? "power4.out" : "power2.inOut"
        }], [this.$panel, {
            opacity: this.open ? [0, 1, 1] : 0
        }, {
            duration: this.open ? .8 : .4,
            ease: this.open ? "power4.out" : "power2.inOut",
            at: "<"
        }]];
        this.open && t.push([this.querySelectorAll("[data-search-panel-item]"), {
            opacity: [0, 1],
            scale: [.97, 1]
        }, {
            duration: 1,
            ease: "power4.out",
            at: .25
        }]);
        const i = e === void 0 ? ve(t) : A(t);
        this.open || (i.then( () => {
            this.search.reset(),
            w(this.$panelWrapper, {
                pointerEvents: "none",
                visibility: "hidden"
            })
        }
        ),
        (s = this.focusTrap) == null || s.deactivate())
    }
    handlePanelFocusIn() {
        this.focusTrap || (this.focusTrap = zi(this.$panelWrapper, {
            clickOutsideDeactivates: !0,
            initialFocus: !1,
            returnFocusOnDeactivate: !1,
            preventScroll: !0,
            onActivate: () => this.isTrapActive = !0,
            onDeactivate: () => this.isTrapActive = !1
        })),
        this.isTrapActive || this.focusTrap.activate()
    }
    handleInputClick() {
        this.open = !0
    }
    handleInput(e) {
        this.open = !0,
        this.search.search(e.currentTarget.value)
    }
    handleInputKeydown(e) {
        e.key === "Escape" && (this.open = !1,
        setTimeout( () => this.$input.focus()))
    }
    handleCloseClick() {
        this.open = !1
    }
    handleStickyHeaderUpdate(e) {
        e.detail.expanded && (this.open = !1)
    }
    render() {
        return p`
      <div class="search-panel-wrapper" data-part="panel-wrapper">
        <div
          data-part="panel"
          class="search-panel search-panel--${this.searchState.state} ${this.searchState.isLoading ? "search-panel--loading" : ""}"
        >
          <div class="search-panel__empty-state">
            <slot name="empty-state"></slot>
          </div>
          <div class="search-panel__skeleton">
            <slot name="skeleton"></slot>
          </div>
          <div data-part="results" class="search-panel__results"></div>
          <div class="loading-bar search-panel__loading-bar">
            <div class="loading-bar__line loading-bar__line--primary"></div>
            <div class="loading-bar__line loading-bar__line--secondary"></div>
          </div>
        </div>
      </div>

      <backdrop-element portal ?active=${this.open} hide-delay="400"></backdrop-element>
      <floating-close ?active=${this.open} @click=${ () => this.open = !1}></floating-close>
    `
    }
}
;
j([u({
    type: Boolean,
    reflect: !0
})], U.prototype, "open", 2),
j([C("[data-part='panel-wrapper']")], U.prototype, "$panelWrapper", 2),
j([C("[data-part='panel']")], U.prototype, "$panel", 2),
j([C("[data-part='results']")], U.prototype, "$results", 2),
j([b()], U.prototype, "searchState", 2),
j([ii("input-id", {
    type: HTMLInputElement
})], U.prototype, "$input", 2),
j([ii("close-id", {
    type: HTMLElement,
    required: !1
})], U.prototype, "$close", 2),
j([l("focusin")], U.prototype, "handlePanelFocusIn", 1),
j([l("click", e => e.$input)], U.prototype, "handleInputClick", 1),
j([l("input", e => e.$input)], U.prototype, "handleInput", 1),
j([l("keydown")], U.prototype, "handleInputKeydown", 1),
j([l("click", e => e.$close)], U.prototype, "handleCloseClick", 1),
j([l("sticky-header:update", document)], U.prototype, "handleStickyHeaderUpdate", 1),
U = j([d("search-panel")], U);
var Td = Object.defineProperty
  , Ed = Object.getOwnPropertyDescriptor
  , ri = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Ed(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Td(t, i, r),
    r
}
;
let me = class extends St {
    constructor() {
        super(...arguments),
        this.placement = "bottom-start",
        this.offset = 8,
        this.shareUrl = "",
        this.shareTitle = "",
        this.inAnimation = "popover-scale-in",
        this.outAnimation = "popover-scale-out"
    }
    async handleButtonClick(e) {
        if ("share"in navigator && this.shareUrl) {
            e.preventDefault(),
            e.stopImmediatePropagation();
            try {
                await navigator.share({
                    title: this.shareTitle,
                    url: this.shareUrl
                })
            } catch (t) {
                t instanceof Error && t.name !== "AbortError" && this.setOpen(!0)
            }
        }
    }
    onOpenStateChange(e) {
        super.onOpenStateChange(e)
    }
    async handlePopoverClick(e) {
        const i = e.target.closest(".listbox__item");
        if (i)
            if (i.hasAttribute("data-copy-url")) {
                e.preventDefault();
                const s = i.getAttribute("data-copy-url");
                if (s)
                    try {
                        await Eo(s),
                        this.setOpen(!1)
                    } catch {
                        this.setOpen(!1)
                    }
            } else
                this.setOpen(!1)
    }
}
;
ri([u({
    attribute: "share-url"
})], me.prototype, "shareUrl", 2),
ri([u({
    attribute: "share-title"
})], me.prototype, "shareTitle", 2),
ri([l("click", e => e.$button)], me.prototype, "handleButtonClick", 1),
ri([l("click", e => e.$popover)], me.prototype, "handlePopoverClick", 1),
me = ri([d("share-button")], me);
class Is extends Error {
}
var Dd = Object.defineProperty
  , Ld = Object.getOwnPropertyDescriptor
  , hi = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Ld(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Dd(t, i, r),
    r
}
;
function kd(e) {
    class t extends e {
        constructor() {
            super(...arguments),
            this.shippingRates = [],
            this.loading = !1,
            this.errorMessage = ""
        }
        updated(s) {
            super.updated(s),
            s.has("loading") && this.$submitButton.toggleAttribute("loading", this.loading),
            s.has("errorMessage") && (this.$errorAlert.textContent = this.errorMessage),
            s.has("shippingRates") && Vs(this.renderShippingRates(), this.$shippingRatesContainer)
        }
        async handleSubmit(s) {
            s.preventDefault(),
            this.errorMessage = "",
            this.shippingRates = [],
            this.loading = !0;
            try {
                this.shippingRates = await this.fetchShippingRates()
            } catch (r) {
                const n = this.getErrorMessage(r);
                r instanceof Is || console.error("Shipping rates error:", r),
                this.errorMessage = n
            } finally {
                this.loading = !1
            }
        }
        getErrorMessage(s) {
            return s instanceof Is ? s.message : s instanceof pn && s.status === 422 ? Tn(s.json).join(`
`) : F("sections.shipping_estimator.error")
        }
        buildShippingRatesUrl() {
            const s = new FormData(this.$form);
            return `/cart/shipping_rates.json?${new URLSearchParams(s).toString()}`
        }
        async fetchShippingRates() {
            const s = this.buildShippingRatesUrl()
              , r = await Lt(s).get().json();
            if (!r.shipping_rates)
                throw new Is(F("sections.shipping_estimator.no_rates"));
            return r.shipping_rates
        }
        renderShippingRates() {
            return this.shippingRates.length === 0 ? p`` : p`${this.shippingRates.map(this.renderShippingRate)}`
        }
        renderShippingRate(s) {
            return p` <li class="shipping-rate">${s.name}: ${s.price} ${s.currency}</li> `
        }
        beforeMorphDOM() {
            return !1
        }
    }
    return hi([b()], t.prototype, "shippingRates", 2),
    hi([b()], t.prototype, "loading", 2),
    hi([b()], t.prototype, "errorMessage", 2),
    hi([l("submit")], t.prototype, "handleSubmit", 1),
    t
}
var Rd = Object.getOwnPropertyDescriptor
  , qd = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Rd(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let rn = class extends kd(N) {
    get $form() {
        return this.querySelector("form")
    }
    get $submitButton() {
        return this.querySelector("[type=submit]")
    }
    get $shippingRatesContainer() {
        return this.querySelector('[data-part="shipping-rates"]')
    }
    get $errorAlert() {
        return this.querySelector('[data-part="error"]')
    }
}
;
rn = qd([d("shipping-estimator")], rn);
class Bd extends it {
    constructor(t, i, s={}) {
        super(t),
        this.target = i,
        this.tracker = new An,
        this.options = Fi(s, {
            minSwipeDistance: 20,
            minSwipeVelocity: .3,
            maxAngleDeviation: 30
        }),
        this.listen( () => this.target, "touchstart", this.handleTouchStart.bind(this), {
            passive: !0
        }),
        this.listen( () => this.target, "touchmove", this.handleTouchMove.bind(this), {
            passive: !0
        }),
        this.listen( () => this.target, "touchend", this.handleTouchEnd.bind(this), {
            passive: !0
        }),
        this.listen( () => this.target, "touchcancel", this.handleTouchCancel.bind(this), {
            passive: !0
        }),
        t.addController(this)
    }
    handleTouchStart(t) {
        if (t.touches.length !== 1 || !t.touches[0])
            return;
        const i = t.touches[0];
        this.tracker.start(i.clientX, i.clientY, t.timeStamp)
    }
    handleTouchMove(t) {
        if (!this.tracker.tracking || t.touches.length !== 1 || !t.touches[0]) {
            this.tracker.stop();
            return
        }
        this.tracker.update(t.touches[0].clientX, t.touches[0].clientY, t.timeStamp),
        this.tracker.exceedsHorizontalAngle(this.options.maxAngleDeviation) && this.tracker.stop()
    }
    handleTouchEnd(t) {
        var s, r, n, o;
        if (!this.tracker.tracking)
            return;
        if (t.changedTouches.length === 1 && t.changedTouches[0]) {
            const a = t.changedTouches[0];
            this.tracker.update(a.clientX, a.clientY, t.timeStamp)
        }
        const i = this.tracker.getMetrics();
        this.tracker.stop(),
        !(t.changedTouches.length !== 1 || !this.isValidSwipe(i)) && (i.deltaX > 0 ? (r = (s = this.options).onSwipeRight) == null || r.call(s, {
            ...i,
            originalEvent: t
        }) : (o = (n = this.options).onSwipeLeft) == null || o.call(n, {
            ...i,
            originalEvent: t
        }))
    }
    handleTouchCancel() {
        this.tracker.stop()
    }
    isValidSwipe(t) {
        return Math.abs(t.deltaX) >= this.options.minSwipeDistance && t.velocity >= this.options.minSwipeVelocity && t.angle <= this.options.maxAngleDeviation
    }
    updateOptions(t) {
        Object.assign(this.options, t)
    }
}
const As = new WeakMap;
function Ud(e, t) {
    const i = As.get(e);
    i?.stop();
    const s = e.clientHeight;
    e.style.height = "",
    t();
    const r = e.clientHeight;
    if (s !== r) {
        const n = E(e, {
            height: [`${s}px`, `${r}px`]
        }, {
            clearProps: "height",
            duration: .5,
            ease: "power2.inOut"
        });
        return As.set(e, n),
        n.then( () => As.delete(e)),
        n
    }
    return null
}
var Hd = Object.defineProperty
  , Nd = Object.getOwnPropertyDescriptor
  , fs = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Nd(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Hd(t, i, r),
    r
}
;
let We = class extends T(x, Zi) {
    constructor() {
        var e;
        super(),
        this.transition = "slideshow-zoom-out",
        this.loop = !0,
        this.swipeController = new Bd(this,this,{
            onSwipeLeft: () => {
                var t;
                (t = this.autoplayController) == null || t.stop(),
                this.goNext()
            }
            ,
            onSwipeRight: () => {
                var t;
                (t = this.autoplayController) == null || t.stop(),
                this.goPrev()
            }
        }),
        this.pauseInactiveSlideVideos = k( () => {
            this.$slides.forEach( (t, i) => {
                var s;
                i !== this.activeIndex && ((s = this.getVideo(t)) == null || s.pause())
            }
            )
        }
        , 1e3),
        (e = window.Shopify) != null && e.designMode && this.initShopifyDesignMode()
    }
    connectedCallback() {
        super.connectedCallback(),
        this.itemCount = this.$slides.length
    }
    firstUpdated() {
        this.autoplay && (this.autoplayController = new Nn(this,{
            interval: this.autoplay,
            progressVar: !0
        }, () => {
            this.goNext()
        }
        ))
    }
    get $slides() {
        return Array.from(this.children)
    }
    get $activeItem() {
        return this.$slides[this.activeIndex]
    }
    async activeIndexUpdated(e) {
        e === void 0 || !this.animateHeight ? this.updateSlideClasses() : Ud(this, () => {
            this.updateSlideClasses()
        }
        ),
        this.$activeItem && this.playSlideVideo(this.$activeItem),
        this.pauseInactiveSlideVideos(),
        e !== void 0 && await this.animateSlideTransition(e)
    }
    updateSlideClasses() {
        this.$slides.forEach( (e, t) => {
            e.classList.toggle("slideshow__slide--is-active", t === this.activeIndex),
            e.classList.toggle("slideshow__slide--is-visible", t === this.activeIndex)
        }
        )
    }
    playSlideVideo(e) {
        var t;
        (t = this.getVideo(e)) == null || t.play().catch( () => {}
        )
    }
    async animateSlideTransition(e) {
        const t = this.$slides[e]
          , i = this.$activeItem;
        if (i) {
            this.playContentAnimation(i),
            t && t.classList.add("slideshow__slide--is-visible");
            const s = t ? [this.getAnimationTarget(i), this.getAnimationTarget(t)] : this.getAnimationTarget(i)
              , r = Ci(this.transition) ? this.transition : "slideshow-zoom-out"
              , n = A(at(r, s));
            ui() && (n.speed = 1e3),
            n.then( () => {
                i === this.$activeItem && this.updateSlideClasses()
            }
            )
        }
    }
    handleControlTrigger(e) {
        var t;
        (t = this.autoplayController) == null || t.stop(),
        super.handleControlTrigger(e)
    }
    getAnimationTarget(e) {
        return e.querySelector("[data-part='animation-target']") ?? e
    }
    getVideo(e) {
        return e.querySelector("[data-part='video'], video")
    }
    prepareContentAnimation(e) {
        var t;
        (t = e.querySelector("animation-element")) == null || t.prepare()
    }
    playContentAnimation(e) {
        var t;
        (t = e.querySelector("animation-element")) == null || t.play()
    }
    initShopifyDesignMode() {
        this.addEventListener("shopify:block:select", e => {
            const t = e.detail.blockId
              , i = [...this.querySelectorAll(":scope > *:not([slot])")]
              , s = this.querySelector(`[id*="${t}"]`)
              , r = s ? i.findIndex(n => n.contains(s)) : i.findIndex(n => n.id.includes(t));
            r !== -1 && setTimeout( () => {
                this.activeIndex = r,
                e.detail.load && this.$slides[r] && this.playContentAnimation(this.$slides[r])
            }
            ),
            this.updateComplete.then( () => {
                var n;
                return (n = this.autoplayController) == null ? void 0 : n.stop()
            }
            )
        }
        )
    }
}
;
fs([u({
    type: Number
})], We.prototype, "autoplay", 2),
fs([u({
    type: Boolean,
    attribute: "animate-height"
})], We.prototype, "animateHeight", 2),
fs([u({
    type: String
})], We.prototype, "transition", 2),
We = fs([d("slideshow-element")], We);
var jd = Object.defineProperty
  , Vd = Object.getOwnPropertyDescriptor
  , Ms = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Vd(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && jd(t, i, r),
    r
}
;
function zd(e) {
    class t extends e {
        constructor() {
            super(...arguments),
            this.shadowDOM = !0,
            this.open = !1
        }
        get slottedSummary() {
            return this.slotted("summary")[0]
        }
        get slottedContent() {
            return this.slotted()[0]
        }
        firstUpdated(s) {
            var r;
            super.firstUpdated(s),
            this.setupAriaAttributes(),
            (r = window.Shopify) != null && r.designMode && (this.addEventListener("shopify:block:select", () => {
                this.open = !0
            }
            ),
            this.addEventListener("shopify:block:deselect", () => {
                this.open = !1
            }
            ))
        }
        handleGroupOpen(s) {
            s.detail.group === this.group && s.target !== this && this.open && (this.open = !1)
        }
        setupAriaAttributes() {
            const s = this.slottedSummary
              , r = this.slottedContent;
            s && (s.setAttribute("role", "button"),
            s.setAttribute("tabindex", "0"),
            s.setAttribute("aria-expanded", this.open.toString())),
            r && r.setAttribute("role", "region"),
            s && r && (s.id || (s.id = Ee("smooth-collapse-summary-")),
            r.id || (r.id = Ee("smooth-collapse-content-")),
            s.setAttribute("aria-controls", r.id),
            r.setAttribute("aria-labelledby", s.id))
        }
        handleSummaryClick(s) {
            s.preventDefault(),
            this.open = !this.open
        }
        updated(s) {
            if (super.updated(s),
            s.has("open")) {
                const n = this.slotted("summary")[0];
                if (n && n.setAttribute("aria-expanded", this.open.toString()),
                this.group) {
                    const o = this.open ? "collapse:open" : "collapse:close";
                    m(this, o, {
                        group: this.group
                    }, {
                        bubbles: !0
                    })
                }
            }
        }
        beforeMorphDOM(s, r) {
            return r(this, s, {
                childrenOnly: !0,
                getNodeKey: () => null
            }),
            this.setupAriaAttributes(),
            !1
        }
        render() {
            return [this.renderSummary(), this.renderContent()]
        }
        renderSummary() {
            return p`
        <div id="summary" @click=${this.handleSummaryClick}>
          <slot name="summary"></slot>
        </div>
      `
        }
        renderContent() {
            return p`
        <div id="content">
          <slot></slot>
        </div>
      `
        }
    }
    return Ms([u({
        type: Boolean,
        reflect: !0
    })], t.prototype, "open", 2),
    Ms([u({
        type: String
    })], t.prototype, "group", 2),
    Ms([l("collapse:open", i => i.group ? document : null, {
        optional: !0
    })], t.prototype, "handleGroupOpen", 1),
    t
}
var Fd = Object.defineProperty
  , Wd = Object.getOwnPropertyDescriptor
  , Sr = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Wd(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Fd(t, i, r),
    r
}
;
let Ye = class extends T(x, zd) {
    openUpdated(e) {
        var t;
        if ((t = this.animation) == null || t.stop(),
        e === void 0) {
            this.open ? (w(this.$container, {
                height: "auto",
                opacity: "1",
                visibility: "visible"
            }),
            w(this.$content, {
                transform: "translateY(0px)"
            })) : (w(this.$container, {
                height: "0px",
                opacity: "0",
                visibility: "hidden"
            }),
            w(this.$content, {
                transform: "translateY(-16px)"
            }));
            return
        }
        this.open ? this.animation = this.animateOpen() : this.animation = this.animateClose()
    }
    animateClose() {
        const e = [];
        return e.push([this.$container, {
            height: "0px"
        }, {
            duration: .5,
            ease: "power4.out",
            at: "<"
        }]),
        e.push([this.$container, {
            opacity: 0,
            visibility: "hidden"
        }, {
            duration: .3,
            ease: "power4.out",
            at: "<"
        }]),
        e.push([this.$content, {
            transform: "translateY(-16px)"
        }, {
            duration: .5,
            ease: "power4.out",
            at: "<"
        }]),
        A(e)
    }
    animateOpen() {
        const e = [];
        return e.push([this.$container, {
            height: `${this.$content.clientHeight}px`
        }, {
            duration: .5,
            ease: "power4.out",
            clearProps: "height"
        }]),
        e.push([this.$container, {
            opacity: 1,
            visibility: "visible"
        }, {
            duration: .4,
            at: .125
        }]),
        e.push([this.$content, {
            transform: ["translateY(16px)", "translateY(0px)"]
        }, {
            duration: .5,
            ease: "power4.out",
            at: .125
        }]),
        A(e)
    }
    renderContent() {
        return p`
      <div id="container">
        <div id="mask">
          <div id="content">
            <slot></slot>
          </div>
        </div>
      </div>
    `
    }
}
;
Ye.styles = tt`
    #container {
      position: relative;
      display: flow-root;
      contain: layout;
    }

    @supports not (contain: layout) {
      #container {
        overflow: hidden;
      }
    }

    #mask {
      height: 100%;
      padding: 12px;
      margin: -12px;
      mask-image: linear-gradient(
        to bottom,
        transparent,
        rgb(0 0 0 / 12.5%) 6px,
        black 12px,
        black calc(100% - 12px),
        rgb(0 0 0 / 12.5%) calc(100% - 6px),
        transparent
      );

      mask-size: 100% 100%;
      mask-repeat: no-repeat;
    }

    #summary {
      position: relative;
      z-index: 2;
      -webkit-user-select: none; /* Safari nonsense */
      user-select: none;
      cursor: pointer;
    }

    #content {
      top: 0;
      left: 0;
      right: 0;
    }
  `,
Sr([C("#container")], Ye.prototype, "$container", 2),
Sr([C("#content")], Ye.prototype, "$content", 2),
Ye = Sr([d("smooth-collapse")], Ye);
var Yd = Object.defineProperty
  , Kd = Object.getOwnPropertyDescriptor
  , ni = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Kd(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Yd(t, i, r),
    r
}
;
let Qt = class extends x {
    constructor() {
        super(!0),
        this.noVariants = !1,
        this.showPicker = !1
    }
    handleClickSelectOptions() {
        this.showPicker = !0
    }
    handleCloseClick() {
        this.showPicker = !1
    }
    handleCartUpdated() {
        this.showPicker = !1
    }
    showPickerUpdated() {
        this.showPicker ? (ir(this),
        this.animateIn()) : (Ai(this),
        this.animateOut())
    }
    animateIn() {
        return this.$variantPicker.style.display = "block",
        A([[this.$variantPicker, {
            transform: ["translateY(100%)", "translateY(0%)"]
        }, {
            duration: .6,
            ease: "power3.out"
        }], [this.$variantPickerContent, {
            opacity: [0, 1],
            transform: ["translateY(0.5rem)", "translateY(0)"]
        }, {
            duration: .8,
            ease: "power4.out",
            at: .25
        }]]).tap(e => {
            e.speed = 1.1
        }
        )
    }
    animateOut() {
        return A([[this.$variantPickerContent, {
            opacity: [1, 0],
            transform: ["translateY(0)", "translateY(0.5rem) scale(0.98)"]
        }, {
            duration: .3,
            ease: "power1.in"
        }], [this.$variantPicker, {
            transform: ["translateY(0%)", "translateY(100%)"]
        }, {
            duration: .4,
            ease: "power2.in",
            at: .1
        }]]).tap(e => {
            e.speed = 1.2
        }
        ).finished.then( () => {
            this.$variantPicker.style.display = "none",
            this.$variantPicker.style.transform = "",
            this.$variantPickerContent.style.transform = ""
        }
        )
    }
    render() {
        return p`
      <backdrop-element
        portal
        hide-delay="300"
        @click=${ () => this.showPicker = !1}
        z-index="105"
        ?active=${this.showPicker}
      ></backdrop-element>

      <div id="variant-picker" class="sticky-add-to-cart-mobile__picker">
        <div id="variant-picker-content">
          ${this.renderCloseButton()}
          <div style="height: 0.5rem"></div>
          <slot name="variant-picker"></slot>
          <div style="height: 1rem"></div>
        </div>
      </div>

      <div
        class="sticky-add-to-cart-mobile__inner"
        id="bar-content"
        @cart:updated=${this.handleCartUpdated}
      >
        <slot></slot>
        ${this.noVariants || this.showPicker ? p`<slot name="add-to-cart"></slot>` : p`<slot name="select-options" @click=${this.handleClickSelectOptions}></slot>`}
      </div>

      <!-- Workaround to prevent WAAPI commitStyle errors -->
      <div class="invisible absolute">
        <slot name="add-to-cart"></slot>
      </div>
    `
    }
    renderCloseButton() {
        return p`
      <button class="close-button" @click=${this.handleCloseClick}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M5 19L19 5" stroke="currentColor" stroke-width="2" />
          <path d="M5 5L19 19" stroke="currentColor" stroke-width="2" />
        </svg>
      </button>
    `
    }
}
;
Qt.styles = [x.themeCSS, tt`
      .close-button {
        position: absolute;
        top: 0;
        right: -0.5rem;
        background: none;
        border: none;
        padding: 0.5rem;
        cursor: pointer;
        color: currentColor;
        z-index: 10;
      }

      #variant-picker {
        display: none;
        overflow: hidden;
      }

      #variant-picker-content {
        position: relative;
      }
    `],
ni([u({
    type: Boolean,
    attribute: "no-variants"
})], Qt.prototype, "noVariants", 2),
ni([b()], Qt.prototype, "showPicker", 2),
ni([C("#variant-picker")], Qt.prototype, "$variantPicker", 2),
ni([C("#variant-picker-content")], Qt.prototype, "$variantPickerContent", 2),
Qt = ni([d("sticky-add-to-cart-mobile")], Qt);
var Xd = Object.defineProperty
  , Gd = Object.getOwnPropertyDescriptor
  , oi = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Gd(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Xd(t, i, r),
    r
}
;
let ge = class extends x {
    constructor() {
        super(!0),
        this.shouldShow = !1,
        this.forceHidden = !1,
        new os(this, () => this.$addToCart,this.handleAddToCartIntersection.bind(this),{
            rootMargin: "-20% 0px 0px 0px"
        }),
        new ss(this,this, ([e]) => {
            e != null && e.borderBoxSize[0] && (this.spacerDiv.style.height = `${e.borderBoxSize[0].blockSize}px`),
            this.visible || this.animateVisibility(!0)
        }
        ),
        this.spacerDiv = this.createSpacerDiv()
    }
    get visible() {
        return this.shouldShow && !this.forceHidden
    }
    createSpacerDiv() {
        const e = document.createElement("div");
        return e.className = "sticky-add-to-cart-spacer",
        e
    }
    connectedCallback() {
        super.connectedCallback(),
        document.body.appendChild(this.spacerDiv)
    }
    disconnectedCallback() {
        super.disconnectedCallback(),
        this.spacerDiv.remove()
    }
    handleAddToCartIntersection(e) {
        this.shouldShow = !e.isIntersecting && e.boundingClientRect.bottom < window.innerHeight * .5
    }
    updated(e) {
        super.updated(e),
        Wi(e, ["shouldShow", "forceHidden"]) && (this.spacerDiv.classList.toggle("is-active", this.visible),
        this.toggleAttribute("visible", this.visible),
        this.animateVisibility(e.get("shouldShow") === void 0 && e.get("forceHidden") === void 0))
    }
    animateVisibility(e) {
        var s;
        (s = this.animation) == null || s.stop();
        const t = this.visible ? "0%" : vn(1024) ? "-100%" : "100%"
          , i = [[this, {
            transform: `translateY(${t})`,
            opacity: this.visible ? 1 : 0,
            visibility: this.visible ? "visible" : "hidden"
        }, {
            duration: this.visible ? .3 : .2,
            ease: this.visible ? "power2.out" : "power1.in"
        }]];
        e ? ve(i) : this.animation = A(i)
    }
    handleStickyHeaderUpdate(e) {
        const {state: t, expanded: i} = e.detail;
        if (i) {
            this.forceHidden = !0;
            return
        }
        this.forceHidden = !1,
        t === "sticky" ? w(document.documentElement, {
            "--sticky-add-to-cart-top": "var(--header-height-sticky, 0px)"
        }) : w(document.documentElement, {
            "--sticky-add-to-cart-top": "0px"
        })
    }
    render() {
        return p`<slot></slot>`
    }
    beforeMorphDOM(e, t) {
        return t(this, e, {
            childrenOnly: !0
        }),
        !1
    }
}
;
oi([b()], ge.prototype, "shouldShow", 2),
oi([b()], ge.prototype, "forceHidden", 2),
oi([ii("target", {
    type: HTMLElement,
    required: !1
})], ge.prototype, "$addToCart", 2),
oi([l("sticky-header:update", document)], ge.prototype, "handleStickyHeaderUpdate", 1),
ge = oi([d("sticky-add-to-cart")], ge);
var Qd = Object.defineProperty
  , Zd = Object.getOwnPropertyDescriptor
  , oe = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? Zd(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = (s ? o(t, i, r) : o(r)) || r);
    return s && r && Qd(t, i, r),
    r
}
;
function Jd(e) {
    class t extends e {
        constructor(...s) {
            super(...s),
            this.mode = "always",
            this.state = "idle",
            this.transition = !1,
            this.expanded = !1,
            this.lastScrollY = 0,
            this.distance = 0,
            this.threshold = 16,
            this.cachedScrollY = 0,
            this.cachedOffsetTop = 0,
            this.cachedClientHeight = 0,
            this.positionAnchor = document.createElement("div"),
            this.positionAnchor.setAttribute("aria-hidden", "true"),
            Xi( () => {
                new ss(this,[this, document.body],k( () => this.updateCachedDimensions(), 500))
            }
            )
        }
        get cachedOffsetBottom() {
            return this.cachedOffsetTop + this.cachedClientHeight
        }
        connectedCallback() {
            super.connectedCallback(),
            this.insertAdjacentElement("beforebegin", this.positionAnchor),
            this.updateCachedDimensions(),
            this.handleWindowScroll(),
            setTimeout( () => {
                this.transition = !0
            }
            )
        }
        disconnectedCallback() {
            super.disconnectedCallback(),
            this.positionAnchor.remove()
        }
        updated(s) {
            super.updated(s),
            Wi(s, ["state", "expanded"]) && m(this, "sticky-header:update", {
                state: this.state,
                expanded: this.expanded
            }, {
                bubbles: !0
            })
        }
        updateCachedDimensions() {
            this.cachedOffsetTop = this.positionAnchor.offsetTop,
            this.cachedClientHeight = this.clientHeight
        }
        shouldBeSticky() {
            return this.cachedScrollY >= this.cachedOffsetTop
        }
        shouldBeIdle() {
            return !this.shouldBeSticky()
        }
        handleWindowScroll() {
            Et.read( () => {
                this.cachedScrollY = window.scrollY
            }
            ),
            Et.render( () => {
                const s = this.cachedScrollY > this.lastScrollY ? "down" : "up";
                (s === "down" && this.distance < 0 || s == "up" && this.distance > 0) && (this.distance = 0),
                this.distance += this.cachedScrollY - this.lastScrollY,
                this.mode === "always" ? this.shouldBeIdle() ? (this.expanded = !1,
                this.state = "idle") : this.shouldBeSticky() && (this.state = "sticky") : this.mode === "scroll-up" && (this.shouldBeIdle() ? (this.state = "idle",
                this.expanded = !1) : s !== this.direction && Math.abs(this.distance) > this.threshold ? (this.direction = s,
                this.handleScrollUpState()) : this.lastScrollY <= this.cachedOffsetBottom && this.cachedScrollY > this.cachedOffsetBottom && this.handleScrollUpState()),
                this.lastScrollY = this.cachedScrollY
            }
            )
        }
        handleScrollUpState() {
            this.direction === "down" && this.cachedScrollY > this.cachedOffsetBottom && this.state === "sticky" ? this.state = "hidden" : this.direction === "up" && this.cachedScrollY > this.cachedOffsetBottom && this.state !== "sticky" && this.animateStickyIn()
        }
        animateStickyIn() {
            this.transition = !1,
            this.state = "hidden",
            setTimeout( () => {
                this.transition = !0,
                this.state = "sticky"
            }
            )
        }
        toggleExpanded() {
            this.expanded = !this.expanded
        }
    }
    return oe([u({
        type: String
    })], t.prototype, "mode", 2),
    oe([u({
        type: String,
        reflect: !0
    })], t.prototype, "state", 2),
    oe([u({
        type: Boolean,
        reflect: !0
    })], t.prototype, "transition", 2),
    oe([u({
        type: Boolean,
        reflect: !0
    })], t.prototype, "expanded", 2),
    oe([l("scroll", window, {
        passive: !0
    })], t.prototype, "handleWindowScroll", 1),
    oe([l("sticky-header:toggle-expanded")], t.prototype, "toggleExpanded", 1),
    t
}
var tu = Object.getOwnPropertyDescriptor
  , eu = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? tu(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let nn = class extends Jd(N) {
    constructor() {
        var e;
        super(),
        this.xlBreakpoint = window.matchMedia("(min-width: 1024px)"),
        (e = window.Shopify) != null && e.designMode && this.initShopifyDesignMode()
    }
    shouldBeSticky() {
        return this.cachedScrollY >= this.cachedOffsetTop + (this.xlBreakpoint.matches ? 48 : 0)
    }
    initShopifyDesignMode() {
        this.addEventListener("shopify:block:select", t => {
            !ct(t.target) || !t.target.closest("mega-menu") || this.state === "sticky" && (e.cancel(),
            this.expanded = !0)
        }
        ),
        this.addEventListener("shopify:block:deselect", t => {
            ct(t.target) && t.target.closest("mega-menu") && e()
        }
        );
        const e = k( () => this.expanded = !1, 100)
    }
}
;
nn = eu([d("sticky-header")], nn);
class di {
    constructor(t, i) {
        this.host = t,
        this.svg = gn(i),
        t.appendChild(this.svg)
    }
    reset() {
        const t = this.svg.querySelector("path");
        t && w(t, {
            strokeDasharray: "",
            strokeDashoffset: "",
            visibility: "hidden"
        })
    }
    computeWidthScale() {
        const t = this.svg.viewBox.baseVal.width || 1;
        return this.svg.clientWidth / t
    }
}
const on = {
    underline: class extends di {
        constructor(e) {
            super(e, `
        <svg
          aria-hidden="true"
          focusable="false"
          class="text-highlight__shape text-highlight__underline"
          viewBox="0 0 95 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path
            d="M8 10.6375C25.5 7.5 55.9796 6.76148 87 10.6375"
            vector-effect="non-scaling-stroke"
            pathLength="1"
            stroke="currentColor"
            stroke-width="clamp(3px, 0.125em, 6px)"
            stroke-linecap="round"
            style="visibility: hidden"
          />
        </svg>
      `)
        }
        play() {
            const e = this.svg.querySelector("path");
            if (!e)
                return;
            const t = this.computeWidthScale();
            w(e, {
                strokeDasharray: `${t}`,
                visibility: ""
            }),
            E(e, {
                strokeDashoffset: [t * .99, 0]
            }, {
                duration: 1,
                delay: .3,
                ease: "power4.inOut",
                clearProps: ["strokeDasharray", "strokeDashoffset"]
            })
        }
    }
    ,
    scribble: class extends di {
        constructor(e) {
            super(e, `
        <svg
          aria-hidden="true"
          focusable="false"
          class="text-highlight__shape text-highlight__scribble"
          viewBox="0 0 452 92"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path
            d="M30 71.9032C68 49.2626 88.8961 28.0128 100 38.2626C106.5 44.2626 93.9423 52.6219 101.5 63.2626C110.682 76.19 138.08 47.9699 153 49.2626C162.5 50.0857 156.5 67.2626 168.5 67.7626C180.5 68.2626 206 35.7626 416 45.2626"
            vector-effect="non-scaling-stroke"
            pathLength="1"
            stroke="currentColor"
            stroke-width="clamp(2.5px, 0.1em, 5px)"
            stroke-linecap="round"
            style="visibility: hidden"
          />
        </svg>
      `)
        }
        play() {
            const e = this.svg.querySelector("path");
            if (!e)
                return;
            const t = this.computeWidthScale();
            w(e, {
                strokeDasharray: `${t}`,
                visibility: ""
            }),
            E(e, {
                strokeDashoffset: [t * .99, 0]
            }, {
                duration: 1,
                delay: .3,
                ease: "power2.inOut",
                clearProps: ["strokeDasharray", "strokeDashoffset"]
            })
        }
    }
    ,
    circle: class extends di {
        constructor(e) {
            super(e, `
        <svg
          aria-hidden="true"
          focusable="false"
          class="text-highlight__shape text-highlight__circle"
          viewBox="0 0 130 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path
            d="M58.7052 11.1462C41.6463 11.1875 7.22824 14.7397 6.02729 28.6182C4.82635 42.4967 43.5569 45.3054 63.0723 44.975C81.6779 44.6445 119.299 40.5388 120.936 26.7595C122.983 9.53526 75.3548 0.861204 38.7804 6.93304"
            pathLength="1"
            stroke="currentColor"
            stroke-width="calc(3px - 0.02em)"
            style="visibility: hidden"
          />
        </svg>
      `)
        }
        play() {
            const e = this.svg.querySelector("path");
            if (!e)
                return;
            const t = 1;
            w(e, {
                strokeDasharray: `${t}`,
                visibility: ""
            }),
            E(e, {
                strokeDashoffset: [t, 0]
            }, {
                duration: 1,
                delay: .3,
                ease: "power2.inOut",
                clearProps: ["strokeDasharray", "strokeDashoffset"]
            })
        }
    }
    ,
    highlighter: class extends di {
        constructor(e) {
            super(e, `
        <svg
          aria-hidden="true"
          focusable="false"
          class="text-highlight__shape text-highlight__marker"
          preserveAspectRatio="none"
          viewBox="0 0 116 39"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6.5 21C29.5 18 82.5 18.5 111 21" stroke="currentColor" stroke-width="24" pathLength="1" style="visibility: hidden"/>
        </svg>
      `)
        }
        play() {
            const e = this.svg.querySelector("path");
            e && (w(e, {
                strokeDasharray: "1",
                visibility: ""
            }),
            E(e, {
                strokeDashoffset: [1, 0]
            }, {
                duration: 1,
                delay: .3,
                ease: "power4.inOut",
                clearProps: ["strokeDasharray", "strokeDashoffset"]
            }))
        }
    }
};
var iu = Object.getOwnPropertyDescriptor
  , su = (e, t, i, s) => {
    for (var r = s > 1 ? void 0 : s ? iu(t, i) : t, n = e.length - 1, o; n >= 0; n--)
        (o = e[n]) && (r = o(r) || r);
    return r
}
;
let an = class extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        document.fonts.ready.then( () => {
            this.initOnce(),
            this.reset()
        }
        )
    }
    disconnectedCallback() {
        var e;
        (e = this.clearInView) == null || e.call(this)
    }
    play() {
        var e, t;
        (e = this.clearInView) == null || e.call(this),
        (t = this.effectInstance) == null || t.play()
    }
    reset() {
        var e, t;
        (e = this.effectInstance) == null || e.reset(),
        (t = this.clearInView) == null || t.call(this),
        this.clearInView = Bt(this, () => this.play())
    }
    initOnce() {
        if (this.effectInstance)
            return;
        const e = (this.dataset.effect ?? "underline").toLowerCase()
          , t = on[e] || on.underline;
        this.effectInstance = new t(this)
    }
}
;
an = su([d("text-highlight", {
    extends: "em"
})], an);
const ru = {
    smooth: "cubic-bezier(.49,0,.51,1)",
    ease: "cubic-bezier(0.25, 0.1, 0.25, 1)",
    "power1.in": ["linear(0.000, 0.001 3.3%, 0.004 6.7%, 0.01 10%, 0.018 13.3%, 0.028 16.7%, 0.04 20%, 0.055 23.3%, 0.071 26.7%, 0.09 30%, 0.111 33.3%, 0.134 36.7%, 0.16 40%, 0.187 43.3%, 0.217 46.7%, 0.249 50%, 0.283 53.3%, 0.32 56.7%, 0.359 60%, 0.399 63.3%, 0.442 66.7%, 0.488 70%, 0.536 73.3%, 0.586 76.7%, 0.638 80%, 0.693 83.3%, 0.75 86.7%, 0.81 90%, 0.872 93.3%, 0.936 96.7%, 1 100%)", "cubic-bezier(0.514, 0, 0.903, 0.823)"],
    "power1.out": ["linear(0.000, 0.065 3.3%, 0.13 6.7%, 0.191 10%, 0.251 13.3%, 0.307 16.7%, 0.362 20%, 0.414 23.3%, 0.464 26.7%, 0.511 30%, 0.557 33.3%, 0.6 36.7%, 0.64 40%, 0.679 43.3%, 0.715 46.7%, 0.75 50%, 0.782 53.3%, 0.812 56.7%, 0.839 60%, 0.865 63.3%, 0.888 66.7%, 0.909 70%, 0.928 73.3%, 0.945 76.7%, 0.959 80%, 0.972 83.3%, 0.982 86.7%, 0.99 90%, 0.995 93.3%, 0.999 96.7%, 1 100%)", "cubic-bezier(0.095, 0.175, 0.488, 1)"],
    "power1.inOut": ["linear(0.000, 0.002 3.3%, 0.009 6.7%, 0.02 10%, 0.036 13.3%, 0.056 16.7%, 0.08 20%, 0.109 23.3%, 0.142 26.7%, 0.18 30%, 0.222 33.3%, 0.269 36.7%, 0.321 40%, 0.377 43.3%, 0.439 46.7%, 0.503 50%, 0.563 53.3%, 0.623 56.7%, 0.679 60%, 0.731 63.3%, 0.779 66.7%, 0.822 70%, 0.86 73.3%, 0.893 76.7%, 0.922 80%, 0.946 83.3%, 0.966 86.7%, 0.981 90%, 0.992 93.3%, 0.998 96.7%, 1 100%)", "cubic-bezier(0.465, 0.036, 0.532, 0.963)"],
    "power2.in": ["linear(0.000, 0 3.3%, 0.001 6.7%, 0.002 10%, 0.004 13.3%, 0.006 16.7%, 0.01 20%, 0.014 23.3%, 0.019 26.7%, 0.027 30%, 0.036 33.3%, 0.047 36.7%, 0.061 40%, 0.079 43.3%, 0.1 46.7%, 0.126 50%, 0.153 53.3%, 0.183 56.7%, 0.214 60%, 0.251 63.3%, 0.293 66.7%, 0.341 70%, 0.394 73.3%, 0.453 76.7%, 0.516 80%, 0.584 83.3%, 0.656 86.7%, 0.734 90%, 0.817 93.3%, 0.905 96.7%, 1 100%)", "cubic-bezier(0.6, 0, 0.768, 0.354)"],
    "power2.out": ["linear(0.000, 0.097 3.3%, 0.187 6.7%, 0.27 10%, 0.346 13.3%, 0.418 16.7%, 0.484 20%, 0.545 23.3%, 0.601 26.7%, 0.653 30%, 0.7 33.3%, 0.743 36.7%, 0.781 40%, 0.816 43.3%, 0.846 46.7%, 0.873 50%, 0.896 53.3%, 0.917 56.7%, 0.935 60%, 0.95 63.3%, 0.962 66.7%, 0.973 70%, 0.981 73.3%, 0.988 76.7%, 0.992 80%, 0.996 83.3%, 0.998 86.7%, 0.999 90%, 1 93.3%, 1 96.7%, 1 100%)", "cubic-bezier(0.283, 0.874, 0.594, 1)"],
    "power2.inOut": ["linear(0.000, 0 3.3%, 0.002 6.7%, 0.005 10%, 0.011 13.3%, 0.019 16.7%, 0.032 20%, 0.049 23.3%, 0.074 26.7%, 0.105 30%, 0.144 33.3%, 0.193 36.7%, 0.254 40%, 0.328 43.3%, 0.412 46.7%, 0.501 50%, 0.588 53.3%, 0.668 56.7%, 0.739 60%, 0.799 63.3%, 0.85 66.7%, 0.891 70%, 0.922 73.3%, 0.947 76.7%, 0.966 80%, 0.979 83.3%, 0.989 86.7%, 0.994 90%, 0.998 93.3%, 1 96.7%, 1 100%)", "cubic-bezier(0.645, 0, 0.357, 1)"],
    "power3.in": ["linear(0.000, 0 3.3%, 0 6.7%, 0.001 10%, 0.001 13.3%, 0.002 16.7%, 0.004 20%, 0.005 23.3%, 0.008 26.7%, 0.01 30%, 0.014 33.3%, 0.019 36.7%, 0.025 40%, 0.033 43.3%, 0.045 46.7%, 0.06 50%, 0.08 53.3%, 0.105 56.7%, 0.132 60%, 0.159 63.3%, 0.193 66.7%, 0.236 70%, 0.286 73.3%, 0.345 76.7%, 0.412 80%, 0.487 83.3%, 0.57 86.7%, 0.661 90%, 0.762 93.3%, 0.875 96.7%, 1 100%)", "cubic-bezier(0.66, 0, 0.779, 0.188)"],
    "power3.out": ["linear(0.000, 0.12 3.3%, 0.236 6.7%, 0.342 10%, 0.437 13.3%, 0.52 16.7%, 0.592 20%, 0.656 23.3%, 0.711 26.7%, 0.759 30%, 0.801 33.3%, 0.838 36.7%, 0.87 40%, 0.897 43.3%, 0.92 46.7%, 0.939 50%, 0.954 53.3%, 0.966 56.7%, 0.975 60%, 0.982 63.3%, 0.987 66.7%, 0.991 70%, 0.994 73.3%, 0.996 76.7%, 0.998 80%, 0.999 83.3%, 0.999 86.7%, 1 90%, 1 93.3%, 1 96.7%, 1 100%)", "cubic-bezier(0.255, 0.946, 0.424, 1)"],
    "power3.inOut": ["linear(0.000, 0 3.3%, 0.001 6.7%, 0.002 10%, 0.004 13.3%, 0.007 16.7%, 0.013 20%, 0.024 23.3%, 0.041 26.7%, 0.066 30%, 0.098 33.3%, 0.143 36.7%, 0.206 40%, 0.287 43.3%, 0.384 46.7%, 0.497 50%, 0.613 53.3%, 0.715 56.7%, 0.796 60%, 0.855 63.3%, 0.896 66.7%, 0.933 70%, 0.96 73.3%, 0.976 76.7%, 0.985 80%, 0.991 83.3%, 0.995 86.7%, 0.998 90%, 0.999 93.3%, 1 96.7%, 1 100%)", "cubic-bezier(0.752, 0, 0.25, 1)"],
    "power4.in": ["linear(0.000, 0 3.3%, 0 6.7%, 0 10%, 0.001 13.3%, 0.001 16.7%, 0.001 20%, 0.002 23.3%, 0.003 26.7%, 0.004 30%, 0.006 33.3%, 0.008 36.7%, 0.012 40%, 0.016 43.3%, 0.022 46.7%, 0.031 50%, 0.043 53.3%, 0.059 56.7%, 0.078 60%, 0.1 63.3%, 0.128 66.7%, 0.165 70%, 0.21 73.3%, 0.264 76.7%, 0.328 80%, 0.403 83.3%, 0.489 86.7%, 0.59 90%, 0.706 93.3%, 0.841 96.7%, 1 100%)", "cubic-bezier(0.687, 0, 0.804, 0.075)"],
    "power4.out": ["linear(0.000, 0.145 3.3%, 0.28 6.7%, 0.401 10%, 0.508 13.3%, 0.6 16.7%, 0.677 20%, 0.74 23.3%, 0.791 26.7%, 0.833 30%, 0.867 33.3%, 0.898 36.7%, 0.924 40%, 0.944 43.3%, 0.959 46.7%, 0.97 50%, 0.978 53.3%, 0.984 56.7%, 0.988 60%, 0.991 63.3%, 0.993 66.7%, 0.995 70%, 0.997 73.3%, 0.998 76.7%, 0.998 80%, 0.999 83.3%, 0.999 86.7%, 1 90%, 1 93.3%, 1 96.7%, 1 100%)", "cubic-bezier(0.217, 1, 0.362, 1)"],
    "power4.inOut": ["linear(0.000, 0 3.3%, 0 6.7%, 0.001 10%, 0.002 13.3%, 0.004 16.7%, 0.007 20%, 0.012 23.3%, 0.02 26.7%, 0.036 30%, 0.066 33.3%, 0.105 36.7%, 0.158 40%, 0.242 43.3%, 0.363 46.7%, 0.511 50%, 0.655 53.3%, 0.764 56.7%, 0.839 60%, 0.891 63.3%, 0.934 66.7%, 0.961 70%, 0.977 73.3%, 0.986 76.7%, 0.992 80%, 0.995 83.3%, 0.997 86.7%, 0.999 90%, 0.999 93.3%, 1 96.7%, 1 100%)", "cubic-bezier(0.825, 0, 0.17, 1)"]
};
Object.assign(Mo, Object.fromEntries(Object.entries(ru).map( ([e,t]) => {
    if (Array.isArray(t)) {
        const [i,s] = t;
        return [e, To() && !Ks() ? i : s]
    } else
        return [e, t]
}
)));
function Vi(e) {
    const t = e.options[e.selectedIndex]
      , i = t && t.textContent.trim() !== "";
    e.toggleAttribute("filled", i)
}
document.addEventListener("change", e => {
    e.target instanceof HTMLSelectElement && Vi(e.target)
}
),
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("select").forEach(Vi)
}
);
const nu = new MutationObserver(e => {
    e.forEach(t => {
        t.addedNodes.forEach(i => {
            i instanceof HTMLSelectElement ? Vi(i) : i instanceof HTMLElement && [...i.getElementsByTagName("select")].forEach(Vi)
        }
        )
    }
    )
}
);
nu.observe(document.body, {
    childList: !0,
    subtree: !0
}),
document.addEventListener("click", e => {
    const t = e.target;
    if (!(t instanceof Element))
        return;
    const i = t.closest("a.skip-to-content");
    if (!i)
        return;
    const s = i.getAttribute("href");
    if (!s)
        return;
    let r;
    try {
        r = document.querySelector(s)
    } catch {
        return
    }
    r && (e.preventDefault(),
    r.focus())
}
),
window.addEventListener("resize", k(window.setScrollbarWidth, 100), {
    passive: !0
});
//# sourceMappingURL=/cdn/shop/t/78/assets/main.js.map?v=43248386564050941511783651786
/* Mobile header: Shopify Inbox launcher + open handler */
(() => {
  const MOBILE_MEDIA = window.matchMedia('(max-width: 639px)');

  function getShopifyChat() {
    return document.querySelector('shopify-chat');
  }

  function hideMobileInboxLauncher() {
    const chat = getShopifyChat();

    if (!chat || !chat.shadowRoot) return false;

    const launcher = chat.shadowRoot.querySelector('[part="activator"]');

    if (!launcher) return false;

    if (MOBILE_MEDIA.matches) {
      launcher.style.setProperty('display', 'none', 'important');
    } else {
      launcher.style.removeProperty('display');
    }

    return true;
  }

  function openShopifyInbox() {
    const chat = getShopifyChat();

    if (chat) {
      chat.setAttribute('open', '');
      return;
    }

    let attempts = 0;

    const timer = setInterval(() => {
      const delayedChat = getShopifyChat();

      if (delayedChat) {
        delayedChat.setAttribute('open', '');
        clearInterval(timer);
      }

      attempts += 1;

      if (attempts >= 20) {
        clearInterval(timer);
      }
    }, 150);
  }

  window.openShopifyInbox = openShopifyInbox;

  function initShopifyInboxLauncher() {
    if (hideMobileInboxLauncher()) return;

    let attempts = 0;

    const timer = setInterval(() => {
      if (hideMobileInboxLauncher()) {
        clearInterval(timer);
      }

      attempts += 1;

      if (attempts >= 40) {
        clearInterval(timer);
      }
    }, 250);
  }

  document.addEventListener('DOMContentLoaded', initShopifyInboxLauncher);
  window.addEventListener('load', initShopifyInboxLauncher);

  MOBILE_MEDIA.addEventListener?.('change', () => {
    setTimeout(hideMobileInboxLauncher, 100);
  });
})();
/* Mobile menu: close menu and open Shopify Inbox */
window.openMobileSupport = function () {
  const mobileMenuTrigger = document.querySelector(
    '[data-modal="MobileMenu"]'
  );

  if (mobileMenuTrigger) {
    mobileMenuTrigger.click();
  }

  setTimeout(() => {
    if (window.openShopifyInbox) {
      window.openShopifyInbox();
    }
  }, 300);
};